var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMantenimientoSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 838.067,
    height: 769.569,
    viewBox: "0 0 838.067 769.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b75b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00225e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Under_construction-amico",
    "data-name": "Under construction-amico",
    transform: "translate(-14.41 -36.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    transform: "translate(14.41 347.259)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-2-2",
    "data-name": "freepik--floor--inject-2",
    cx: 419.034,
    cy: 229.375,
    rx: 419.034,
    ry: 229.375,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2",
    transform: "translate(48.905 382.108)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-2",
    d: "M111.135,392.483c9,5.069,9.089,13.447.2,18.711s-23.389,5.336-32.407.338-9.089-13.429-.2-18.765S102.153,387.432,111.135,392.483Z",
    transform: "translate(-3.978 -107.797)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-2",
    "data-name": "freepik--shadow--inject-2",
    d: "M285.062,376.6l-87.154-49.8a5.656,5.656,0,0,0-5.123,0l-.907.516c-1.423.818-1.405,2.134,0,2.917l29.686,16.613-30.415,17.609-29.33-16.933a5.656,5.656,0,0,0-5.123,0l-.907.516a1.565,1.565,0,0,0,0,2.97l88.577,51.136.96-1.138.48.267,34.968-20.152.267.16.516-.6.747-.427-.267-.16Z",
    transform: "translate(60.346 -156.497)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-3",
    "data-name": "freepik--shadow--inject-2",
    d: "M196.213,460.246l42.866-24.741a1.779,1.779,0,0,0,0-3.326l-42.866-24.741a6.439,6.439,0,0,0-5.763,0L147.6,432.179a1.779,1.779,0,0,0,0,3.326l42.848,24.741a6.332,6.332,0,0,0,5.763,0Z",
    transform: "translate(53.912 -93.759)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-4",
    "data-name": "freepik--shadow--inject-2",
    d: "M369.473,444.814l42.848-24.759a1.779,1.779,0,0,0,0-3.326l-42.848-24.741a6.439,6.439,0,0,0-5.763,0l-42.848,24.741a1.779,1.779,0,0,0,0,3.326l42.848,24.759A6.438,6.438,0,0,0,369.473,444.814Z",
    transform: "translate(188.822 -105.789)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-5",
    "data-name": "freepik--shadow--inject-2",
    d: "M265.933,479.882l-50.372-29.188a1.263,1.263,0,0,1,0-2.4L336.19,378.606a4.642,4.642,0,0,1,4.162,0l50.46,29.134a1.263,1.263,0,0,1,0,2.4L270.024,479.882a4.642,4.642,0,0,1-4.091,0Z",
    transform: "translate(107.044 -116.063)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-6",
    "data-name": "freepik--shadow--inject-2",
    d: "M428.842,443.261l-106.47-61.47c-8.5-4.909-8.5-12.86,0-17.787L443.32,294.192c8.52-4.909,22.3-4.909,30.806,0l106.47,61.47c8.52,4.927,8.52,12.877,0,17.787L459.648,443.261C451.182,448.17,437.344,448.17,428.842,443.261Z",
    transform: "translate(185.926 -184.276)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-7",
    "data-name": "freepik--shadow--inject-2",
    d: "M74.9,500.618l-39.5-22.8a2.348,2.348,0,0,1,0-4.447L453.915,231.7a8.52,8.52,0,0,1,7.7,0l39.5,22.8a2.348,2.348,0,0,1,0,4.447L82.6,500.618a8.52,8.52,0,0,1-7.7,0Z",
    transform: "translate(-33.804 -230.783)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2-8",
    "data-name": "freepik--shadow--inject-2",
    d: "M165.238,363.906c10.565,5.959,10.672,15.777.231,21.949s-27.445,6.368-38.01.409-10.672-15.777-.231-21.949S154.673,357.93,165.238,363.906Z",
    transform: "translate(32.897 -130.516)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2",
    transform: "translate(78.086 75.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-2-2",
    "data-name": "freepik--gears--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M179.137,70.467h0a1.209,1.209,0,0,0-1.316.213l-2.632,1.992-.5,1.672a3.184,3.184,0,0,0,.943,3.006,13.252,13.252,0,0,1,1.352,1.458,1.885,1.885,0,0,0,2.615.391l6.136-4.642a1.227,1.227,0,0,1,1.281-.213Zm-8.306,24.172c-1.245-5.123-4.731-7.506-9-6.866a12.2,12.2,0,0,1,1.085,2.988c1.974,8.128-2.472,20.152-9.907,26.84a15.794,15.794,0,0,1-7.933,4.215c2.935,5.336,9.48,5.443,15.9-.32C168.359,114.809,172.788,102.785,170.831,94.639Zm-2.188-35.182h0a1.779,1.779,0,0,0-.445-.107l-4.891-.783a2.615,2.615,0,0,0-2.65,1.458l-3.984,8.893a3.558,3.558,0,0,1-.925,1.209h0a3.772,3.772,0,0,1-.729.587L156.8,75.34a1.654,1.654,0,0,0,2.348.889,20.827,20.827,0,0,1,2.917-1.174,5.336,5.336,0,0,0,1.654-1.014,4.055,4.055,0,0,0,.96-1.227l3.949-8.893a2.668,2.668,0,0,1,2.65-1.459l4.909.765a1.778,1.778,0,0,1,.5.16Zm-8.057,84.7a1.334,1.334,0,0,1-.516-.694l-1.992-5.336a1.636,1.636,0,0,0-2.348-.889,20.827,20.827,0,0,1-2.917,1.174,3.362,3.362,0,0,0-.907.462l.267.676a1.405,1.405,0,0,0,.676.8h0ZM146.054,65.344a1.067,1.067,0,0,0-.534-.107,1.316,1.316,0,0,0-.854.409L137.784,71.8a1.9,1.9,0,0,0-.249.285,2.01,2.01,0,0,0-.178.231,5.337,5.337,0,0,0-.569,1.192,1.672,1.672,0,0,1,0,.285h0a3.4,3.4,0,0,0-.107,1.174l.889,6.866a5.6,5.6,0,0,1-.907,3.4c-1.1,1.494-2.117,3.059-3.077,4.66a3.557,3.557,0,0,1-1.512,1.352,3.717,3.717,0,0,1-.623.231h-.285a3.557,3.557,0,0,1-.427,0h-5.158l-.338.107h0l-.374.178a4.2,4.2,0,0,0-.64.462,2.828,2.828,0,0,0-.676,1l-3.717,10.1a1.779,1.779,0,0,0,.889,2.312l5.336,2.632a2.312,2.312,0,0,1,.213,1.334c-.249,1.583-.427,3.184-.516,4.731a5.745,5.745,0,0,1-1.334,3.273h0l-6.03,6.581a1.477,1.477,0,0,0-.285.374h0a2.116,2.116,0,0,0-.231.445,3.7,3.7,0,0,0-.32,2.366l1.672,6.919a1.458,1.458,0,0,0,.623.907l7.879,3.877a1.263,1.263,0,0,1-.587-.889l-1.672-6.919a3.13,3.13,0,0,1,0-1.352,3.735,3.735,0,0,1,.889-1.885l5.941-6.243h0a6.048,6.048,0,0,0,1.37-3.291,39.667,39.667,0,0,1,.5-4.713,2.366,2.366,0,0,0-1.476-2.526l-3.86-1.334A1.779,1.779,0,0,1,127.7,107.5l3.717-10.1a2.668,2.668,0,0,1,.694-1,2.881,2.881,0,0,1,1.779-.818h4.678a2.934,2.934,0,0,0,1.334-.356,3.557,3.557,0,0,0,1.512-1.334c.943-1.6,1.974-3.166,3.059-4.66a5.532,5.532,0,0,0,.907-3.415l-.889-6.848a2.793,2.793,0,0,1,.107-1.192,4.02,4.02,0,0,1,1.067-1.974l6.866-6.172a1.263,1.263,0,0,1,1.423-.285Zm-6.012,73.8a3.219,3.219,0,0,0-.96-2.988,11.6,11.6,0,0,1-1.334-1.458,1.779,1.779,0,0,0-2.615-.409l-3.557,2.65-2.188,7.364a1.619,1.619,0,0,0,.783,1.921h0l7.968,3.842a1.583,1.583,0,0,1-.783-1.921Z",
    transform: "translate(2.179 -58.55)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M179.137,70.467h0a1.209,1.209,0,0,0-1.316.213l-2.632,1.992-.5,1.672a3.184,3.184,0,0,0,.943,3.006,13.252,13.252,0,0,1,1.352,1.458,1.885,1.885,0,0,0,2.615.391l6.136-4.642a1.227,1.227,0,0,1,1.281-.213Zm-8.306,24.172c-1.245-5.123-4.731-7.506-9-6.866a12.2,12.2,0,0,1,1.085,2.988c1.974,8.128-2.472,20.152-9.907,26.84a15.794,15.794,0,0,1-7.933,4.215c2.935,5.336,9.48,5.443,15.9-.32C168.359,114.809,172.788,102.785,170.831,94.639Zm-2.188-35.182h0a1.779,1.779,0,0,0-.445-.107l-4.891-.783a2.615,2.615,0,0,0-2.65,1.458l-3.984,8.893a3.558,3.558,0,0,1-.925,1.209h0a3.772,3.772,0,0,1-.729.587L156.8,75.34a1.654,1.654,0,0,0,2.348.889,20.827,20.827,0,0,1,2.917-1.174,5.336,5.336,0,0,0,1.654-1.014,4.055,4.055,0,0,0,.96-1.227l3.949-8.893a2.668,2.668,0,0,1,2.65-1.459l4.909.765a1.778,1.778,0,0,1,.5.16Zm-8.057,84.7a1.334,1.334,0,0,1-.516-.694l-1.992-5.336a1.636,1.636,0,0,0-2.348-.889,20.827,20.827,0,0,1-2.917,1.174,3.362,3.362,0,0,0-.907.462l.267.676a1.405,1.405,0,0,0,.676.8h0ZM146.054,65.344a1.067,1.067,0,0,0-.534-.107,1.316,1.316,0,0,0-.854.409L137.784,71.8a1.9,1.9,0,0,0-.249.285,2.01,2.01,0,0,0-.178.231,5.337,5.337,0,0,0-.569,1.192,1.672,1.672,0,0,1,0,.285h0a3.4,3.4,0,0,0-.107,1.174l.889,6.866a5.6,5.6,0,0,1-.907,3.4c-1.1,1.494-2.117,3.059-3.077,4.66a3.557,3.557,0,0,1-1.512,1.352,3.717,3.717,0,0,1-.623.231h-.285a3.557,3.557,0,0,1-.427,0h-5.158l-.338.107h0l-.374.178a4.2,4.2,0,0,0-.64.462,2.828,2.828,0,0,0-.676,1l-3.717,10.1a1.779,1.779,0,0,0,.889,2.312l5.336,2.632a2.312,2.312,0,0,1,.213,1.334c-.249,1.583-.427,3.184-.516,4.731a5.745,5.745,0,0,1-1.334,3.273h0l-6.03,6.581a1.477,1.477,0,0,0-.285.374h0a2.116,2.116,0,0,0-.231.445,3.7,3.7,0,0,0-.32,2.366l1.672,6.919a1.458,1.458,0,0,0,.623.907l7.879,3.877a1.263,1.263,0,0,1-.587-.889l-1.672-6.919a3.13,3.13,0,0,1,0-1.352,3.735,3.735,0,0,1,.889-1.885l5.941-6.243h0a6.048,6.048,0,0,0,1.37-3.291,39.667,39.667,0,0,1,.5-4.713,2.366,2.366,0,0,0-1.476-2.526l-3.86-1.334A1.779,1.779,0,0,1,127.7,107.5l3.717-10.1a2.668,2.668,0,0,1,.694-1,2.881,2.881,0,0,1,1.779-.818h4.678a2.934,2.934,0,0,0,1.334-.356,3.557,3.557,0,0,0,1.512-1.334c.943-1.6,1.974-3.166,3.059-4.66a5.532,5.532,0,0,0,.907-3.415l-.889-6.848a2.793,2.793,0,0,1,.107-1.192,4.02,4.02,0,0,1,1.067-1.974l6.866-6.172a1.263,1.263,0,0,1,1.423-.285Zm-6.012,73.8a3.219,3.219,0,0,0-.96-2.988,11.6,11.6,0,0,1-1.334-1.458,1.779,1.779,0,0,0-2.615-.409l-3.557,2.65-2.188,7.364a1.619,1.619,0,0,0,.783,1.921h0l7.968,3.842a1.583,1.583,0,0,1-.783-1.921Z",
    transform: "translate(2.179 -58.55)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M179.137,70.467h0a1.209,1.209,0,0,0-1.316.213l-2.632,1.992-.5,1.672a3.184,3.184,0,0,0,.943,3.006,13.252,13.252,0,0,1,1.352,1.458,1.885,1.885,0,0,0,2.615.391l6.136-4.642a1.227,1.227,0,0,1,1.281-.213Zm-8.306,24.172c-1.245-5.123-4.731-7.506-9-6.866a12.2,12.2,0,0,1,1.085,2.988c1.974,8.128-2.472,20.152-9.907,26.84a15.794,15.794,0,0,1-7.933,4.215c2.935,5.336,9.48,5.443,15.9-.32C168.359,114.809,172.788,102.785,170.831,94.639Zm-2.188-35.182h0a1.779,1.779,0,0,0-.445-.107l-4.891-.783a2.615,2.615,0,0,0-2.65,1.458l-3.984,8.893a3.558,3.558,0,0,1-.925,1.209h0a3.772,3.772,0,0,1-.729.587L156.8,75.34a1.654,1.654,0,0,0,2.348.889,20.827,20.827,0,0,1,2.917-1.174,5.336,5.336,0,0,0,1.654-1.014,4.055,4.055,0,0,0,.96-1.227l3.949-8.893a2.668,2.668,0,0,1,2.65-1.459l4.909.765a1.778,1.778,0,0,1,.5.16Zm-8.057,84.7a1.334,1.334,0,0,1-.516-.694l-1.992-5.336a1.636,1.636,0,0,0-2.348-.889,20.827,20.827,0,0,1-2.917,1.174,3.362,3.362,0,0,0-.907.462l.267.676a1.405,1.405,0,0,0,.676.8h0ZM146.054,65.344a1.067,1.067,0,0,0-.534-.107,1.316,1.316,0,0,0-.854.409L137.784,71.8a1.9,1.9,0,0,0-.249.285,2.01,2.01,0,0,0-.178.231,5.337,5.337,0,0,0-.569,1.192,1.672,1.672,0,0,1,0,.285h0a3.4,3.4,0,0,0-.107,1.174l.889,6.866a5.6,5.6,0,0,1-.907,3.4c-1.1,1.494-2.117,3.059-3.077,4.66a3.557,3.557,0,0,1-1.512,1.352,3.717,3.717,0,0,1-.623.231h-.285a3.557,3.557,0,0,1-.427,0h-5.158l-.338.107h0l-.374.178a4.2,4.2,0,0,0-.64.462,2.828,2.828,0,0,0-.676,1l-3.717,10.1a1.779,1.779,0,0,0,.889,2.312l5.336,2.632a2.312,2.312,0,0,1,.213,1.334c-.249,1.583-.427,3.184-.516,4.731a5.745,5.745,0,0,1-1.334,3.273h0l-6.03,6.581a1.477,1.477,0,0,0-.285.374h0a2.116,2.116,0,0,0-.231.445,3.7,3.7,0,0,0-.32,2.366l1.672,6.919a1.458,1.458,0,0,0,.623.907l7.879,3.877a1.263,1.263,0,0,1-.587-.889l-1.672-6.919a3.13,3.13,0,0,1,0-1.352,3.735,3.735,0,0,1,.889-1.885l5.941-6.243h0a6.048,6.048,0,0,0,1.37-3.291,39.667,39.667,0,0,1,.5-4.713,2.366,2.366,0,0,0-1.476-2.526l-3.86-1.334A1.779,1.779,0,0,1,127.7,107.5l3.717-10.1a2.668,2.668,0,0,1,.694-1,2.881,2.881,0,0,1,1.779-.818h4.678a2.934,2.934,0,0,0,1.334-.356,3.557,3.557,0,0,0,1.512-1.334c.943-1.6,1.974-3.166,3.059-4.66a5.532,5.532,0,0,0,.907-3.415l-.889-6.848a2.793,2.793,0,0,1,.107-1.192,4.02,4.02,0,0,1,1.067-1.974l6.866-6.172a1.263,1.263,0,0,1,1.423-.285Zm-6.012,73.8a3.219,3.219,0,0,0-.96-2.988,11.6,11.6,0,0,1-1.334-1.458,1.779,1.779,0,0,0-2.615-.409l-3.557,2.65-2.188,7.364a1.619,1.619,0,0,0,.783,1.921h0l7.968,3.842a1.583,1.583,0,0,1-.783-1.921Z",
    transform: "translate(2.179 -58.55)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M132.189,95.812l-5.941,6.243a3.735,3.735,0,0,0-.889,1.885l-7.879-3.877a4.055,4.055,0,0,1,.3-1.032,2.118,2.118,0,0,1,.231-.445h0a1.477,1.477,0,0,1,.285-.374l5.958-6.243Z",
    transform: "translate(2.17 -32.528)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M136.986,80.737a2.935,2.935,0,0,1-1.334.356h-4.678a2.881,2.881,0,0,0-1.779.818l-7.915-3.9a4.2,4.2,0,0,1,.64-.462l.374-.178h0l.338-.107h5.158a3.561,3.561,0,0,0,.427,0h.285l.6-.249h0Z",
    transform: "translate(5.129 -44.169)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M162.008,69.156a1.21,1.21,0,0,0-1.281.249l-6.136,4.642a1.868,1.868,0,0,1-2.615-.427,14.874,14.874,0,0,0-1.352-1.441,3.184,3.184,0,0,1-.943-3.006l.5-1.672,2.632-1.992a1.209,1.209,0,0,1,1.316-.213h0Z",
    transform: "translate(27.188 -53.381)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M159.775,63.326a1.779,1.779,0,0,0-.5-.16l-4.909-.765a2.668,2.668,0,0,0-2.65,1.459l-3.949,8.893a4.056,4.056,0,0,1-.96,1.227L139,70.139a3.557,3.557,0,0,0,.925-1.209l3.984-8.893a2.615,2.615,0,0,1,2.65-1.458l4.891.765a1.778,1.778,0,0,1,.534.16h0Z",
    transform: "translate(18.927 -58.543)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M145.561,66.313a1.263,1.263,0,0,0-1.423.285l-6.866,6.172a4.02,4.02,0,0,0-1.067,1.974l-7.915-3.877a1.672,1.672,0,0,0,0-.285,5.335,5.335,0,0,1,.569-1.192,2.008,2.008,0,0,1,.178-.231,1.9,1.9,0,0,1,.249-.285l6.883-6.154a1.316,1.316,0,0,1,.854-.409,1.067,1.067,0,0,1,.534.107Z",
    transform: "translate(10.587 -55.624)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M132.189,95.812l-5.941,6.243a3.735,3.735,0,0,0-.889,1.885l-7.879-3.877a4.055,4.055,0,0,1,.3-1.032,2.118,2.118,0,0,1,.231-.445h0a1.477,1.477,0,0,1,.285-.374l5.958-6.243Z",
    transform: "translate(2.17 -32.528)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M136.986,80.737a2.935,2.935,0,0,1-1.334.356h-4.678a2.881,2.881,0,0,0-1.779.818l-7.915-3.9a4.2,4.2,0,0,1,.64-.462l.374-.178h0l.338-.107h5.158a3.561,3.561,0,0,0,.427,0h.285l.6-.249h0Z",
    transform: "translate(5.129 -44.169)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M162.008,69.156a1.21,1.21,0,0,0-1.281.249l-6.136,4.642a1.868,1.868,0,0,1-2.615-.427,14.874,14.874,0,0,0-1.352-1.441,3.184,3.184,0,0,1-.943-3.006l.5-1.672,2.632-1.992a1.209,1.209,0,0,1,1.316-.213h0Z",
    transform: "translate(27.188 -53.381)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M159.775,63.326a1.779,1.779,0,0,0-.5-.16l-4.909-.765a2.668,2.668,0,0,0-2.65,1.459l-3.949,8.893a4.056,4.056,0,0,1-.96,1.227L139,70.139a3.557,3.557,0,0,0,.925-1.209l3.984-8.893a2.615,2.615,0,0,1,2.65-1.458l4.891.765a1.778,1.778,0,0,1,.534.16h0Z",
    transform: "translate(18.927 -58.543)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M145.561,66.313a1.263,1.263,0,0,0-1.423.285l-6.866,6.172a4.02,4.02,0,0,0-1.067,1.974l-7.915-3.877a1.672,1.672,0,0,0,0-.285,5.335,5.335,0,0,1,.569-1.192,2.008,2.008,0,0,1,.178-.231,1.9,1.9,0,0,1,.249-.285l6.883-6.154a1.316,1.316,0,0,1,.854-.409,1.067,1.067,0,0,1,.534.107Z",
    transform: "translate(10.587 -55.624)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M185.914,80.462l-1.6-6.83a1.156,1.156,0,0,0-1.974-.694L176.22,77.58a1.868,1.868,0,0,1-2.615-.427,14.873,14.873,0,0,0-1.352-1.441,3.184,3.184,0,0,1-.943-3.006L174,63.653a1.636,1.636,0,0,0-1.352-2.117l-4.891-.747a2.561,2.561,0,0,0-2.65,1.441l-3.984,8.893a4.838,4.838,0,0,1-2.6,2.259,21.735,21.735,0,0,0-2.917,1.174,1.654,1.654,0,0,1-2.348-.889l-1.992-5.336a1.209,1.209,0,0,0-2.081-.516l-6.866,6.172a4.109,4.109,0,0,0-1.174,3.166L142.034,84a5.336,5.336,0,0,1-.907,3.415c-1.085,1.494-2.117,3.059-3.059,4.66a3.753,3.753,0,0,1-2.846,1.779h-4.66a3.024,3.024,0,0,0-2.579,1.779l-3.717,10.1a1.779,1.779,0,0,0,1.138,2.4l3.86,1.37a2.294,2.294,0,0,1,1.458,2.49c-.249,1.6-.409,3.184-.5,4.731a5.763,5.763,0,0,1-1.352,3.291l-6.012,6.314a3.877,3.877,0,0,0-.872,3.237l1.672,6.9a1.138,1.138,0,0,0,1.957.711l6.136-4.642a1.779,1.779,0,0,1,2.6.409,11.63,11.63,0,0,0,1.352,1.441,3.166,3.166,0,0,1,.96,3.006l-2.757,9.16a1.619,1.619,0,0,0,1.334,2.117l4.909.765A2.615,2.615,0,0,0,142.8,148l3.966-8.893a4.714,4.714,0,0,1,2.615-2.241,27.516,27.516,0,0,0,2.9-1.174,1.636,1.636,0,0,1,2.348.889l1.992,5.336a1.209,1.209,0,0,0,2.1.516l6.848-6.172a4,4,0,0,0,1.174-3.148l-.889-6.866a5.443,5.443,0,0,1,.907-3.4c1.1-1.512,2.117-3.059,3.077-4.678a3.717,3.717,0,0,1,2.846-1.779h4.66a2.988,2.988,0,0,0,2.561-1.779l3.735-10.1a1.9,1.9,0,0,0-1.138-2.419l-3.877-1.352a2.33,2.33,0,0,1-1.458-2.508,44.072,44.072,0,0,0,.5-4.731,5.958,5.958,0,0,1,1.352-3.273l6.03-6.332A3.842,3.842,0,0,0,185.914,80.462ZM157.455,119.77c-7.435,6.688-15.065,5.5-17.022-2.65s2.472-20.152,9.907-26.84,15.047-5.514,17.022,2.632-2.455,20.17-9.889,26.858Z",
    transform: "translate(5.63 -56.824)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M185.914,80.462l-1.6-6.83a1.156,1.156,0,0,0-1.974-.694L176.22,77.58a1.868,1.868,0,0,1-2.615-.427,14.873,14.873,0,0,0-1.352-1.441,3.184,3.184,0,0,1-.943-3.006L174,63.653a1.636,1.636,0,0,0-1.352-2.117l-4.891-.747a2.561,2.561,0,0,0-2.65,1.441l-3.984,8.893a4.838,4.838,0,0,1-2.6,2.259,21.735,21.735,0,0,0-2.917,1.174,1.654,1.654,0,0,1-2.348-.889l-1.992-5.336a1.209,1.209,0,0,0-2.081-.516l-6.866,6.172a4.109,4.109,0,0,0-1.174,3.166L142.034,84a5.336,5.336,0,0,1-.907,3.415c-1.085,1.494-2.117,3.059-3.059,4.66a3.753,3.753,0,0,1-2.846,1.779h-4.66a3.024,3.024,0,0,0-2.579,1.779l-3.717,10.1a1.779,1.779,0,0,0,1.138,2.4l3.86,1.37a2.294,2.294,0,0,1,1.458,2.49c-.249,1.6-.409,3.184-.5,4.731a5.763,5.763,0,0,1-1.352,3.291l-6.012,6.314a3.877,3.877,0,0,0-.872,3.237l1.672,6.9a1.138,1.138,0,0,0,1.957.711l6.136-4.642a1.779,1.779,0,0,1,2.6.409,11.63,11.63,0,0,0,1.352,1.441,3.166,3.166,0,0,1,.96,3.006l-2.757,9.16a1.619,1.619,0,0,0,1.334,2.117l4.909.765A2.615,2.615,0,0,0,142.8,148l3.966-8.893a4.714,4.714,0,0,1,2.615-2.241,27.516,27.516,0,0,0,2.9-1.174,1.636,1.636,0,0,1,2.348.889l1.992,5.336a1.209,1.209,0,0,0,2.1.516l6.848-6.172a4,4,0,0,0,1.174-3.148l-.889-6.866a5.443,5.443,0,0,1,.907-3.4c1.1-1.512,2.117-3.059,3.077-4.678a3.717,3.717,0,0,1,2.846-1.779h4.66a2.988,2.988,0,0,0,2.561-1.779l3.735-10.1a1.9,1.9,0,0,0-1.138-2.419l-3.877-1.352a2.33,2.33,0,0,1-1.458-2.508,44.072,44.072,0,0,0,.5-4.731,5.958,5.958,0,0,1,1.352-3.273l6.03-6.332A3.842,3.842,0,0,0,185.914,80.462ZM157.455,119.77c-7.435,6.688-15.065,5.5-17.022-2.65s2.472-20.152,9.907-26.84,15.047-5.514,17.022,2.632-2.455,20.17-9.889,26.858Z",
    transform: "translate(5.63 -56.824)",
    fill: "#fff",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M135.185,81.354h0a1.779,1.779,0,0,0-1.779.285l-3.557,2.739-.694,2.33a4.376,4.376,0,0,0,1.316,4.126,16.863,16.863,0,0,1,1.779,2.01,2.579,2.579,0,0,0,3.557.551l8.449-6.4a1.779,1.779,0,0,1,1.779-.3Zm-11.508,33.314c-1.779-7.115-6.492-10.334-12.451-9.462a17.556,17.556,0,0,1,1.494,4.109c2.7,11.206-3.415,27.765-13.642,36.978a21.9,21.9,0,0,1-10.921,5.87c4.038,7.364,13.055,7.488,21.9-.445C120.28,142.45,126.4,125.891,123.677,114.668ZM120.671,66.2h0a1.886,1.886,0,0,0-.711-.249l-6.759-.943A3.557,3.557,0,0,0,109.643,67l-5.567,12.237a5.336,5.336,0,0,1-1.281,1.69h0a5.959,5.959,0,0,1-1.014.783l2.366,6.421a2.259,2.259,0,0,0,3.237,1.227,34.934,34.934,0,0,1,4-1.619,6.776,6.776,0,0,0,2.294-1.387,5.336,5.336,0,0,0,1.3-1.779l5.46-12.344a3.664,3.664,0,0,1,3.664-1.885l6.759,1.067a2.509,2.509,0,0,1,.676.2Zm-11.1,116.68a1.779,1.779,0,0,1-.694-.978l-2.757-7.31a2.241,2.241,0,0,0-3.219-1.227,31.124,31.124,0,0,1-4.02,1.619,5.088,5.088,0,0,0-1.245.622l.356.943a1.956,1.956,0,0,0,.925,1.1h0ZM89.58,74.381a1.512,1.512,0,0,0-.747-.142,1.939,1.939,0,0,0-1.192.551l-9.374,8.431a1.9,1.9,0,0,0-.356.391,2.046,2.046,0,0,0-.249.3,6.919,6.919,0,0,0-.765,1.636.635.635,0,0,1-.089.391h0a4.358,4.358,0,0,0-.16,1.619l1.138,9.462a7.417,7.417,0,0,1-1.245,4.7c-1.512,2.063-2.9,4.233-4.215,6.439a5.1,5.1,0,0,1-2.081,1.779,4.161,4.161,0,0,1-.854.32,1.778,1.778,0,0,1-.427.089,2.009,2.009,0,0,1-.569,0l-6.421.107H61.3a1.992,1.992,0,0,0-.462.142h0a3.416,3.416,0,0,0-.516.249,4.518,4.518,0,0,0-.889.64,3.949,3.949,0,0,0-.943,1.37l-5.123,14.14a2.561,2.561,0,0,0,1.227,3.166l7.4,3.557a3.184,3.184,0,0,1,.267,1.779,58.993,58.993,0,0,0-.676,6.51,8.128,8.128,0,0,1-1.868,4.518h0L51.5,155.132a3.719,3.719,0,0,0-.391.5h0a1.974,1.974,0,0,0-.32.6,5.069,5.069,0,0,0-.445,3.273l2.312,9.516a1.921,1.921,0,0,0,.854,1.263l10.85,5.336a1.779,1.779,0,0,1-.818-1.227l-2.294-9.516a4.3,4.3,0,0,1,0-1.779,5.336,5.336,0,0,1,1.209-2.615l8-8.324v-.107a8.146,8.146,0,0,0,1.885-4.518,59.907,59.907,0,0,1,.676-6.51,3.2,3.2,0,0,0-1.868-3.486l-5.336-1.779a2.579,2.579,0,0,1-1.583-3.326l5.14-14.069a3.344,3.344,0,0,1,.943-1.37,4.073,4.073,0,0,1,2.615-1.067l6.439-.107a4.162,4.162,0,0,0,1.779-.5,5,5,0,0,0,2.081-1.779c1.316-2.206,2.721-4.376,4.215-6.421a7.488,7.488,0,0,0,1.245-4.767l-1.227-9.445a4.127,4.127,0,0,1,.142-1.654,5.336,5.336,0,0,1,1.476-2.7l9.445-8.5a1.779,1.779,0,0,1,1.957-.409Zm-8.289,101.6a4.447,4.447,0,0,0-1.334-4.144,16.474,16.474,0,0,1-1.779-1.992,2.561,2.561,0,0,0-3.557-.569L69.8,172.83,66.8,182.986a2.206,2.206,0,0,0,1.067,2.65h0l10.921,5.336a2.206,2.206,0,0,1-1.067-2.668Z",
    transform: "translate(-50.183 -53.536)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M135.185,81.354h0a1.779,1.779,0,0,0-1.779.285l-3.557,2.739-.694,2.33a4.376,4.376,0,0,0,1.316,4.126,16.863,16.863,0,0,1,1.779,2.01,2.579,2.579,0,0,0,3.557.551l8.449-6.4a1.779,1.779,0,0,1,1.779-.3Zm-11.508,33.314c-1.779-7.115-6.492-10.334-12.451-9.462a17.556,17.556,0,0,1,1.494,4.109c2.7,11.206-3.415,27.765-13.642,36.978a21.9,21.9,0,0,1-10.921,5.87c4.038,7.364,13.055,7.488,21.9-.445C120.28,142.45,126.4,125.891,123.677,114.668ZM120.671,66.2h0a1.886,1.886,0,0,0-.711-.249l-6.759-.943A3.557,3.557,0,0,0,109.643,67l-5.567,12.237a5.336,5.336,0,0,1-1.281,1.69h0a5.959,5.959,0,0,1-1.014.783l2.366,6.421a2.259,2.259,0,0,0,3.237,1.227,34.934,34.934,0,0,1,4-1.619,6.776,6.776,0,0,0,2.294-1.387,5.336,5.336,0,0,0,1.3-1.779l5.46-12.344a3.664,3.664,0,0,1,3.664-1.885l6.759,1.067a2.509,2.509,0,0,1,.676.2Zm-11.1,116.68a1.779,1.779,0,0,1-.694-.978l-2.757-7.31a2.241,2.241,0,0,0-3.219-1.227,31.124,31.124,0,0,1-4.02,1.619,5.088,5.088,0,0,0-1.245.622l.356.943a1.956,1.956,0,0,0,.925,1.1h0ZM89.58,74.381a1.512,1.512,0,0,0-.747-.142,1.939,1.939,0,0,0-1.192.551l-9.374,8.431a1.9,1.9,0,0,0-.356.391,2.046,2.046,0,0,0-.249.3,6.919,6.919,0,0,0-.765,1.636.635.635,0,0,1-.089.391h0a4.358,4.358,0,0,0-.16,1.619l1.138,9.462a7.417,7.417,0,0,1-1.245,4.7c-1.512,2.063-2.9,4.233-4.215,6.439a5.1,5.1,0,0,1-2.081,1.779,4.161,4.161,0,0,1-.854.32,1.778,1.778,0,0,1-.427.089,2.009,2.009,0,0,1-.569,0l-6.421.107H61.3a1.992,1.992,0,0,0-.462.142h0a3.416,3.416,0,0,0-.516.249,4.518,4.518,0,0,0-.889.64,3.949,3.949,0,0,0-.943,1.37l-5.123,14.14a2.561,2.561,0,0,0,1.227,3.166l7.4,3.557a3.184,3.184,0,0,1,.267,1.779,58.993,58.993,0,0,0-.676,6.51,8.128,8.128,0,0,1-1.868,4.518h0L51.5,155.132a3.719,3.719,0,0,0-.391.5h0a1.974,1.974,0,0,0-.32.6,5.069,5.069,0,0,0-.445,3.273l2.312,9.516a1.921,1.921,0,0,0,.854,1.263l10.85,5.336a1.779,1.779,0,0,1-.818-1.227l-2.294-9.516a4.3,4.3,0,0,1,0-1.779,5.336,5.336,0,0,1,1.209-2.615l8-8.324v-.107a8.146,8.146,0,0,0,1.885-4.518,59.907,59.907,0,0,1,.676-6.51,3.2,3.2,0,0,0-1.868-3.486l-5.336-1.779a2.579,2.579,0,0,1-1.583-3.326l5.14-14.069a3.344,3.344,0,0,1,.943-1.37,4.073,4.073,0,0,1,2.615-1.067l6.439-.107a4.162,4.162,0,0,0,1.779-.5,5,5,0,0,0,2.081-1.779c1.316-2.206,2.721-4.376,4.215-6.421a7.488,7.488,0,0,0,1.245-4.767l-1.227-9.445a4.127,4.127,0,0,1,.142-1.654,5.336,5.336,0,0,1,1.476-2.7l9.445-8.5a1.779,1.779,0,0,1,1.957-.409Zm-8.289,101.6a4.447,4.447,0,0,0-1.334-4.144,16.474,16.474,0,0,1-1.779-1.992,2.561,2.561,0,0,0-3.557-.569L69.8,172.83,66.8,182.986a2.206,2.206,0,0,0,1.067,2.65h0l10.921,5.336a2.206,2.206,0,0,1-1.067-2.668Z",
    transform: "translate(-50.183 -53.536)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M135.185,81.354h0a1.779,1.779,0,0,0-1.779.285l-3.557,2.739-.694,2.33a4.376,4.376,0,0,0,1.316,4.126,16.863,16.863,0,0,1,1.779,2.01,2.579,2.579,0,0,0,3.557.551l8.449-6.4a1.779,1.779,0,0,1,1.779-.3Zm-11.508,33.314c-1.779-7.115-6.492-10.334-12.451-9.462a17.556,17.556,0,0,1,1.494,4.109c2.7,11.206-3.415,27.765-13.642,36.978a21.9,21.9,0,0,1-10.921,5.87c4.038,7.364,13.055,7.488,21.9-.445C120.28,142.45,126.4,125.891,123.677,114.668ZM120.671,66.2h0a1.886,1.886,0,0,0-.711-.249l-6.759-.943A3.557,3.557,0,0,0,109.643,67l-5.567,12.237a5.336,5.336,0,0,1-1.281,1.69h0a5.959,5.959,0,0,1-1.014.783l2.366,6.421a2.259,2.259,0,0,0,3.237,1.227,34.934,34.934,0,0,1,4-1.619,6.776,6.776,0,0,0,2.294-1.387,5.336,5.336,0,0,0,1.3-1.779l5.46-12.344a3.664,3.664,0,0,1,3.664-1.885l6.759,1.067a2.509,2.509,0,0,1,.676.2Zm-11.1,116.68a1.779,1.779,0,0,1-.694-.978l-2.757-7.31a2.241,2.241,0,0,0-3.219-1.227,31.124,31.124,0,0,1-4.02,1.619,5.088,5.088,0,0,0-1.245.622l.356.943a1.956,1.956,0,0,0,.925,1.1h0ZM89.58,74.381a1.512,1.512,0,0,0-.747-.142,1.939,1.939,0,0,0-1.192.551l-9.374,8.431a1.9,1.9,0,0,0-.356.391,2.046,2.046,0,0,0-.249.3,6.919,6.919,0,0,0-.765,1.636.635.635,0,0,1-.089.391h0a4.358,4.358,0,0,0-.16,1.619l1.138,9.462a7.417,7.417,0,0,1-1.245,4.7c-1.512,2.063-2.9,4.233-4.215,6.439a5.1,5.1,0,0,1-2.081,1.779,4.161,4.161,0,0,1-.854.32,1.778,1.778,0,0,1-.427.089,2.009,2.009,0,0,1-.569,0l-6.421.107H61.3a1.992,1.992,0,0,0-.462.142h0a3.416,3.416,0,0,0-.516.249,4.518,4.518,0,0,0-.889.64,3.949,3.949,0,0,0-.943,1.37l-5.123,14.14a2.561,2.561,0,0,0,1.227,3.166l7.4,3.557a3.184,3.184,0,0,1,.267,1.779,58.993,58.993,0,0,0-.676,6.51,8.128,8.128,0,0,1-1.868,4.518h0L51.5,155.132a3.719,3.719,0,0,0-.391.5h0a1.974,1.974,0,0,0-.32.6,5.069,5.069,0,0,0-.445,3.273l2.312,9.516a1.921,1.921,0,0,0,.854,1.263l10.85,5.336a1.779,1.779,0,0,1-.818-1.227l-2.294-9.516a4.3,4.3,0,0,1,0-1.779,5.336,5.336,0,0,1,1.209-2.615l8-8.324v-.107a8.146,8.146,0,0,0,1.885-4.518,59.907,59.907,0,0,1,.676-6.51,3.2,3.2,0,0,0-1.868-3.486l-5.336-1.779a2.579,2.579,0,0,1-1.583-3.326l5.14-14.069a3.344,3.344,0,0,1,.943-1.37,4.073,4.073,0,0,1,2.615-1.067l6.439-.107a4.162,4.162,0,0,0,1.779-.5,5,5,0,0,0,2.081-1.779c1.316-2.206,2.721-4.376,4.215-6.421a7.488,7.488,0,0,0,1.245-4.767l-1.227-9.445a4.127,4.127,0,0,1,.142-1.654,5.336,5.336,0,0,1,1.476-2.7l9.445-8.5a1.779,1.779,0,0,1,1.957-.409Zm-8.289,101.6a4.447,4.447,0,0,0-1.334-4.144,16.474,16.474,0,0,1-1.779-1.992,2.561,2.561,0,0,0-3.557-.569L69.8,172.83,66.8,182.986a2.206,2.206,0,0,0,1.067,2.65h0l10.921,5.336a2.206,2.206,0,0,1-1.067-2.668Z",
    transform: "translate(-50.183 -53.536)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M70.487,116.336l-8.2,8.555a5.336,5.336,0,0,0-1.209,2.615L50.21,122.17a6.279,6.279,0,0,1,.427-1.423,1.974,1.974,0,0,1,.32-.6h0a3.717,3.717,0,0,1,.391-.5L59.6,111Z",
    transform: "translate(-50.21 -17.71)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M77.1,95.548a4.162,4.162,0,0,1-1.779.5l-6.421.107a4.073,4.073,0,0,0-2.579,1.138l-10.9-5.336a4.518,4.518,0,0,1,.889-.64,3.418,3.418,0,0,1,.516-.249h0a1.993,1.993,0,0,1,.462-.142h.676l6.421-.107a2.01,2.01,0,0,0,.569,0l.427-.089a2.426,2.426,0,0,0,.818-.338h0Z",
    transform: "translate(-46.153 -33.758)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M111.512,79.548a1.779,1.779,0,0,0-1.779.338l-8.449,6.439a2.561,2.561,0,0,1-3.557-.569,16.6,16.6,0,0,0-1.779-1.992,4.393,4.393,0,0,1-1.316-4.144l.694-2.294,3.557-2.757a1.779,1.779,0,0,1,1.779-.285h0Z",
    transform: "translate(-15.696 -46.395)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M108.622,71.543a2.508,2.508,0,0,0-.676-.2l-6.759-1.067a3.664,3.664,0,0,0-3.664,1.992L91.974,84.581a5.336,5.336,0,0,1-1.3,1.779L79.79,81.023a5.335,5.335,0,0,0,1.281-1.69L86.549,66.99A3.557,3.557,0,0,1,90.106,65l6.759,1.049a1.885,1.885,0,0,1,.711.249h0Z",
    transform: "translate(-27.177 -53.544)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M88.893,75.647a1.779,1.779,0,0,0-1.957.409l-9.445,8.5a5.336,5.336,0,0,0-1.476,2.7L65.13,81.926a.634.634,0,0,1,.089-.391,6.919,6.919,0,0,1,.765-1.636,2.047,2.047,0,0,1,.249-.3,1.9,1.9,0,0,1,.356-.391l9.462-8.5a1.939,1.939,0,0,1,1.192-.551,1.512,1.512,0,0,1,.747.142Z",
    transform: "translate(-38.592 -49.52)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M70.487,116.336l-8.2,8.555a5.336,5.336,0,0,0-1.209,2.615L50.21,122.17a6.279,6.279,0,0,1,.427-1.423,1.974,1.974,0,0,1,.32-.6h0a3.717,3.717,0,0,1,.391-.5L59.6,111Z",
    transform: "translate(-50.21 -17.71)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M77.1,95.548a4.162,4.162,0,0,1-1.779.5l-6.421.107a4.073,4.073,0,0,0-2.579,1.138l-10.9-5.336a4.518,4.518,0,0,1,.889-.64,3.418,3.418,0,0,1,.516-.249h0a1.993,1.993,0,0,1,.462-.142h.676l6.421-.107a2.01,2.01,0,0,0,.569,0l.427-.089a2.426,2.426,0,0,0,.818-.338h0Z",
    transform: "translate(-46.153 -33.758)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M111.512,79.548a1.779,1.779,0,0,0-1.779.338l-8.449,6.439a2.561,2.561,0,0,1-3.557-.569,16.6,16.6,0,0,0-1.779-1.992,4.393,4.393,0,0,1-1.316-4.144l.694-2.294,3.557-2.757a1.779,1.779,0,0,1,1.779-.285h0Z",
    transform: "translate(-15.696 -46.395)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M108.622,71.543a2.508,2.508,0,0,0-.676-.2l-6.759-1.067a3.664,3.664,0,0,0-3.664,1.992L91.974,84.581a5.336,5.336,0,0,1-1.3,1.779L79.79,81.023a5.335,5.335,0,0,0,1.281-1.69L86.549,66.99A3.557,3.557,0,0,1,90.106,65l6.759,1.049a1.885,1.885,0,0,1,.711.249h0Z",
    transform: "translate(-27.177 -53.544)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M88.893,75.647a1.779,1.779,0,0,0-1.957.409l-9.445,8.5a5.336,5.336,0,0,0-1.476,2.7L65.13,81.926a.634.634,0,0,1,.089-.391,6.919,6.919,0,0,1,.765-1.636,2.047,2.047,0,0,1,.249-.3,1.9,1.9,0,0,1,.356-.391l9.462-8.5a1.939,1.939,0,0,1,1.192-.551,1.512,1.512,0,0,1,.747.142Z",
    transform: "translate(-38.592 -49.52)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M144.52,95.168l-2.294-9.516a1.583,1.583,0,0,0-2.7-.96l-8.449,6.439a2.561,2.561,0,0,1-3.557-.569,18.165,18.165,0,0,0-1.779-1.992,4.322,4.322,0,0,1-1.3-4.126l3.682-12.451a2.223,2.223,0,0,0-1.779-2.917l-6.937-1.067A3.557,3.557,0,0,0,115.848,70l-5.567,12.237a6.492,6.492,0,0,1-3.557,3.095,30.932,30.932,0,0,0-4,1.619,2.259,2.259,0,0,1-3.273-1.156l-2.757-7.346a1.672,1.672,0,0,0-2.881-.711l-9.445,8.5A5.585,5.585,0,0,0,82.747,90.6l1.245,9.427a7.577,7.577,0,0,1-1.245,4.7c-1.512,2.063-2.917,4.215-4.233,6.421a5.14,5.14,0,0,1-3.913,2.33l-6.368.124a4.091,4.091,0,0,0-3.557,2.437l-5.14,13.909a2.579,2.579,0,0,0,1.583,3.326l5.336,1.779a3.2,3.2,0,0,1,2.01,3.451,55.384,55.384,0,0,0-.676,6.51,8.022,8.022,0,0,1-1.885,4.518L57.561,158.4a5.336,5.336,0,0,0-1.192,4.447l2.294,9.516a1.6,1.6,0,0,0,2.7.978l8.449-6.4a2.561,2.561,0,0,1,3.557.569,19.92,19.92,0,0,0,1.779,1.992,4.375,4.375,0,0,1,1.316,4.126l-3.7,12.451a2.241,2.241,0,0,0,1.779,2.917l6.759,1.049a3.557,3.557,0,0,0,3.557-2.01l5.478-12.326a6.51,6.51,0,0,1,3.557-3.095,30.236,30.236,0,0,0,4.02-1.619,2.277,2.277,0,0,1,3.237,1.227l2.739,7.31a1.672,1.672,0,0,0,2.881.711l9.445-8.5a5.656,5.656,0,0,0,1.619-4.358l-1.227-9.445a7.47,7.47,0,0,1,1.245-4.7c1.512-2.063,2.917-4.215,4.233-6.421A5.1,5.1,0,0,1,126,144.49l6.421-.107a4.091,4.091,0,0,0,3.557-2.508l5.123-13.909a2.561,2.561,0,0,0-1.565-3.326l-5.336-1.779a3.2,3.2,0,0,1-2.01-3.451,64.175,64.175,0,0,0,.676-6.51,8.128,8.128,0,0,1,1.779-4.518l8.306-8.715a5.336,5.336,0,0,0,1.565-4.5Zm-39.13,54.16c-10.245,9.2-20.739,7.577-23.443-3.557s3.415-27.783,13.66-36.978,20.721-7.595,23.443,3.557-3.468,27.765-13.713,36.978Z",
    transform: "translate(-45.484 -51.2)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M144.52,95.168l-2.294-9.516a1.583,1.583,0,0,0-2.7-.96l-8.449,6.439a2.561,2.561,0,0,1-3.557-.569,18.165,18.165,0,0,0-1.779-1.992,4.322,4.322,0,0,1-1.3-4.126l3.682-12.451a2.223,2.223,0,0,0-1.779-2.917l-6.937-1.067A3.557,3.557,0,0,0,115.848,70l-5.567,12.237a6.492,6.492,0,0,1-3.557,3.095,30.932,30.932,0,0,0-4,1.619,2.259,2.259,0,0,1-3.273-1.156l-2.757-7.346a1.672,1.672,0,0,0-2.881-.711l-9.445,8.5A5.585,5.585,0,0,0,82.747,90.6l1.245,9.427a7.577,7.577,0,0,1-1.245,4.7c-1.512,2.063-2.917,4.215-4.233,6.421a5.14,5.14,0,0,1-3.913,2.33l-6.368.124a4.091,4.091,0,0,0-3.557,2.437l-5.14,13.909a2.579,2.579,0,0,0,1.583,3.326l5.336,1.779a3.2,3.2,0,0,1,2.01,3.451,55.384,55.384,0,0,0-.676,6.51,8.022,8.022,0,0,1-1.885,4.518L57.561,158.4a5.336,5.336,0,0,0-1.192,4.447l2.294,9.516a1.6,1.6,0,0,0,2.7.978l8.449-6.4a2.561,2.561,0,0,1,3.557.569,19.92,19.92,0,0,0,1.779,1.992,4.375,4.375,0,0,1,1.316,4.126l-3.7,12.451a2.241,2.241,0,0,0,1.779,2.917l6.759,1.049a3.557,3.557,0,0,0,3.557-2.01l5.478-12.326a6.51,6.51,0,0,1,3.557-3.095,30.236,30.236,0,0,0,4.02-1.619,2.277,2.277,0,0,1,3.237,1.227l2.739,7.31a1.672,1.672,0,0,0,2.881.711l9.445-8.5a5.656,5.656,0,0,0,1.619-4.358l-1.227-9.445a7.47,7.47,0,0,1,1.245-4.7c1.512-2.063,2.917-4.215,4.233-6.421A5.1,5.1,0,0,1,126,144.49l6.421-.107a4.091,4.091,0,0,0,3.557-2.508l5.123-13.909a2.561,2.561,0,0,0-1.565-3.326l-5.336-1.779a3.2,3.2,0,0,1-2.01-3.451,64.175,64.175,0,0,0,.676-6.51,8.128,8.128,0,0,1,1.779-4.518l8.306-8.715a5.336,5.336,0,0,0,1.565-4.5Zm-39.13,54.16c-10.245,9.2-20.739,7.577-23.443-3.557s3.415-27.783,13.66-36.978,20.721-7.595,23.443,3.557-3.468,27.765-13.713,36.978Z",
    transform: "translate(-45.484 -51.2)",
    fill: "#fff",
    opacity: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cones--inject-2",
    transform: "translate(254.493 633.708)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cone--inject-2",
    transform: "translate(0 27.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M150.459,428.54l38.063-21.984a5.176,5.176,0,0,1,2.543-.6,5.336,5.336,0,0,1,2.561.6l38.045,21.984a1.779,1.779,0,0,1,1.049,1.476v2.7a1.779,1.779,0,0,1-1.049,1.476l-38.045,21.966a5.336,5.336,0,0,1-2.561.6,5.178,5.178,0,0,1-2.543-.6l-38.063-21.9a1.779,1.779,0,0,1-1.049-1.476v-2.775A1.779,1.779,0,0,1,150.459,428.54Z",
    transform: "translate(-149.374 -373.488)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M149.39,429.977v2.7a1.779,1.779,0,0,0,1.049,1.476L188.5,456.123a5.176,5.176,0,0,0,2.543.6V406a5.175,5.175,0,0,0-2.544.6l-38.028,21.9a1.779,1.779,0,0,0-1.085,1.476Z",
    transform: "translate(-149.39 -373.449)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M172.81,406v50.887a5.336,5.336,0,0,0,2.561-.6l38.045-21.966a1.778,1.778,0,0,0,1.049-1.476v-2.775a1.779,1.779,0,0,0-1.049-1.476l-38.045-21.984a5.336,5.336,0,0,0-2.561-.6Z",
    transform: "translate(-131.154 -373.449)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M193.59,453.454l38.063-21.966a1.565,1.565,0,0,0,0-2.953L193.59,406.568a5.656,5.656,0,0,0-5.123,0l-38.01,21.966a1.565,1.565,0,0,0,0,2.953L188.5,453.454a5.656,5.656,0,0,0,5.087,0Z",
    transform: "translate(-149.373 -373.483)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M193.59,453.454l38.063-21.966a1.565,1.565,0,0,0,0-2.953L193.59,406.568a5.656,5.656,0,0,0-5.123,0l-38.01,21.966a1.565,1.565,0,0,0,0,2.953L188.5,453.454a5.656,5.656,0,0,0,5.087,0Z",
    transform: "translate(-149.373 -373.483)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M172.81,406a5.337,5.337,0,0,1,2.561.623l38.063,21.966a1.565,1.565,0,0,1,0,2.953l-38.063,21.966a5.335,5.335,0,0,1-2.561.623Z",
    transform: "translate(-131.154 -373.449)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M159.808,441.45h0l16.844-50.567v-.089h0a3.806,3.806,0,0,1,1.779-1.957,10.672,10.672,0,0,1,9.587,0,3.966,3.966,0,0,1,1.779,1.956h0l16.968,50.656h0c1.547,4.411-.623,9.16-6.528,12.575-9.374,5.336-24.563,5.336-33.919,0C160.519,450.611,158.26,445.861,159.808,441.45Z",
    transform: "translate(-141.647 -387.697)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M166.438,400.755h0l2.4-7.115a3.433,3.433,0,0,0,1.049,3.557,6.9,6.9,0,0,0,1.494,1.156,14.461,14.461,0,0,0,13.073,0,7.364,7.364,0,0,0,1.494-1.156,3.557,3.557,0,0,0,1.032-3.557l2.4,7.2h0a4.127,4.127,0,0,1-.534,3.557,7.542,7.542,0,0,1-2.686,2.437,13.551,13.551,0,0,1-2.9,1.174,19.3,19.3,0,0,1-10.672,0,13.34,13.34,0,0,1-2.917-1.174,7.7,7.7,0,0,1-2.686-2.437A4.126,4.126,0,0,1,166.438,400.755Z",
    transform: "translate(-136.272 -383.073)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M161.106,417.084h0l2.383-7.2a6.4,6.4,0,0,0-.125,3.557,8.164,8.164,0,0,0,2.028,3.646,14.372,14.372,0,0,0,3.344,2.615,29.881,29.881,0,0,0,26.964,0,14.018,14.018,0,0,0,3.344-2.615,8.4,8.4,0,0,0,2.045-3.646,6.563,6.563,0,0,0-.142-3.557l2.383,7.115h0a7.417,7.417,0,0,1,.267,3.557c-.5,2.739-2.561,5.336-6.19,7.506-8.413,4.838-22.038,4.838-30.451,0-3.557-2.117-5.692-4.767-6.172-7.506a7.292,7.292,0,0,1,.32-3.468Z",
    transform: "translate(-140.58 -370.427)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M163.759,408.944h0l2.4-7.2a4.856,4.856,0,0,0,.213,3.557,8.627,8.627,0,0,0,3.557,3.557h.125a22.162,22.162,0,0,0,20.01,0h.107a8.52,8.52,0,0,0,3.557-3.557,4.945,4.945,0,0,0,.231-3.557l2.383,7.2h0a5.514,5.514,0,0,1,0,3.557,8.2,8.2,0,0,1-2.632,3.557,15.162,15.162,0,0,1-1.921,1.352,21.341,21.341,0,0,1-6.385,2.277,28.618,28.618,0,0,1-10.672,0,21.077,21.077,0,0,1-6.385-2.277,14,14,0,0,1-1.921-1.352,8.11,8.11,0,0,1-2.65-3.557A5.763,5.763,0,0,1,163.759,408.944Z",
    transform: "translate(-138.413 -376.766)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M172.826,387.7a9.835,9.835,0,0,1,4.8,1.138,3.966,3.966,0,0,1,1.779,1.956h0l16.879,50.656h0c1.547,4.411-.623,9.16-6.528,12.575a34.738,34.738,0,0,1-16.968,4.055h.142A14.229,14.229,0,0,0,184.6,442.075l-7.008-50.354Z",
    transform: "translate(-131.169 -387.699)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M180.577,394.387c2.65-1.53,2.65-4.02,0-5.549a10.672,10.672,0,0,0-9.587,0c-2.65,1.53-2.65,4.02,0,5.549a10.672,10.672,0,0,0,9.587,0Z",
    transform: "translate(-134.119 -387.697)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M180.577,394.387c2.65-1.53,2.65-4.02,0-5.549a10.672,10.672,0,0,0-9.587,0c-2.65,1.53-2.65,4.02,0,5.549a10.672,10.672,0,0,0,9.587,0Z",
    transform: "translate(-134.119 -387.697)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cone--inject-2-2",
    "data-name": "freepik--cone--inject-2",
    transform: "translate(308.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M323.7,413.09l38.063-21.966a4.946,4.946,0,0,1,2.544-.622,5.07,5.07,0,0,1,2.561.622l38.046,21.966a1.779,1.779,0,0,1,1.049,1.476v2.775a1.778,1.778,0,0,1-1.049,1.476l-38.045,21.966a5.336,5.336,0,0,1-2.561.6,5.122,5.122,0,0,1-2.543-.6L323.7,418.817a1.778,1.778,0,0,1-1.049-1.476v-2.828A1.778,1.778,0,0,1,323.7,413.09Z",
    transform: "translate(-322.616 -358.019)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M322.65,414.513v2.775a1.779,1.779,0,0,0,1.049,1.476l38.063,21.966a5.122,5.122,0,0,0,2.544.6V390.5a4.945,4.945,0,0,0-2.543.623L323.7,413.09a1.778,1.778,0,0,0-1.049,1.423Z",
    transform: "translate(-322.616 -358.019)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M346.07,390.5v50.887a5.335,5.335,0,0,0,2.561-.6l38.045-21.966a1.778,1.778,0,0,0,1.049-1.476v-2.828a1.779,1.779,0,0,0-1.049-1.476l-38.045-21.966a5.068,5.068,0,0,0-2.561-.569Z",
    transform: "translate(-304.38 -358.021)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M366.882,438l38.046-21.966a1.547,1.547,0,0,0,0-2.953l-38.046-21.966a5.656,5.656,0,0,0-5.123,0l-38.046,21.966a1.547,1.547,0,0,0,0,2.953L361.76,438a5.656,5.656,0,0,0,5.123,0Z",
    transform: "translate(-322.631 -358.014)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M366.882,438l38.046-21.966a1.547,1.547,0,0,0,0-2.953l-38.046-21.966a5.656,5.656,0,0,0-5.123,0l-38.046,21.966a1.547,1.547,0,0,0,0,2.953L361.76,438a5.656,5.656,0,0,0,5.123,0Z",
    transform: "translate(-322.631 -358.014)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M346.07,390.5a5.336,5.336,0,0,1,2.561.623l38.045,21.966a1.547,1.547,0,0,1,0,2.953l-38.045,21.966a5.335,5.335,0,0,1-2.561.623Z",
    transform: "translate(-304.38 -358.019)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M333.069,425.995h0l16.844-50.638h0a4.038,4.038,0,0,1,1.779-1.957,10.672,10.672,0,0,1,9.6,0,4.037,4.037,0,0,1,1.779,1.957h0l16.844,50.585h0c1.547,4.411-.623,9.16-6.545,12.575-9.356,5.336-24.545,5.336-33.9,0C333.691,435.155,331.539,430.495,333.069,425.995Z",
    transform: "translate(-314.875 -372.223)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M339.7,385.3h0l2.4-7.115a3.558,3.558,0,0,0,1.032,3.557,7.51,7.51,0,0,0,1.512,1.156,14.425,14.425,0,0,0,13.055,0,7.51,7.51,0,0,0,1.512-1.156,3.557,3.557,0,0,0,1.032-3.557l2.4,7.221h0a4.126,4.126,0,0,1-.534,3.557,7.7,7.7,0,0,1-2.686,2.437,14.572,14.572,0,0,1-2.9,1.192,19.688,19.688,0,0,1-10.672,0,14.561,14.561,0,0,1-2.9-1.192,7.7,7.7,0,0,1-2.686-2.437,4.127,4.127,0,0,1-.569-3.664Z",
    transform: "translate(-309.497 -367.604)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M334.367,401.595h0l2.4-7.115a6.4,6.4,0,0,0-.125,3.557,8.164,8.164,0,0,0,2.028,3.646,14.017,14.017,0,0,0,3.344,2.615,29.882,29.882,0,0,0,26.964,0,14.016,14.016,0,0,0,3.344-2.615,8.165,8.165,0,0,0,2.028-3.646,6.333,6.333,0,0,0-.124-3.557l2.383,7.115h0a7.114,7.114,0,0,1,.249,3.557,11.49,11.49,0,0,1-6.172,7.506c-8.413,4.838-22.038,4.838-30.451,0a11.49,11.49,0,0,1-6.172-7.506A7.116,7.116,0,0,1,334.367,401.595Z",
    transform: "translate(-313.807 -354.919)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M337.016,393.494h0l2.383-7.2a4.945,4.945,0,0,0,.231,3.557,8.521,8.521,0,0,0,3.557,3.557h.107a22.2,22.2,0,0,0,20.028,0h.107a8.521,8.521,0,0,0,3.557-3.557,4.945,4.945,0,0,0,.231-3.557l2.383,7.2h0a5.639,5.639,0,0,1,0,3.557,8.2,8.2,0,0,1-2.632,3.557,13.753,13.753,0,0,1-1.939,1.352,20.969,20.969,0,0,1-6.368,2.277,27.994,27.994,0,0,1-10.672,0,20.97,20.97,0,0,1-6.368-2.277,13.759,13.759,0,0,1-1.939-1.352,8.2,8.2,0,0,1-2.632-3.557,5.763,5.763,0,0,1-.036-3.557Z",
    transform: "translate(-311.635 -361.297)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M346.1,372.251a9.836,9.836,0,0,1,4.8,1.138,4.038,4.038,0,0,1,1.779,1.957h0l16.844,50.585h0c1.547,4.411-.622,9.16-6.545,12.575a34.629,34.629,0,0,1-16.951,4.055h.142a14.229,14.229,0,0,0,11.65-16.008l-6.99-50.354Z",
    transform: "translate(-304.411 -372.23)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M353.845,378.929c2.65-1.53,2.65-4.02,0-5.549a10.672,10.672,0,0,0-9.6,0c-2.65,1.53-2.65,4.02,0,5.549a10.672,10.672,0,0,0,9.6,0Z",
    transform: "translate(-307.352 -372.238)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M353.845,378.929c2.65-1.53,2.65-4.02,0-5.549a10.672,10.672,0,0,0-9.6,0c-2.65,1.53-2.65,4.02,0,5.549a10.672,10.672,0,0,0,9.6,0Z",
    transform: "translate(-307.352 -372.238)",
    fill: "#fff",
    opacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2",
    transform: "translate(16.156 527.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M72.928,393.662s4.358-21.344-.658-40.589-15.83-33.794-28.6-39.13-27.267,3.291-16.008,16.15,33.474,29.4,34.862,64.032Z",
    transform: "translate(-8.988 -312.338)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M72.928,393.662s4.358-21.344-.658-40.589-15.83-33.794-28.6-39.13-27.267,3.291-16.008,16.15,33.474,29.4,34.862,64.032Z",
    transform: "translate(-8.988 -312.338)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M65.854,384.524H66a.765.765,0,0,0,.694-.8c-2.739-38.561-24.421-61.364-35.573-68.016a.729.729,0,0,0-1.014.249.747.747,0,0,0,.267,1.014c10.85,6.528,32.1,28.9,34.791,66.86A.747.747,0,0,0,65.854,384.524Z",
    transform: "translate(-4.014 -309.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M15.744,342.042c-1.405,4.3,1.654,7.292,4.553,9.711,2.206,1.868,4.642,3.877,5.336,6.723,1.227,5.727-5.549,11.01-4.091,16.684a9.213,9.213,0,0,0,4.785,5.336,61.006,61.006,0,0,0,5.638,2.4,25.834,25.834,0,0,0,2.81.676,13.144,13.144,0,0,1,7.7,3.433c3.13,3.4,2.739,8.626,3.86,13.109v.16a13.838,13.838,0,0,0,21.451,7.559l15.83-11.277c6.279-8.431,4.7-23.549-5.336-28.459-2.134-1.049-4.571-1.654-6.279-3.326a11.632,11.632,0,0,1-2.686-8,23.123,23.123,0,0,0-1.174-8.5,12.451,12.451,0,0,0-9.5-6.581c-4.642-.8-9.267,1.067-13.66-.534s-8.449-4.18-13-5.336c-4.98-1.245-10.672-.569-14.443,3.451a7.951,7.951,0,0,0-1.8,2.775Z",
    transform: "translate(-15.392 -294.494)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M58.057,364.808a.587.587,0,0,0-.2-.267C46.087,347.858,27.625,339.96,21.4,338.555a.676.676,0,0,0-.783.5.658.658,0,0,0,.5.783c5.923,1.316,23.123,8.626,34.577,23.923a36.089,36.089,0,0,0-28.708,2.508.658.658,0,0,0-.2.907.711.711,0,0,0,.534.3.747.747,0,0,0,.374-.107,34.737,34.737,0,0,1,29.33-1.779,54.676,54.676,0,0,1,9.8,33.652.658.658,0,0,0,.587.658h0a.658.658,0,0,0,.676-.623,55.974,55.974,0,0,0-10.032-34.471Z",
    transform: "translate(-11.336 -291.932)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2",
    transform: "translate(77.924 36.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2-2",
    "data-name": "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2-3",
    "data-name": "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M486.532,57.116l-9.107-5.336L50.156,298.48V620.416A6.812,6.812,0,0,0,53,626.695h0l9.125,5.336h0a6.83,6.83,0,0,0,6.866-.676l407.793-235.53a21.468,21.468,0,0,0,9.711-16.844Z",
    transform: "translate(-50.119 -24.498)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M55.27,623.341c0,6.207,4.358,8.715,9.711,5.621L472.774,393.521a21.468,21.468,0,0,0,9.711-16.844V54.74L55.27,301.475Z",
    transform: "translate(-46.108 -22.193)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M55.27,623.341c0,6.207,4.358,8.715,9.711,5.621L472.774,393.521a21.468,21.468,0,0,0,9.711-16.844V54.74L55.27,301.475Z",
    transform: "translate(-46.108 -22.193)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M61.048,631.823a5.886,5.886,0,0,1-2.97-.783,7.684,7.684,0,0,1-3.291-7.115V301.6l.409-.3L483.853,53.92v323.4A22.5,22.5,0,0,1,473.7,394.924L65.869,630.347a9.747,9.747,0,0,1-4.82,1.476ZM56.566,302.629v321.35a6.03,6.03,0,0,0,2.4,5.532,6.012,6.012,0,0,0,5.976-.694L472.772,393.394a20.579,20.579,0,0,0,9.267-16.008V57Z",
    transform: "translate(-46.515 -22.832)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M55.27,301.444v38.081L482.521,92.861V54.78Z",
    transform: "translate(-46.108 -22.162)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M59.265,233.861l-9.125-5.3V190.48l9.125,5.3Z",
    transform: "translate(-50.102 83.502)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M59.265,233.861l-9.125-5.3V190.48l9.125,5.3Z",
    transform: "translate(-50.102 83.502)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M245,109.641v9.071c0,1.779,1.316,2.615,2.917,1.779l59.514-34.506V70.19l-59.46,34.4a6.474,6.474,0,0,0-2.97,5.051Z",
    transform: "translate(101.626 -10.163)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M295.414,65.383c1.619-.925,2.917-.178,2.917,1.779v9.053a6.4,6.4,0,0,1-2.917,5.051L280.1,90.159V74.24Z",
    transform: "translate(128.957 -14.213)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M292.02,75.085l-1.779-.534a10.4,10.4,0,0,0,.267-2.206,3.984,3.984,0,0,0-1.565-3.557,2.419,2.419,0,0,0-2.49.107,8.893,8.893,0,0,0-3.415,7.115,4,4,0,0,0,1.565,3.557,2.117,2.117,0,0,0,1.085.3,2.793,2.793,0,0,0,1.405-.427,7.115,7.115,0,0,0,2.757-3.682l1.779.534h.249a.623.623,0,0,0,.6-.445.6.6,0,0,0-.462-.765Zm-5.478,3.2a1.174,1.174,0,0,1-1.209.125,2.952,2.952,0,0,1-.925-2.561,7.612,7.612,0,0,1,2.775-6.012,1.6,1.6,0,0,1,.765-.249,1.05,1.05,0,0,1,.462.125,3.006,3.006,0,0,1,.925,2.561,7.63,7.63,0,0,1-2.793,6.012Z",
    transform: "translate(131.231 -11.483)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M474.652,37.15c-1.779-1.085-4.233-.96-6.972.623L59.869,273.2A21.54,21.54,0,0,0,50.14,290v20.383l9.125,5.336L486.516,69.059V48.694a6.866,6.866,0,0,0-2.81-6.279C482.1,41.472,476.217,38.129,474.652,37.15Z",
    transform: "translate(-50.102 -36.441)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M55.27,293.017a21.5,21.5,0,0,1,9.711-16.844L472.774,40.75c5.336-3.095,9.729-.587,9.729,5.621V66.736L55.27,313.4Z",
    transform: "translate(-46.108 -34.118)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M482.637,42.483c-1.779-1.1-4.233-1-7.008.6L67.748,278.493a20.063,20.063,0,0,0-6.883,7.257l-9.125-5.336a20.028,20.028,0,0,1,6.883-7.292L466.434,37.77c2.739-1.583,5.211-1.69,6.955-.623s7.435,4.322,9.071,5.336C482.477,42.43,482.531,42.447,482.637,42.483Z",
    transform: "translate(-48.857 -36.438)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M266.7,60.964a10.085,10.085,0,0,0-4.553,7.9c0,2.917,2.045,4.091,4.553,2.632a10.085,10.085,0,0,0,4.571-7.9C271.275,60.68,269.229,59.506,266.7,60.964Z",
    transform: "translate(114.98 -17.834)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M275.691,55.793a10.085,10.085,0,0,0-4.571,7.968c0,2.917,2.046,4.091,4.571,2.632a10.085,10.085,0,0,0,4.553-7.968C280.245,55.526,278.2,54.334,275.691,55.793Z",
    transform: "translate(121.965 -21.859)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M284.653,50.623a10.067,10.067,0,0,0-4.553,7.9c0,2.917,2.028,4.091,4.553,2.632a10.014,10.014,0,0,0,4.553-7.9C289.207,50.356,287.179,49.164,284.653,50.623Z",
    transform: "translate(128.957 -25.884)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M73.428,383.405a1.713,1.713,0,0,1-1.708-1.725V277.38a1.779,1.779,0,0,1,.854-1.476L197.7,203.654a1.743,1.743,0,0,1,2.632,1.476V309.4a1.779,1.779,0,0,1-.854,1.476L74.3,383.174A1.868,1.868,0,0,1,73.428,383.405Zm1.779-105.083V378.763l121.7-70.275V208.012Z",
    transform: "translate(-33.299 93.574)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M74.795,337.058,71.86,335.28l37.868-63.889a1.779,1.779,0,0,1,2.312-.6l24.4,13.838,25.773-51.581a1.779,1.779,0,0,1,1.192-.907,1.672,1.672,0,0,1,1.459.391l34.719,30.646-2.259,2.543-33.047-29.17L138.7,287.736a1.779,1.779,0,0,1-2.366.729L111.809,274.61Z",
    transform: "translate(-33.19 115.909)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M106.877,256.386a5.193,5.193,0,0,1-2.632-.694,6.368,6.368,0,0,1-2.864-5.887,16.453,16.453,0,0,1,7.577-13.109,5.834,5.834,0,0,1,9.391,5.336,16.524,16.524,0,0,1-7.577,13.126A7.932,7.932,0,0,1,106.877,256.386Zm5.958-17.235a4.3,4.3,0,0,0-2.063.676,12.913,12.913,0,0,0-5.763,9.978,3.059,3.059,0,0,0,1.049,2.757,3.113,3.113,0,0,0,2.9-.462,12.966,12.966,0,0,0,5.763-10,3.024,3.024,0,0,0-1.049-2.739,1.583,1.583,0,0,0-.836-.213Z",
    transform: "translate(-10.223 118.517)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M153.44,228.676l105.35-60.83c2.4-1.37,4.34-.249,4.34,2.508v8.787a9.587,9.587,0,0,1-4.34,7.524l-105.35,60.83c-2.4,1.387-4.34.267-4.34-2.508v-8.822a9.587,9.587,0,0,1,4.34-7.488Z",
    transform: "translate(26.953 65.423)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M150.859,239.107l77.976-45c.96-.569,1.779-.107,1.779,1v5.336a3.806,3.806,0,0,1-1.779,3.006l-77.976,45.036c-.96.551-1.779.107-1.779-1.014v-5.336A3.842,3.842,0,0,1,150.859,239.107Z",
    transform: "translate(26.938 86.136)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M149.538,272.6a1.032,1.032,0,0,1-.872-.5,1.014,1.014,0,0,1,.374-1.37l154.53-89.217a1.019,1.019,0,0,1,1,1.779l-154.53,89.217a1.014,1.014,0,0,1-.5.089Z",
    transform: "translate(26.515 76.421)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M149.535,277.936a1.014,1.014,0,0,1-.5-1.885l154.53-89.2a1,1,0,0,1,1.37.356,1.014,1.014,0,0,1-.374,1.37l-154.53,89.217a1.014,1.014,0,0,1-.5.142Z",
    transform: "translate(26.518 80.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M149.538,283.2a1.032,1.032,0,0,1-.872-.5,1.014,1.014,0,0,1,.374-1.37l154.53-89.271a1.019,1.019,0,0,1,1,1.779l-154.53,89.217A.979.979,0,0,1,149.538,283.2Z",
    transform: "translate(26.515 84.628)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M149.538,288.462a1.032,1.032,0,0,1-.872-.5,1.014,1.014,0,0,1,.374-1.37l154.53-89.217a1.019,1.019,0,0,1,1,1.779l-154.53,89.217A.978.978,0,0,1,149.538,288.462Z",
    transform: "translate(26.515 88.771)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M149.538,293.752a1.032,1.032,0,0,1-.872-.5,1.014,1.014,0,0,1,.374-1.37l154.53-89.217a1.019,1.019,0,0,1,1,1.779l-154.53,89.217a.978.978,0,0,1-.5.089Z",
    transform: "translate(26.515 92.89)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M149.538,278.518a1.032,1.032,0,0,1-.872-.5,1.014,1.014,0,0,1,.374-1.37l73.245-42.332A1.024,1.024,0,1,1,223.3,236.1l-73.263,42.225a1.013,1.013,0,0,1-.5.2Z",
    transform: "translate(26.515 117.532)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-2",
    transform: "translate(38.403 374.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M80.87,394.543l88.488-51.154a8.2,8.2,0,0,0,3.7-6.421V289.335c0-2.366-1.654-3.308-3.7-2.134L80.87,338.355a8.2,8.2,0,0,0-3.7,6.421v47.632C77.17,394.774,78.824,395.734,80.87,394.543Z",
    transform: "translate(-67.458 -216.422)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M79.595,396.295a2.881,2.881,0,0,1-1.388-.356,3.433,3.433,0,0,1-1.511-3.148V345.158a9.018,9.018,0,0,1,4.126-7.115l88.506-51.172a3.095,3.095,0,0,1,4.98,2.881v47.668a9.018,9.018,0,0,1-4.127,7.115L81.694,395.672a4.339,4.339,0,0,1-2.1.623Zm91.814-108.356a2.455,2.455,0,0,0-1.227.391L81.694,339.484a7.381,7.381,0,0,0-3.291,5.674v47.632A1.448,1.448,0,0,0,80.84,394.2l88.506-51.172a7.364,7.364,0,0,0,3.273-5.674V289.718a1.779,1.779,0,0,0-.658-1.654A1.032,1.032,0,0,0,171.409,287.939Z",
    transform: "translate(-67.838 -216.805)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M82.9,322.035l17.146-9.925c1.032-.587,1.779-.107,1.779,1.067v19.8a4.073,4.073,0,0,1-1.779,3.219L82.9,346.082c-1.014.6-1.779.125-1.779-1.067V325.236a4.109,4.109,0,0,1,1.779-3.2Z",
    transform: "translate(-64.383 -196.829)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M97.457,322.3l52.719-30.5a.464.464,0,0,1,.747.427v2.6a1.619,1.619,0,0,1-.747,1.281l-52.719,30.5a.46.46,0,0,1-.747-.427v-2.6a1.654,1.654,0,0,1,.747-1.281Z",
    transform: "translate(-52.244 -212.519)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M97.457,327.867l52.719-30.5a.46.46,0,0,1,.747.427v2.561a1.654,1.654,0,0,1-.747,1.281l-52.719,30.54a.464.464,0,0,1-.747-.427v-2.6A1.619,1.619,0,0,1,97.457,327.867Z",
    transform: "translate(-52.244 -208.193)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M97.457,333.4l52.719-30.5a.46.46,0,0,1,.747.427v2.6a1.672,1.672,0,0,1-.747,1.281L97.457,337.755a.464.464,0,0,1-.747-.427v-2.6a1.618,1.618,0,0,1,.747-1.334Z",
    transform: "translate(-52.244 -203.887)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M81.827,354.964l80.52-46.494a.464.464,0,0,1,.747.427v2.6a1.619,1.619,0,0,1-.747,1.281l-80.52,46.512a.464.464,0,0,1-.747-.427v-2.615a1.672,1.672,0,0,1,.747-1.281Z",
    transform: "translate(-64.414 -199.539)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M81.827,360.516l80.52-46.476a.464.464,0,0,1,.747.427v2.6a1.619,1.619,0,0,1-.747,1.281l-80.52,46.476a.46.46,0,0,1-.747-.427v-2.6A1.654,1.654,0,0,1,81.827,360.516Z",
    transform: "translate(-64.414 -195.202)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M75.549,314.863a.676.676,0,0,1-.551-.32.64.64,0,0,1,.231-.871l1.779-1.085a.658.658,0,0,1,.889.249.64.64,0,0,1-.231.871l-1.779,1.067a.658.658,0,0,1-.338.089Z",
    transform: "translate(-69.217 -196.327)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M78.8,313.6a.641.641,0,0,1-.569-.32.622.622,0,0,1,.249-.871l3.9-2.366a.622.622,0,0,1,.872.249.64.64,0,0,1-.231.871l-3.9,2.241A.551.551,0,0,1,78.8,313.6Z",
    transform: "translate(-66.703 -198.315)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M83.168,310.978a.64.64,0,0,1-.32-1.192l3.9-2.259a.658.658,0,0,1,.889.231.64.64,0,0,1-.249.889l-3.9,2.241a.516.516,0,0,1-.32.089Z",
    transform: "translate(-63.283 -200.269)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M87.549,308.448a.676.676,0,0,1-.551-.32.64.64,0,0,1,.231-.872L91.142,305a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241A.729.729,0,0,1,87.549,308.448Z",
    transform: "translate(-59.873 -202.238)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M91.939,305.918a.623.623,0,0,1-.551-.32.64.64,0,0,1,.231-.871l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241a.729.729,0,0,1-.32.089Z",
    transform: "translate(-56.454 -204.208)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M96.279,303.388a.676.676,0,0,1-.551-.32.658.658,0,0,1,.231-.889l3.9-2.241a.658.658,0,0,1,.889.231.622.622,0,0,1-.249.871L96.6,303.3a.658.658,0,0,1-.32.089Z",
    transform: "translate(-53.076 -206.179)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M100.878,300.758a.64.64,0,0,1-.569-.32.622.622,0,0,1,.249-.871l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241A.552.552,0,0,1,100.878,300.758Z",
    transform: "translate(-49.51 -208.226)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M105.409,298.138a.676.676,0,0,1-.551-.32.658.658,0,0,1,.231-.889l3.9-2.241a.658.658,0,0,1,.889.231.64.64,0,0,1-.231.871l-3.913,2.259a.658.658,0,0,1-.32.089Z",
    transform: "translate(-45.967 -210.267)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M109.959,295.548a.587.587,0,0,1-.551-.32.64.64,0,0,1,.231-.872l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241a.73.73,0,0,1-.32.089Z",
    transform: "translate(-42.423 -212.283)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M114.5,292.878a.64.64,0,0,1-.32-1.192l3.913-2.259a.645.645,0,0,1,.64,1.121l-3.913,2.259a.6.6,0,0,1-.32.071Z",
    transform: "translate(-38.887 -214.362)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M119.049,290.258a.649.649,0,0,1-.32-1.209l3.9-2.241a.64.64,0,0,1,.872.231.623.623,0,0,1-.231.872l-3.806,2.259a.73.73,0,0,1-.409.089Z",
    transform: "translate(-35.346 -216.402)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M123.608,287.628a.64.64,0,0,1-.569-.32.622.622,0,0,1,.249-.871l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.188A.551.551,0,0,1,123.608,287.628Z",
    transform: "translate(-31.811 -218.45)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M128.139,285.008a.676.676,0,0,1-.551-.32.658.658,0,0,1,.231-.889l3.9-2.241a.658.658,0,0,1,.889.231.622.622,0,0,1-.249.871l-3.966,2.259A.658.658,0,0,1,128.139,285.008Z",
    transform: "translate(-28.268 -220.491)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M132.7,282.378a.64.64,0,0,1-.569-.32.622.622,0,0,1,.249-.872l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241A.73.73,0,0,1,132.7,282.378Z",
    transform: "translate(-24.733 -222.538)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M137.278,279.747a.64.64,0,0,1-.32-1.192l3.9-2.259a.658.658,0,0,1,.889.249.623.623,0,0,1-.249.871l-3.9,2.259a.658.658,0,0,1-.32.071Z",
    transform: "translate(-21.15 -224.584)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M141.785,277.117a.676.676,0,0,1-.569-.32.658.658,0,0,1,.249-.889l3.9-2.241a.64.64,0,0,1,.64,1.1l-3.9,2.259A.728.728,0,0,1,141.785,277.117Z",
    transform: "translate(-17.653 -226.615)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M146.278,274.548a.64.64,0,0,1-.32-1.192l3.913-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.913,2.241A.515.515,0,0,1,146.278,274.548Z",
    transform: "translate(-14.142 -228.635)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M150.862,271.867a.658.658,0,0,1-.32-1.209l3.9-2.241a.64.64,0,0,1,.64,1.1l-3.9,2.259A.73.73,0,0,1,150.862,271.867Z",
    transform: "translate(-10.561 -230.702)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M155.411,269.271a.676.676,0,0,1-.551-.32.64.64,0,0,1,.32-.925l3.913-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241A.729.729,0,0,1,155.411,269.271Z",
    transform: "translate(-7.035 -232.785)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M159.959,266.617a.6.6,0,0,1-.551-.32.64.64,0,0,1,.231-.871l3.9-2.259a.658.658,0,0,1,.889.249.623.623,0,0,1-.249.871l-3.9,2.205a.694.694,0,0,1-.32.125Z",
    transform: "translate(-3.49 -234.808)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M164.515,263.987a.676.676,0,0,1-.569-.32.658.658,0,0,1,.249-.889l3.9-2.241a.64.64,0,0,1,.64,1.1l-3.9,2.259a.729.729,0,0,1-.32.089Z",
    transform: "translate(0.046 -236.838)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M169.048,261.369a.64.64,0,0,1-.32-1.192l3.9-2.259a.658.658,0,0,1,.889.231.64.64,0,0,1-.249.889l-3.806,2.241a.516.516,0,0,1-.409.089Z",
    transform: "translate(3.588 -238.898)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M173.448,258.838a.64.64,0,0,1-.569-.32.623.623,0,0,1,.249-.872l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241A.729.729,0,0,1,173.448,258.838Z",
    transform: "translate(6.997 -240.867)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M177.819,256.308a.658.658,0,0,1-.551-.32.64.64,0,0,1,.231-.872l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241A.73.73,0,0,1,177.819,256.308Z",
    transform: "translate(10.416 -242.837)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M182.2,253.26a.676.676,0,0,1-.551-.32.64.64,0,0,1,.231-.872l1.779-1.085a.676.676,0,0,1,.889.249.623.623,0,0,1-.249.872l-1.779,1.067a.623.623,0,0,1-.32.089Z",
    transform: "translate(13.827 -244.29)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M73.95,355.126a.64.64,0,0,1-.64-.64V352.28a.64.64,0,0,1,1.281,0v2.134a.64.64,0,0,1-.64.711Z",
    transform: "translate(-70.464 -165.853)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M73.95,373.995a.64.64,0,0,1-.64-.64v-4.091a.64.64,0,0,1,1.281,0v4.091a.64.64,0,0,1-.64.64Zm0-8.2a.64.64,0,0,1-.64-.64v-4.109a.64.64,0,1,1,1.281,0v4.109A.64.64,0,0,1,73.95,365.8Zm0-8.2a.64.64,0,0,1-.64-.64v-4.109a.64.64,0,0,1,1.281,0v4.109a.64.64,0,0,1-.64.64Zm0-8.2a.658.658,0,0,1-.64-.658v-4.091a.64.64,0,1,1,1.281,0v4.091a.658.658,0,0,1-.64.658Zm0-8.217a.64.64,0,0,1-.64-.64v-4.055a.64.64,0,1,1,1.281,0v4.091a.64.64,0,0,1-.64.6Zm0-8.2a.64.64,0,0,1-.64-.64V328.23a.64.64,0,0,1,1.281,0v4.109a.64.64,0,0,1-.64.587Zm0-8.2a.64.64,0,0,1-.64-.64V320.03a.64.64,0,0,1,1.281,0v4.109a.64.64,0,0,1-.64.64Z",
    transform: "translate(-70.464 -190.965)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M73.95,319.313a.64.64,0,0,1-.64-.64V316.52a.64.64,0,1,1,1.281,0v2.152A.64.64,0,0,1,73.95,319.313Z",
    transform: "translate(-70.464 -193.698)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M182.279,293.944a.676.676,0,0,1-.551-.32.658.658,0,0,1,.231-.889l1.779-1.067a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-1.868,1.067A.623.623,0,0,1,182.279,293.944Z",
    transform: "translate(13.889 -212.618)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M78.789,354.208a.623.623,0,0,1-.551-.32.658.658,0,0,1,.231-.889l3.9-2.241a.658.658,0,0,1,.889.231.623.623,0,0,1-.249.872l-3.9,2.259a.73.73,0,0,1-.32.089Z",
    transform: "translate(-66.694 -166.608)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M83.188,351.668a.64.64,0,0,1-.569-.32.622.622,0,0,1,.249-.871l3.9-2.259a.645.645,0,0,1,.64,1.121l-3.9,2.259a.693.693,0,0,1-.32.071Z",
    transform: "translate(-63.284 -168.585)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M87.559,349.152a.676.676,0,0,1-.551-.32.64.64,0,0,1,.231-.871l3.913-2.259a.64.64,0,1,1,.64,1.1l-3.913,2.259a.623.623,0,0,1-.32.089Z",
    transform: "translate(-59.865 -170.569)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M91.949,346.608a.676.676,0,0,1-.551-.32.658.658,0,0,1,.231-.889l3.9-2.241a.658.658,0,0,1,.889.231.64.64,0,0,1-.231.871L92.269,346.5a.659.659,0,0,1-.32.107Z",
    transform: "translate(-56.447 -172.525)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M96.339,344.067a.587.587,0,0,1-.551-.32.64.64,0,0,1,.231-.872l3.9-2.259a.658.658,0,0,1,.889.249.622.622,0,0,1-.249.871L96.659,344a.694.694,0,0,1-.32.071Z",
    transform: "translate(-53.028 -174.501)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M100.879,341.437a.676.676,0,0,1-.551-.32.658.658,0,0,1,.231-.889l3.913-2.241a.64.64,0,0,1,.64,1.1l-3.9,2.259a.729.729,0,0,1-.338.089Z",
    transform: "translate(-49.494 -176.531)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M105.429,338.818a.6.6,0,0,1-.551-.32.64.64,0,0,1,.231-.872l3.9-2.259a.658.658,0,0,1,.889.231.64.64,0,0,1-.249.889l-3.9,2.241a.552.552,0,0,1-.32.089Z",
    transform: "translate(-45.95 -178.591)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M109.988,336.2a.658.658,0,0,1-.569-.338.623.623,0,0,1,.249-.872l3.9-2.241a.623.623,0,0,1,.872.231.64.64,0,0,1-.231.871l-3.9,2.259A.729.729,0,0,1,109.988,336.2Z",
    transform: "translate(-42.416 -180.634)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M114.519,333.537a.676.676,0,0,1-.551-.32.64.64,0,0,1,.231-.871l3.913-2.259a.64.64,0,0,1,.64,1.1l-3.913,2.259A.659.659,0,0,1,114.519,333.537Z",
    transform: "translate(-38.872 -182.683)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M119.072,330.939a.587.587,0,0,1-.551-.32.622.622,0,0,1,.231-.871l3.9-2.259a.623.623,0,0,1,.872.249.64.64,0,0,1-.231.872l-3.842,2.241a.551.551,0,0,1-.374.089Z",
    transform: "translate(-35.332 -184.727)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M123.609,328.321a.676.676,0,0,1-.551-.32.658.658,0,0,1,.231-.889l3.913-2.241a.623.623,0,0,1,.872.231.64.64,0,0,1-.231.872l-3.913,2.259a.622.622,0,0,1-.32.089Z",
    transform: "translate(-31.795 -186.769)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M128.159,325.688a.6.6,0,0,1-.551-.32.64.64,0,0,1,.231-.871l3.9-2.259a.645.645,0,1,1,.64,1.121l-3.9,2.241A.551.551,0,0,1,128.159,325.688Z",
    transform: "translate(-28.252 -188.815)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M132.718,323.058a.64.64,0,0,1-.569-.32.622.622,0,0,1,.249-.872l3.9-2.259a.645.645,0,0,1,.64,1.121l-3.9,2.259a.694.694,0,0,1-.32.071Z",
    transform: "translate(-24.718 -190.862)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M137.279,320.4a.676.676,0,0,1-.551-.32.64.64,0,0,1,.231-.871l3.877-2.17a.658.658,0,0,1,.889.231.64.64,0,0,1-.231.871l-3.913,2.259A.658.658,0,0,1,137.279,320.4Z",
    transform: "translate(-21.15 -192.864)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M141.808,317.808a.64.64,0,0,1-.569-.32.623.623,0,0,1,.249-.871l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241a.552.552,0,0,1-.32.089Z",
    transform: "translate(-17.64 -194.95)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M146.339,315.191a.676.676,0,0,1-.551-.32.658.658,0,0,1,.231-.889l3.913-2.241a.623.623,0,0,1,.872.231.64.64,0,0,1-.231.872l-3.913,2.259a.658.658,0,0,1-.32.089Z",
    transform: "translate(-14.096 -196.993)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M150.889,312.548a.587.587,0,0,1-.551-.32.64.64,0,0,1,.231-.872l3.9-2.259a.64.64,0,0,1,.872.231.6.6,0,0,1-.231.872l-3.9,2.348a.728.728,0,0,1-.32,0Z",
    transform: "translate(-10.553 -199.046)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M155.428,309.928a.64.64,0,0,1-.32-1.192l3.913-2.259a.645.645,0,0,1,.64,1.121l-3.9,2.259a.729.729,0,0,1-.338.071Z",
    transform: "translate(-7.017 -201.086)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M159.972,307.309a.658.658,0,0,1-.32-1.21l3.9-2.241a.658.658,0,0,1,.889.231.623.623,0,0,1-.249.871l-3.9,2.259A.729.729,0,0,1,159.972,307.309Z",
    transform: "translate(-3.468 -203.127)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M164.538,304.678a.64.64,0,0,1-.569-.32.622.622,0,0,1,.249-.872l3.9-2.259a.64.64,0,0,1,.872.231.658.658,0,0,1-.231.889l-3.9,2.241a.552.552,0,0,1-.32.089Z",
    transform: "translate(0.059 -205.174)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M169.069,302.06a.658.658,0,0,1-.551-.338.64.64,0,0,1,.231-.872l3.9-2.241a.642.642,0,0,1,.658,1.1l-3.913,2.259A.658.658,0,0,1,169.069,302.06Z",
    transform: "translate(3.603 -207.216)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M173.459,299.548a.587.587,0,0,1-.551-.32.64.64,0,0,1,.231-.872l3.9-2.259a.658.658,0,0,1,.889.231.64.64,0,0,1-.249.889l-3.9,2.241A.552.552,0,0,1,173.459,299.548Z",
    transform: "translate(7.021 -209.169)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M177.858,296.977a.676.676,0,0,1-.569-.32.622.622,0,0,1,.249-.871l3.9-2.259a.64.64,0,0,1,.64,1.1l-3.9,2.259a.729.729,0,0,1-.32.089Z",
    transform: "translate(10.431 -211.15)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M75.548,355.575a.64.64,0,0,1-.32-1.192l1.779-1.067a.658.658,0,1,1,.658,1.121L75.886,355.5a.658.658,0,0,1-.338.071Z",
    transform: "translate(-69.216 -164.666)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M184.88,255.243a.64.64,0,0,1-.64-.64V252.45a.64.64,0,0,1,1.281,0V254.6A.64.64,0,0,1,184.88,255.243Z",
    transform: "translate(15.912 -243.587)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M184.88,309.9a.64.64,0,0,1-.64-.64v-4.109a.64.64,0,0,1,1.281,0v4.109A.64.64,0,0,1,184.88,309.9Zm0-8.2a.64.64,0,0,1-.64-.64v-4.109a.64.64,0,1,1,1.281,0v4.109a.64.64,0,0,1-.64.676Zm0-8.2a.64.64,0,0,1-.64-.64v-4.109a.64.64,0,0,1,1.281,0v4.109a.64.64,0,0,1-.64.676Zm0-8.217a.64.64,0,0,1-.64-.64v-4.091a.64.64,0,1,1,1.281,0v4.091a.64.64,0,0,1-.64.676Zm0-8.2a.64.64,0,0,1-.64-.64v-4.091a.64.64,0,0,1,1.281,0v4.091a.64.64,0,0,1-.64.676Zm0-8.2a.64.64,0,0,1-.64-.64V264.14a.64.64,0,1,1,1.281,0v4.109a.64.64,0,0,1-.64.747Zm0-8.2a.64.64,0,0,1-.64-.64V255.94a.64.64,0,1,1,1.281,0V260.1a.64.64,0,0,1-.64.622Z",
    transform: "translate(15.912 -240.869)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M184.88,291a.64.64,0,0,1-.64-.64V288.28a.64.64,0,0,1,1.281,0v2.134A.64.64,0,0,1,184.88,291Z",
    transform: "translate(15.912 -215.687)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M183.281,258.345a.623.623,0,0,1-.32-.089.587.587,0,0,1-.32-.551v-6.581a.587.587,0,0,1,.32-.551l5.692-3.291a.587.587,0,0,1,.64,0,.623.623,0,0,1,.32.551v6.581a.622.622,0,0,1-.32.551l-5.692,3.291A.729.729,0,0,1,183.281,258.345Zm.64-6.848v5.087l4.411-2.543v-5.1Z",
    transform: "translate(14.666 -247.187)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M183.28,299a.6.6,0,0,1-.32,0,.64.64,0,0,1-.32-.569v-6.581a.6.6,0,0,1,.32-.551l5.692-3.29a.676.676,0,0,1,.64,0,.623.623,0,0,1,.32.551v6.581a.676.676,0,0,1-.32.569L183.6,299A.7.7,0,0,1,183.28,299Zm.64-6.848v5.1l4.411-2.543v-5.1Z",
    transform: "translate(14.666 -215.466)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M72.35,322.372a.658.658,0,0,1-.32,0,.622.622,0,0,1-.32-.551v-6.581a.623.623,0,0,1,.32-.551l5.692-3.29a.64.64,0,0,1,.96.551v6.581a.587.587,0,0,1-.32.551l-5.692,3.291A.729.729,0,0,1,72.35,322.372Zm.64-6.848v5.087l4.411-2.543v-5.1Z",
    transform: "translate(-71.71 -197.255)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M72.35,363.116a.658.658,0,0,1-.32-.089.676.676,0,0,1-.32-.569v-6.581a.658.658,0,0,1,.32-.551l5.692-3.291a.676.676,0,0,1,.64,0,.587.587,0,0,1,.32.551v6.563a.64.64,0,0,1-.32.569l-5.692,3.29A.729.729,0,0,1,72.35,363.116Zm.64-6.866v5.1l4.411-2.543v-5.1Z",
    transform: "translate(-71.71 -165.608)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M188.725,273.094a6.848,6.848,0,0,1-2.864,5.478c-1.583.925-2.881,0-2.881-2.17a6.865,6.865,0,0,1,2.881-5.478C187.444,270.035,188.725,271.013,188.725,273.094Z",
    transform: "translate(14.931 -228.959)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M135.435,281.089a6.9,6.9,0,0,1-2.864,5.5c-1.583.907-2.881,0-2.881-2.17a6.919,6.919,0,0,1,2.881-5.5C134.154,278.048,135.435,279.026,135.435,281.089Z",
    transform: "translate(-26.563 -222.726)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M135.435,321.816a6.848,6.848,0,0,1-2.864,5.478c-1.583.925-2.881,0-2.881-2.17a6.866,6.866,0,0,1,2.881-5.478C134.154,318.757,135.435,319.7,135.435,321.816Z",
    transform: "translate(-26.563 -191.025)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M77.787,337.234a6.9,6.9,0,0,1-2.864,5.5c-1.583.907-2.864,0-2.864-2.17a6.9,6.9,0,0,1,2.864-5.5C76.507,334.157,77.787,335.206,77.787,337.234Z",
    transform: "translate(-71.437 -179.016)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M135.544,307.109a.524.524,0,0,1-.32-.978l81.142-46.85a.534.534,0,0,1,.534.925l-81.089,46.832A.5.5,0,0,1,135.544,307.109Z",
    transform: "translate(-22.457 -237.825)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M135.523,309.91a.534.534,0,0,1-.462-.267.516.516,0,0,1,.2-.711l81.142-46.9a.551.551,0,0,1,.729.2.516.516,0,0,1-.2.711l-81.142,46.85A.5.5,0,0,1,135.523,309.91Z",
    transform: "translate(-22.436 -235.681)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M135.523,312.669a.569.569,0,0,1-.462-.267.516.516,0,0,1,.2-.712l81.142-46.85a.534.534,0,0,1,.729.2.516.516,0,0,1-.2.712L135.79,312.6a.747.747,0,0,1-.267.071Z",
    transform: "translate(-22.436 -233.495)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M135.521,315.439a.521.521,0,0,1-.267-.978l81.142-46.85a.534.534,0,0,1,.534.925l-81.142,46.832A.5.5,0,0,1,135.521,315.439Z",
    transform: "translate(-22.434 -231.338)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M135.523,318.217a.533.533,0,0,1-.462-.267.516.516,0,0,1,.2-.711l81.142-46.85a.552.552,0,0,1,.729.2.516.516,0,0,1-.2.711l-81.142,46.85a.5.5,0,0,1-.267.071Z",
    transform: "translate(-22.436 -229.171)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M135.523,310.151a.533.533,0,0,1-.462-.267.516.516,0,0,1,.2-.711l38.49-22.144a.551.551,0,0,1,.729.2.516.516,0,0,1-.2.711l-38.49,22.215A.5.5,0,0,1,135.523,310.151Z",
    transform: "translate(-22.436 -216.214)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M135.524,327.389a.551.551,0,0,1-.462-.249.534.534,0,0,1,.2-.729l81.142-46.85a.534.534,0,1,1,.534.925l-81.142,46.832a.5.5,0,0,1-.267.071Z",
    transform: "translate(-22.437 -222.034)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M135.523,330.169a.533.533,0,0,1-.462-.267.516.516,0,0,1,.2-.711l81.142-46.85a.534.534,0,0,1,.729.2.516.516,0,0,1-.2.711L135.79,330.1a.5.5,0,0,1-.267.071Z",
    transform: "translate(-22.436 -219.869)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M135.523,332.993a.569.569,0,0,1-.462-.267.516.516,0,0,1,.2-.711l81.142-46.85a.534.534,0,1,1,.534.907l-81.142,46.85a.746.746,0,0,1-.267.071Z",
    transform: "translate(-22.436 -217.712)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M135.524,324.958a.551.551,0,0,1-.462-.249.534.534,0,0,1,.2-.729l38.49-22.215a.534.534,0,1,1,.534.907l-38.49,22.215a.5.5,0,0,1-.267.071Z",
    transform: "translate(-22.437 -204.786)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M204.377,330.018a.427.427,0,0,1-.213,0,.391.391,0,0,1-.213-.374v-74.7a.445.445,0,0,1,.213-.374l60.083-34.684a.445.445,0,0,1,.427,0,.427.427,0,0,1,.213.374v74.7a.48.48,0,0,1-.213.374l-60.083,34.684Zm.427-74.9v73.743l59.229-34.2V220.916Z",
    transform: "translate(69.662 106.355)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M206.977,291.884a.373.373,0,0,1-.213,0,.445.445,0,0,1-.213-.373V254.034a.444.444,0,0,1,.213-.374L257.6,224.313a.463.463,0,0,1,.427,0,.427.427,0,0,1,.213.374v37.352a.427.427,0,0,1-.213.374L207.19,291.777Zm.427-37.547V290.71l49.98-28.868V225.469Z",
    transform: "translate(71.687 109.805)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M207.27,268.163l12.877-7.435a.307.307,0,0,1,.5.285v1.53a1.085,1.085,0,0,1-.5.854l-12.877,7.435c-.267.16-.48,0-.48-.285v-1.53a1.085,1.085,0,0,1,.48-.854Z",
    transform: "translate(71.874 138.151)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M207.27,280.086l48.308-27.818a.309.309,0,0,1,.5.285v1.53a1.1,1.1,0,0,1-.5.854L207.27,282.754c-.267.16-.48,0-.48-.285v-1.53a1.085,1.085,0,0,1,.48-.854Z",
    transform: "translate(71.874 131.564)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M207.27,286.086l48.308-27.818a.309.309,0,0,1,.5.285v1.53a1.1,1.1,0,0,1-.5.854L207.27,288.754c-.267.16-.48,0-.48-.285v-1.53a1.085,1.085,0,0,1,.48-.854Z",
    transform: "translate(71.874 136.236)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M207.27,283.086l48.308-27.818a.309.309,0,0,1,.5.285v1.53a1.1,1.1,0,0,1-.5.854L207.27,285.754c-.267.16-.48,0-.48-.285v-1.53a1.085,1.085,0,0,1,.48-.854Z",
    transform: "translate(71.874 133.9)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M243.267,247.361h0l-17.68-2.775a.445.445,0,0,1-.356-.5.409.409,0,0,1,.48-.356l17.7,2.793a.427.427,0,0,1,0,.836Z",
    transform: "translate(86.231 124.962)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M224.645,244.433h0l-17.7-2.793a.427.427,0,0,1-.356-.48.391.391,0,0,1,.48-.356l17.787,2.775a.445.445,0,0,1,.356.5.409.409,0,0,1-.569.356Z",
    transform: "translate(71.717 122.679)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M206.965,272.718a.445.445,0,0,1-.267,0,.409.409,0,0,1,0-.6l17.68-23.123a.427.427,0,0,1,.587,0,.409.409,0,0,1,0,.587l-17.626,22.962a.462.462,0,0,1-.374.178Z",
    transform: "translate(71.699 128.971)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M225.579,248.392a.534.534,0,0,1-.267-.089.445.445,0,0,1,0-.6L243.1,224.452a.431.431,0,0,1,.676.534l-17.787,23.229a.409.409,0,0,1-.409.178Z",
    transform: "translate(86.204 109.826)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M221.921,241.864A4.945,4.945,0,0,0,220,245.813c0,1.583.836,2.383,1.868,1.779a4.909,4.909,0,0,0,1.779-3.931C223.771,242.078,222.935,241.277,221.921,241.864Z",
    transform: "translate(82.16 123.362)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M227.322,239.281l-1.405.836v-.747c0-.48-.249-.711-.569-.534l-4.038,2.33a1.458,1.458,0,0,0-.551,1.174v.747l-1.423.818a3.042,3.042,0,0,0-1.156,2.437v7.239c0,.978.516,1.476,1.156,1.1l7.986-4.607a3.042,3.042,0,0,0,1.156-2.437V240.4C228.532,239.423,227.963,238.925,227.322,239.281Zm-3.984,12.006c-1.547.872-2.792-.32-2.792-2.686a7.346,7.346,0,0,1,2.793-5.905c1.53-.889,2.775.32,2.775,2.686A7.381,7.381,0,0,1,223.338,251.287Z",
    transform: "translate(80.743 121.108)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M245.947,306.016a.338.338,0,0,1-.213,0,.427.427,0,0,1-.213-.356v-74.7a.427.427,0,0,1,.213-.373l60.1-34.684a.373.373,0,0,1,.427,0,.427.427,0,0,1,.213.356v74.7a.427.427,0,0,1-.213.374l-60.1,34.684A.284.284,0,0,1,245.947,306.016Zm.427-74.9v73.725l59.247-34.2V196.913Z",
    transform: "translate(102.031 87.669)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M248.547,267.873a.48.48,0,0,1-.213,0,.427.427,0,0,1-.213-.374V230.041a.427.427,0,0,1,.213-.373l50.852-29.348a.374.374,0,0,1,.427,0,.427.427,0,0,1,.213.356v37.352a.48.48,0,0,1-.213.374L248.76,267.748A.426.426,0,0,1,248.547,267.873Zm.427-37.53v36.374l50-28.868V201.475Z",
    transform: "translate(104.056 91.111)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M248.858,244.158l12.878-7.435a.3.3,0,0,1,.5.285v1.53a1.1,1.1,0,0,1-.5.854l-12.878,7.435a.309.309,0,0,1-.5-.285v-1.53A1.138,1.138,0,0,1,248.858,244.158Z",
    transform: "translate(104.243 119.45)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M248.858,256.082l48.308-27.818a.3.3,0,0,1,.5.285v1.53a1.085,1.085,0,0,1-.5.854L248.858,258.75a.309.309,0,0,1-.5-.285v-1.53A1.138,1.138,0,0,1,248.858,256.082Z",
    transform: "translate(104.243 112.862)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M248.858,262.086l48.308-27.818a.309.309,0,0,1,.5.285v1.53a1.139,1.139,0,0,1-.5.854l-48.308,27.818a.312.312,0,0,1-.5-.285v-1.53a1.085,1.085,0,0,1,.5-.854Z",
    transform: "translate(104.243 117.548)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M248.858,259.073l48.308-27.818a.312.312,0,0,1,.5.285v1.53a1.085,1.085,0,0,1-.5.854l-48.308,27.818a.309.309,0,0,1-.5-.285v-1.53a1.139,1.139,0,0,1,.5-.854Z",
    transform: "translate(104.243 115.207)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M265.679,215.2A15.3,15.3,0,0,0,258.76,227.2c0,4.411,3.095,6.208,6.919,4a15.3,15.3,0,0,0,6.937-12.006C272.616,214.771,269.521,212.974,265.679,215.2Zm3.557,6.492-5.158,6.172c-.516.6-.925.462-.925-.32v-5.816a1.352,1.352,0,0,1,1.423-1.352l4.162.16c.854.036,1.121.551.569,1.156Z",
    transform: "translate(112.341 102.005)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M364.2,128.758a2.828,2.828,0,0,0-2.561.356L82.766,289.833a8.538,8.538,0,0,0-3.842,6.67v16.132a2.775,2.775,0,0,0,1.049,2.455c-.658-.427-6.474-3.717-7.115-4.144a2.739,2.739,0,0,1-1.1-2.472V292.341a8.5,8.5,0,0,1,3.86-6.67L354.473,124.934a2.721,2.721,0,0,1,2.757-.249C357.781,125.059,362.833,127.922,364.2,128.758Z",
    transform: "translate(-33.281 32.065)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M79.63,288.009,358.505,127.29c2.117-1.227,3.842-.231,3.842,2.223v16.132a8.537,8.537,0,0,1-3.842,6.67L79.63,313.035c-2.134,1.227-3.86.231-3.86-2.223V294.679a8.5,8.5,0,0,1,3.86-6.67Z",
    transform: "translate(-30.145 33.889)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M80.075,220.83l-7.221-4.18a7.773,7.773,0,0,0-1.138,3.806v16.132a2.739,2.739,0,0,0,1.1,2.472c.711.427,6.528,3.717,7.115,4.144a2.775,2.775,0,0,1-1.049-2.455V224.618a7.826,7.826,0,0,1,1.192-3.788Z",
    transform: "translate(-33.312 103.879)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M363.729,128.758c-1.37-.836-6.421-3.7-7.115-4.073a2.721,2.721,0,0,0-2.757.249L75.071,285.671a7.684,7.684,0,0,0-2.721,2.864l7.221,4.109a7.737,7.737,0,0,1,2.721-2.881L361.168,129.043A2.828,2.828,0,0,1,363.729,128.758Z",
    transform: "translate(-32.808 32.065)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M273.052,138.622a8.253,8.253,0,0,1-3.86,6.4l-93.451,53.947c-2.117,1.227-3.842.356-3.842-1.939a8.271,8.271,0,0,1,3.842-6.4l93.451-53.947C271.327,135.456,273.052,136.328,273.052,138.622Z",
    transform: "translate(44.707 41.179)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-2-3",
    "data-name": "freepik--gears--inject-2",
    transform: "translate(346.715 68.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M248.518,161.875,397.925,75.646c1.921-1.1,3.468-.2,3.468,2.01V212.478a7.666,7.666,0,0,1-3.468,6.012L248.518,304.719c-1.921,1.1-3.468.2-3.468-2.01V167.887A7.666,7.666,0,0,1,248.518,161.875Z",
    transform: "translate(-245.05 -75.176)",
    fill: "#e6e6e6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M300.428,139.018a9.226,9.226,0,0,0-1-1.583,5.341,5.341,0,0,0-.6-.658,6.582,6.582,0,0,0-1.779-1.37,5.693,5.693,0,0,0-1.067-.462,8.662,8.662,0,0,0-3.148-.409,6.384,6.384,0,0,0-1.156.125l-.836.16-.818.2-1.049.356-.818.338a7.833,7.833,0,0,1,0,.925v1.209c0,9.889-6.954,21.931-15.51,26.876a16,16,0,0,1-1.885.978h0a3.792,3.792,0,0,0,.107.8v.338a3.645,3.645,0,0,0,.2.872,3.97,3.97,0,0,0,.231.783,5.753,5.753,0,0,0,.285.836c.107.249.2.462.3.676a7.97,7.97,0,0,0,1.085,1.779,7.806,7.806,0,0,0,1.192,1.227h.124l.569.409h.107a5.533,5.533,0,0,0,.711.391c.249.107.534.231.8.32a9.871,9.871,0,0,0,5.994,0c.569-.178,1.174-.409,1.779-.658a11.444,11.444,0,0,0,1.779-.96c8.573-4.945,15.528-16.968,15.528-26.876a14.372,14.372,0,0,0-1.121-6.617Z",
    transform: "translate(-225.031 -28.965)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M326.056,136.377l-1.583,3.148a2.259,2.259,0,0,0,.142,1.992,18.627,18.627,0,0,1,1.779,4.038,1,1,0,0,0,1.37.64l8.182-3.682a.747.747,0,0,1,.64,0Zm-10.121-17.235-5.923-3.433a1.174,1.174,0,0,0-.427,0,2.7,2.7,0,0,0-.374,0,.5.5,0,0,0-.231,0,3.265,3.265,0,0,0-.391.3.2.2,0,0,0-.2.16l-4.838,7.186-6.1-3.557h-.125l-4.429-2.543h-.213a.961.961,0,0,0-.462.125l-6.314,3.664-.729.409h0l-1.992,1.138h-.125a1.671,1.671,0,0,0-.356.285,2.864,2.864,0,0,0-.569.854h0a1.62,1.62,0,0,0-.16.551l-.925,10.227a.517.517,0,0,1,0,.16,2.1,2.1,0,0,1-.142.551,3.362,3.362,0,0,1-.765,1.192,54.822,54.822,0,0,0-5.123,5.336,1.779,1.779,0,0,1-.765.48,1.637,1.637,0,0,1-1.049,0l-5.87-2.081a1.78,1.78,0,0,0-.445,0h-.587l-.249.125a.693.693,0,0,0-.178.142.782.782,0,0,0-.213.267l-2.775,4.8-2.935,5.087-1.049,1.779a1.459,1.459,0,0,0-.16.907h0a1.334,1.334,0,0,0,.445.818l4.731,4.091a1.534,1.534,0,0,1,.231.249,1.779,1.779,0,0,1,.32.943,2.154,2.154,0,0,1-.089.6,52.088,52.088,0,0,0-2.117,7.115,3.412,3.412,0,0,1-.569,1.138,2.775,2.775,0,0,1-.622.658l-8.378,5.905a1.156,1.156,0,0,0-.3.285c-.107.125-.178.267-.285.409h0a2.437,2.437,0,0,0-.356,1.121v10.672a.747.747,0,0,0,.32.676l10.672,6.154-3.878,7.826a1.209,1.209,0,0,0,.48,1.583l14.46,8.4h.2l-.178-.089-.96-.569a1.227,1.227,0,0,1-.5-1.6l5.461-10.992a1.617,1.617,0,0,0,.125-.445,2.347,2.347,0,0,0-.249-1.53,18.374,18.374,0,0,1-1.779-4.055.978.978,0,0,0-1.37-.64l-4.109,1.779-4.055,1.779a.747.747,0,0,1-.729,0h0a.729.729,0,0,1-.3-.676V184.187a2.134,2.134,0,0,1,.356-1.121,1.956,1.956,0,0,1,.569-.676l8.413-5.923a3.007,3.007,0,0,0,.6-.64,3.06,3.06,0,0,0,.551-1.138A56.91,56.91,0,0,1,278,167.574a1.636,1.636,0,0,0,.107-.587h0a1.779,1.779,0,0,0-.569-1.227L272.8,161.7a1.4,1.4,0,0,1-.427-.818,1.334,1.334,0,0,1,.124-.943l1.921-3.326,2.4-4.144,2.437-4.215a1.351,1.351,0,0,1,1.049-.658h0a1.3,1.3,0,0,1,.587,0l5.905,2.063a1.637,1.637,0,0,0,1.049,0,1.778,1.778,0,0,0,.765-.5,56.67,56.67,0,0,1,5.087-5.336,3.236,3.236,0,0,0,.783-1.192,2.969,2.969,0,0,0,.178-.711l.925-10.227a1.3,1.3,0,0,1,.16-.551,2.312,2.312,0,0,1,.943-1.174l1.779-.978,3.7-2.152,3.753-2.17a.765.765,0,0,1,.694,0h0a.694.694,0,0,1,.356.623l.48,4.678.427,4.251a.96.96,0,0,0,1.21.854,16.949,16.949,0,0,1,4.429-.445,2.276,2.276,0,0,0,1.281-.409,2.58,2.58,0,0,0,.5-.48l6.795-10.209a.978.978,0,0,1,.213-.249,1.227,1.227,0,0,1,1.067-.267.676.676,0,0,1,.267,0ZM295.587,213.3a.444.444,0,0,1-.142-.213,1.259,1.259,0,0,1,0-.3l-.889-8.893a.943.943,0,0,0-1.227-.854,18.533,18.533,0,0,1-4.429.445,2.312,2.312,0,0,0-1.779.872l-1.957,2.935,10.494,6.065Z",
    transform: "translate(-239.826 -43.63)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M323.464,123.528a.676.676,0,0,0-.267,0,1.227,1.227,0,0,0-1.067.267.978.978,0,0,0-.214.249l-6.794,10.209a2.581,2.581,0,0,1-.5.48,2.277,2.277,0,0,1-1.281.409,16.949,16.949,0,0,0-4.429.445.96.96,0,0,1-1.209-.854l-.427-4.251-.48-4.678a.694.694,0,0,0-.356-.623h0a.765.765,0,0,0-.694,0l-3.735,2.117-3.7,2.152-1.779.978a2.312,2.312,0,0,0-.943,1.174,1.3,1.3,0,0,0-.16.551l-.925,10.227a2.969,2.969,0,0,1-.178.711,3.237,3.237,0,0,1-.783,1.192,56.65,56.65,0,0,0-5.087,5.336,1.779,1.779,0,0,1-.765.5,1.636,1.636,0,0,1-1.049,0l-5.976-1.974a1.3,1.3,0,0,0-.587,0h0a1.352,1.352,0,0,0-1.049.658l-2.437,4.215-2.366,4.18-1.921,3.326a1.334,1.334,0,0,0-.124.943,1.4,1.4,0,0,0,.427.818l4.731,4.055a1.779,1.779,0,0,1,.569,1.227h0a1.635,1.635,0,0,1-.107.587,56.912,56.912,0,0,0-2.134,7.115,3.059,3.059,0,0,1-.551,1.138,3.007,3.007,0,0,1-.6.64l-8.413,5.923a1.958,1.958,0,0,0-.569.676,2.135,2.135,0,0,0-.356,1.121v10.672a.729.729,0,0,0,.3.676h0a.747.747,0,0,0,.729,0l4.055-1.779,4.109-1.779a.978.978,0,0,1,1.37.64,18.375,18.375,0,0,0,1.779,4.055,2.347,2.347,0,0,1,.249,1.53,1.619,1.619,0,0,1-.125.445l-5.46,10.992a1.227,1.227,0,0,0,.5,1.6l.96.569.178.089h-.2l-14.3-8.715a1.21,1.21,0,0,1-.48-1.583l3.878-7.826L252.051,188.2a.747.747,0,0,1-.32-.676V176.852a2.437,2.437,0,0,1,.356-1.12h0c.107-.142.178-.285.285-.409a1.155,1.155,0,0,1,.3-.285l8.377-5.905a2.774,2.774,0,0,0,.623-.658,3.413,3.413,0,0,0,.569-1.138,52.094,52.094,0,0,1,2.116-7.115,2.15,2.15,0,0,0,.089-.6,1.779,1.779,0,0,0-.32-.943,1.531,1.531,0,0,0-.231-.249l-4.731-4.091a1.334,1.334,0,0,1-.445-.818h0a1.458,1.458,0,0,1,.16-.907l1.049-1.779,2.935-5.087.8-1.405,2.028-3.557a1.245,1.245,0,0,1,1.494-.534h.125l5.336,1.921h0l.462.16a1.637,1.637,0,0,0,1.049,0,1.779,1.779,0,0,0,.765-.48,54.816,54.816,0,0,1,5.123-5.336,3.362,3.362,0,0,0,.765-1.192,2.1,2.1,0,0,0,.142-.551.516.516,0,0,0,0-.16l.925-10.227a1.619,1.619,0,0,1,.16-.551h0a2.865,2.865,0,0,1,.569-.854,2.931,2.931,0,0,1,.48-.374l1.992-1.138h0l.729-.409,6.314-3.664a.961.961,0,0,1,.463-.124h.213l4.429,2.543h.125l6.1,3.557,4.838-7.257c0-.089.142-.089.2-.16a3.276,3.276,0,0,1,.391-.3.5.5,0,0,1,.231,0,2.7,2.7,0,0,1,.374,0,1.174,1.174,0,0,1,.427,0l5.923,3.433Z",
    transform: "translate(-239.85 -43.677)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M280.821,174.869a1.261,1.261,0,0,1,0-.3l-.889-8.893a.943.943,0,0,0-1.227-.854,18.531,18.531,0,0,1-4.429.445,2.312,2.312,0,0,0-1.779.872l-1.956,2.935,10.494,6.065h0A.445.445,0,0,1,280.821,174.869Z",
    transform: "translate(-225.202 -5.409)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M294.3,127.32l-1.583,3.148a2.259,2.259,0,0,0,.142,1.992,18.622,18.622,0,0,1,1.779,4.038,1,1,0,0,0,1.37.64l8.182-3.682a.747.747,0,0,1,.64,0Z",
    transform: "translate(-208.067 -34.574)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M282.843,128.013a1.3,1.3,0,0,0-.16.551l-.925,10.227a2.972,2.972,0,0,1-.178.711l-13.5-7.791h0a3.74,3.74,0,0,0,.178-.534.518.518,0,0,0,0-.16l.925-10.227a2.149,2.149,0,0,1,.16-.551Z",
    transform: "translate(-227.118 -40.087)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M274.844,150.864l-13.518-7.808h0a1.779,1.779,0,0,0-.249-.907,1.528,1.528,0,0,0-.231-.249l-4.731-4.091a1.334,1.334,0,0,1-.445-.818l13.518,7.808a1.4,1.4,0,0,0,.427.818l4.731,4.055A1.778,1.778,0,0,1,274.844,150.864Z",
    transform: "translate(-236.781 -27.044)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M269.2,175.569a1.227,1.227,0,0,0,.5,1.6l.96.569h0l-14.389-8.377a1.21,1.21,0,0,1-.48-1.583l3.878-7.826,2.846,1.636h0a.747.747,0,0,0,.729,0l4.055-1.779,7.559,4.376a1.616,1.616,0,0,1-.125.445Z",
    transform: "translate(-236.789 -9.275)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M280.994,175.106h0L270.5,169.04l1.957-2.935a2.312,2.312,0,0,1,1.779-.872,18.534,18.534,0,0,0,4.429-.445.943.943,0,0,1,1.227.854l.889,8.893a1.265,1.265,0,0,0,0,.3A.445.445,0,0,0,280.994,175.106Z",
    transform: "translate(-225.233 -5.432)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M301.7,145.583c0,9.907-6.955,21.931-15.528,26.876-.623.356-1.245.676-1.779.96a10.685,10.685,0,0,1-1.779.658,9.871,9.871,0,0,1-5.994,0,2.363,2.363,0,0,1-.8-.32,5.53,5.53,0,0,1-.711-.391H275l-.569-.409h-.125a7.81,7.81,0,0,1-1.192-1.227,7.967,7.967,0,0,1-1.085-1.779c-.107-.213-.2-.427-.3-.676a5.745,5.745,0,0,1-.285-.836,3.965,3.965,0,0,1-.231-.783,5.525,5.525,0,0,0-.2-.872v-.338a3.788,3.788,0,0,1-.107-.8h0a16,16,0,0,0,1.885-.978c8.555-4.945,15.51-16.986,15.51-26.876v-1.209a7.793,7.793,0,0,0,0-.925h0l.551-.3.925-.32.818-.2.836-.16a6.388,6.388,0,0,1,1.156-.125,8.663,8.663,0,0,1,3.148.409,5.693,5.693,0,0,1,1.067.462,6.581,6.581,0,0,1,1.779,1.37,5.338,5.338,0,0,1,.6.658,9.224,9.224,0,0,1,1,1.583,14.372,14.372,0,0,1,1.512,6.545Z",
    transform: "translate(-224.914 -28.95)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M304.836,133.426a.747.747,0,0,0-.64,0l-8.182,3.682a1,1,0,0,1-1.37-.64,18.621,18.621,0,0,0-1.779-4.038,2.259,2.259,0,0,1-.142-1.992l1.583-3.148Z",
    transform: "translate(-208.059 -34.597)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M300.711,123.5a.676.676,0,0,0-.267,0,1.227,1.227,0,0,0-1.067.267,1.435,1.435,0,0,0-.213.249l-6.794,10.209a2.582,2.582,0,0,1-.5.48l-3.717-2.294-3.557-2.045-.48-4.678a.694.694,0,0,0-.356-.623h0l-2.81-1.636,4.838-7.257a1.085,1.085,0,0,1,.587-.462.5.5,0,0,1,.231,0,1.049,1.049,0,0,1,.8.107l5.923,3.433Z",
    transform: "translate(-217.096 -43.645)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M274.987,153.188a3.007,3.007,0,0,1-.6.64l-8.413,5.923a1.957,1.957,0,0,0-.569.676l-13.5-7.791a3.353,3.353,0,0,1,.285-.409,1.156,1.156,0,0,1,.3-.285l8.377-5.905a2.776,2.776,0,0,0,.623-.658Z",
    transform: "translate(-239.716 -20.511)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M282.49,120.94Z",
    transform: "translate(-215.897 -39.541)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M282.49,120.94Z",
    transform: "translate(-215.897 -39.541)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M331.176,150.463V139.791a.694.694,0,0,0-1.049-.676l-8.182,3.682a.978.978,0,0,1-1.352-.64,19.228,19.228,0,0,0-1.779-4.055,2.205,2.205,0,0,1-.125-1.974l5.46-10.992a1.263,1.263,0,0,0-.5-1.6l-5.905-3.415a1.245,1.245,0,0,0-1.636.391l-6.794,10.209a2.223,2.223,0,0,1-1.779.889,18.3,18.3,0,0,0-4.411.445.96.96,0,0,1-1.227-.872l-.907-8.893a.676.676,0,0,0-1.1-.551l-9.178,5.336a2.472,2.472,0,0,0-1.1,1.779l-.925,10.227a3.307,3.307,0,0,1-.96,1.9,56.666,56.666,0,0,0-5.087,5.336,1.779,1.779,0,0,1-1.779.516l-6.047-2.063a1.441,1.441,0,0,0-1.654.623l-6.741,11.686a1.423,1.423,0,0,0,.285,1.779l4.731,4.073a1.779,1.779,0,0,1,.462,1.779,53.924,53.924,0,0,0-2.117,7.115,3.308,3.308,0,0,1-1.192,1.779l-8.377,5.905a2.454,2.454,0,0,0-.943,1.779v10.672a.676.676,0,0,0,1.049.676l8.164-3.682a1,1,0,0,1,1.37.64,19.21,19.21,0,0,0,1.779,4.055,2.205,2.205,0,0,1,.125,1.974l-5.443,10.992a1.227,1.227,0,0,0,.48,1.6l5.923,3.415a1.21,1.21,0,0,0,1.619-.391l6.794-10.209a2.33,2.33,0,0,1,1.779-.889,17.662,17.662,0,0,0,4.429-.445.978.978,0,0,1,1.227.872l.889,8.893a.694.694,0,0,0,1.121.569l9.178-5.336a2.526,2.526,0,0,0,1.1-1.779l.907-10.227a3.558,3.558,0,0,1,.96-1.9,54.648,54.648,0,0,0,5.1-5.336,1.779,1.779,0,0,1,1.779-.516L315.488,187a1.441,1.441,0,0,0,1.654-.6l6.759-11.7a1.441,1.441,0,0,0-.3-1.779l-4.731-4.073a1.779,1.779,0,0,1-.462-1.779,54.03,54.03,0,0,0,2.134-7.115,3.38,3.38,0,0,1,1.174-1.779l8.4-5.905A2.508,2.508,0,0,0,331.176,150.463ZM295.247,183.83c-8.573,4.945-15.528.925-15.528-8.893s6.955-21.931,15.528-26.893,15.51-.925,15.51,8.893S303.82,178.868,295.247,183.83Z",
    transform: "translate(-233.99 -40.303)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M331.176,150.463V139.791a.694.694,0,0,0-1.049-.676l-8.182,3.682a.978.978,0,0,1-1.352-.64,19.228,19.228,0,0,0-1.779-4.055,2.205,2.205,0,0,1-.125-1.974l5.46-10.992a1.263,1.263,0,0,0-.5-1.6l-5.905-3.415a1.245,1.245,0,0,0-1.636.391l-6.794,10.209a2.223,2.223,0,0,1-1.779.889,18.3,18.3,0,0,0-4.411.445.96.96,0,0,1-1.227-.872l-.907-8.893a.676.676,0,0,0-1.1-.551l-9.178,5.336a2.472,2.472,0,0,0-1.1,1.779l-.925,10.227a3.307,3.307,0,0,1-.96,1.9,56.666,56.666,0,0,0-5.087,5.336,1.779,1.779,0,0,1-1.779.516l-6.047-2.063a1.441,1.441,0,0,0-1.654.623l-6.741,11.686a1.423,1.423,0,0,0,.285,1.779l4.731,4.073a1.779,1.779,0,0,1,.462,1.779,53.924,53.924,0,0,0-2.117,7.115,3.308,3.308,0,0,1-1.192,1.779l-8.377,5.905a2.454,2.454,0,0,0-.943,1.779v10.672a.676.676,0,0,0,1.049.676l8.164-3.682a1,1,0,0,1,1.37.64,19.21,19.21,0,0,0,1.779,4.055,2.205,2.205,0,0,1,.125,1.974l-5.443,10.992a1.227,1.227,0,0,0,.48,1.6l5.923,3.415a1.21,1.21,0,0,0,1.619-.391l6.794-10.209a2.33,2.33,0,0,1,1.779-.889,17.662,17.662,0,0,0,4.429-.445.978.978,0,0,1,1.227.872l.889,8.893a.694.694,0,0,0,1.121.569l9.178-5.336a2.526,2.526,0,0,0,1.1-1.779l.907-10.227a3.558,3.558,0,0,1,.96-1.9,54.648,54.648,0,0,0,5.1-5.336,1.779,1.779,0,0,1,1.779-.516L315.488,187a1.441,1.441,0,0,0,1.654-.6l6.759-11.7a1.441,1.441,0,0,0-.3-1.779l-4.731-4.073a1.779,1.779,0,0,1-.462-1.779,54.03,54.03,0,0,0,2.134-7.115,3.38,3.38,0,0,1,1.174-1.779l8.4-5.905A2.508,2.508,0,0,0,331.176,150.463ZM295.247,183.83c-8.573,4.945-15.528.925-15.528-8.893s6.955-21.931,15.528-26.893,15.51-.925,15.51,8.893S303.82,178.868,295.247,183.83Z",
    transform: "translate(-233.99 -40.303)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M266.761,131.289,263.6,129.51a1.28,1.28,0,0,0-1,.6l-2.028,3.557h0l-.8,1.405-2.935,5.087-1.049,1.779a1.459,1.459,0,0,0-.16.907h0l13.518,7.808a1.334,1.334,0,0,1,.125-.943l1.921-3.326,2.4-4.144,2.437-4.215a1.352,1.352,0,0,1,1.049-.658Z",
    transform: "translate(-236.826 -32.868)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M266.761,131.289,263.6,129.51a1.28,1.28,0,0,0-1,.6l-2.028,3.557h0l-.8,1.405-2.935,5.087-1.049,1.779a1.459,1.459,0,0,0-.16.907h0l13.518,7.808a1.334,1.334,0,0,1,.125-.943l1.921-3.326,2.4-4.144,2.437-4.215a1.352,1.352,0,0,1,1.049-.658Z",
    transform: "translate(-236.826 -32.868)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M267.6,131.585a1.779,1.779,0,0,1-1.049,0l-.462-.16h0l-5.336-1.9h-.107a1.192,1.192,0,0,0-.5,0l.178.107h0l2.988,1.779,1.014.587h0l9.32,5.336h0a1.3,1.3,0,0,1,.587,0l5.905,2.063a1.637,1.637,0,0,0,1.049,0Z",
    transform: "translate(-233.292 -32.88)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M293.1,124.309a.765.765,0,0,0-.694,0l-3.682,2.241-3.7,2.152-1.779.978a2.313,2.313,0,0,0-.943,1.174l-13.5-7.791h0a2.862,2.862,0,0,1,.569-.854,1.671,1.671,0,0,1,.356-.285h.125l1.992-1.138h0l.729-.409,6.314-3.664a.961.961,0,0,1,.462-.125h.213l4.429,2.543h.124l6.1,3.557Z",
    transform: "translate(-226.557 -42.929)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M293.1,124.309a.765.765,0,0,0-.694,0l-3.682,2.241-3.7,2.152-1.779.978a2.313,2.313,0,0,0-.943,1.174l-13.5-7.791h0a2.862,2.862,0,0,1,.569-.854,1.671,1.671,0,0,1,.356-.285h.125l1.992-1.138h0l.729-.409,6.314-3.664a.961.961,0,0,1,.462-.125h.213l4.429,2.543h.124l6.1,3.557Z",
    transform: "translate(-226.557 -42.929)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M330.04,142.313a5.069,5.069,0,0,0-3.949-3.13h-.6a7.524,7.524,0,0,0-3.557.747v1.37a22.215,22.215,0,0,1-10.085,17.466c-.391.231-.8.445-1.174.623a8.183,8.183,0,0,0,.676,2.632,5.069,5.069,0,0,0,4.731,3.184h1.049a2.092,2.092,0,0,0,.445,0,.621.621,0,0,0,.2,0h.267a14.229,14.229,0,0,0,6.545-4.233C329.719,155.244,332.156,147.026,330.04,142.313Z",
    transform: "translate(-193.955 -25.341)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M324.556,160.811a14.229,14.229,0,0,1-6.545,4.233h-.267a.622.622,0,0,1-.2,0,2.1,2.1,0,0,1-.445,0h-1a5.069,5.069,0,0,1-4.731-3.184,8.18,8.18,0,0,1-.676-2.632c.373-.178.783-.391,1.174-.623a22.215,22.215,0,0,0,10.085-17.466c0-.48,0-.943,0-1.37a7.523,7.523,0,0,1,3.557-.747h.587a5.069,5.069,0,0,1,3.949,3.13C332.133,147.151,329.7,155.368,324.556,160.811Z",
    transform: "translate(-193.931 -25.466)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M321.546,161.086l-2.6-3.931c-.16-.267-.658-.249-1.067,0a17.78,17.78,0,0,1-1.512.96l5.211,3.006a.089.089,0,0,1-.035-.036Z",
    transform: "translate(-189.516 -11.493)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M326.047,141a19.85,19.85,0,0,1-.107,2.028.725.725,0,0,0,.729.694l4.3.249a.6.6,0,0,1,.32,0Z",
    transform: "translate(-182.065 -23.922)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M314.03,159.252a9.039,9.039,0,0,1-2.188-1.281.889.889,0,0,0-1.121.2l-5.14,4.7a.853.853,0,0,1-.551.249l5.034,2.9,3.113,1.779a.463.463,0,0,1-.213-.5l1.583-7.115a.783.783,0,0,0-.516-.925Z",
    transform: "translate(-198.346 -10.798)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M309.923,187.458h.107l.3.178h0a.3.3,0,0,1-.107-.142l-2.294-5.051a.871.871,0,0,1,0-.6,1.78,1.78,0,0,1,.285-.587l4.82-5.816a2.721,2.721,0,0,0,.427-.889,1.032,1.032,0,0,0,0-.391,21.708,21.708,0,0,1,0-4.162.694.694,0,0,0-.729-.676l-4.3-.267a.562.562,0,0,1-.6-.711l2.383-7.986a1.636,1.636,0,0,1,1.067-.907l4.714-1.138a2.01,2.01,0,0,0,1.21-.872,43.427,43.427,0,0,1,2.526-4.411,1.655,1.655,0,0,0,.178-.356.744.744,0,0,0,0-.213v-.231a.906.906,0,0,0,0-.445l-1.53-5.194a1.05,1.05,0,0,1,0-.6,2.527,2.527,0,0,1,.142-.32l.231-.3,5.514-5.816c.249-.249.534-.356.729-.249h0a.284.284,0,0,1,.142.107l2.561,3.931c.178.267.658.249,1.085,0a21.522,21.522,0,0,1,3.113-1.779,2.472,2.472,0,0,0,1.1-1.067l2.7-7.293a.693.693,0,0,1,.107-.2,1.512,1.512,0,0,1,.694-.5h.3l5.016-.516h.3a.267.267,0,0,1,.178,0,.391.391,0,0,1,.213.5l-1.565,7.115a.818.818,0,0,0,.516.907,7.95,7.95,0,0,1,2.188,1.263.889.889,0,0,0,1.121-.2l5.14-4.678c.267-.231.534-.32.729-.231l-9.818-5.692a.339.339,0,0,0-.178,0c-.551-.3-1.174-.676-1.779-1.067h0l-2.01-1.138-.8-.48-1.779-1.049-.285-.178-1.405-.8a.694.694,0,0,0-.5-.089l-5.016.5a.534.534,0,0,0-.231,0h-.213l-.231.125-.16.142a.818.818,0,0,0-.249.374l-2.739,7.292a.338.338,0,0,1-.089.178,1.194,1.194,0,0,1-.2.249,1.781,1.781,0,0,1-.249.267h0a.676.676,0,0,1-.231.16l-.285.178c-.534.249-1.032.534-1.583.836l-5.336-3.042h-.089a.427.427,0,0,0-.427,0,.694.694,0,0,0-.3.2h0l-3.913,4.126-1.6,1.69a1.949,1.949,0,0,0-.249.32,3.382,3.382,0,0,0-.16.374.907.907,0,0,0,0,.427h0l1.547,5.194a1.3,1.3,0,0,1,0,.462.516.516,0,0,1,0,.16h0a2.1,2.1,0,0,1-.213.5,43.313,43.313,0,0,0-2.543,4.393,1.957,1.957,0,0,1-1.192.907l-4.713,1.138a1.512,1.512,0,0,0-1.067.872l-2.383,8a.5.5,0,0,0,.2.569s2.1,1.245,3.557,2.117l1.779.978a17,17,0,0,0,.089,2.152h0a2.439,2.439,0,0,1,0,.338,1.425,1.425,0,0,1-.124.356,3.56,3.56,0,0,1-.3.516l-5.033,6.261a1.5,1.5,0,0,0-.285.587,1.188,1.188,0,0,0,0,.32.729.729,0,0,0,0,.285l2.277,5.051a.5.5,0,0,0,.16.178h0l1.459.836c.2.125.445.249.676.409l6.136,3.557a7.607,7.607,0,0,1,.676.391l.373.213",
    transform: "translate(-203.951 -35.483)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M309.923,187.458h.107l.3.178h0a.3.3,0,0,1-.107-.142l-2.294-5.051a.871.871,0,0,1,0-.6,1.78,1.78,0,0,1,.285-.587l4.82-5.816a2.721,2.721,0,0,0,.427-.889,1.032,1.032,0,0,0,0-.391,21.708,21.708,0,0,1,0-4.162.694.694,0,0,0-.729-.676l-4.3-.267a.562.562,0,0,1-.6-.711l2.383-7.986a1.636,1.636,0,0,1,1.067-.907l4.714-1.138a2.01,2.01,0,0,0,1.21-.872,43.427,43.427,0,0,1,2.526-4.411,1.655,1.655,0,0,0,.178-.356.744.744,0,0,0,0-.213v-.231a.906.906,0,0,0,0-.445l-1.53-5.194a1.05,1.05,0,0,1,0-.6,2.527,2.527,0,0,1,.142-.32l.231-.3,5.514-5.816c.249-.249.534-.356.729-.249h0a.284.284,0,0,1,.142.107l2.561,3.931c.178.267.658.249,1.085,0a21.522,21.522,0,0,1,3.113-1.779,2.472,2.472,0,0,0,1.1-1.067l2.7-7.293a.693.693,0,0,1,.107-.2,1.512,1.512,0,0,1,.694-.5h.3l5.016-.516h.3a.267.267,0,0,1,.178,0,.391.391,0,0,1,.213.5l-1.565,7.115a.818.818,0,0,0,.516.907,7.95,7.95,0,0,1,2.188,1.263.889.889,0,0,0,1.121-.2l5.14-4.678c.267-.231.534-.32.729-.231l-9.818-5.692a.339.339,0,0,0-.178,0c-.551-.3-1.174-.676-1.779-1.067h0l-2.01-1.138-.8-.48-1.779-1.049-.285-.178-1.405-.8a.694.694,0,0,0-.5-.089l-5.016.5a.534.534,0,0,0-.231,0h-.213l-.231.125-.16.142a.818.818,0,0,0-.249.374l-2.739,7.292a.338.338,0,0,1-.089.178,1.194,1.194,0,0,1-.2.249,1.781,1.781,0,0,1-.249.267h0a.676.676,0,0,1-.231.16l-.285.178c-.534.249-1.032.534-1.583.836l-5.336-3.042h-.089a.427.427,0,0,0-.427,0,.694.694,0,0,0-.3.2h0l-3.913,4.126-1.6,1.69a1.949,1.949,0,0,0-.249.32,3.382,3.382,0,0,0-.16.374.907.907,0,0,0,0,.427h0l1.547,5.194a1.3,1.3,0,0,1,0,.462.516.516,0,0,1,0,.16h0a2.1,2.1,0,0,1-.213.5,43.313,43.313,0,0,0-2.543,4.393,1.957,1.957,0,0,1-1.192.907l-4.713,1.138a1.512,1.512,0,0,0-1.067.872l-2.383,8a.5.5,0,0,0,.2.569s2.1,1.245,3.557,2.117l1.779.978a17,17,0,0,0,.089,2.152h0a2.439,2.439,0,0,1,0,.338,1.425,1.425,0,0,1-.124.356,3.56,3.56,0,0,1-.3.516l-5.033,6.261a1.5,1.5,0,0,0-.285.587,1.188,1.188,0,0,0,0,.32.729.729,0,0,0,0,.285l2.277,5.051a.5.5,0,0,0,.16.178h0l1.459.836c.2.125.445.249.676.409l6.136,3.557a7.607,7.607,0,0,1,.676.391l.373.213",
    transform: "translate(-203.951 -35.483)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M321.546,161.086l-2.6-3.931c-.16-.267-.658-.249-1.067,0a17.78,17.78,0,0,1-1.512.96l5.211,3.006a.089.089,0,0,1-.035-.036Z",
    transform: "translate(-189.516 -11.493)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M326.047,141a19.85,19.85,0,0,1-.107,2.028.725.725,0,0,0,.729.694l4.3.249a.6.6,0,0,1,.32,0Z",
    transform: "translate(-182.065 -23.922)",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M314.03,159.252a9.039,9.039,0,0,1-2.188-1.281.889.889,0,0,0-1.121.2l-5.14,4.7a.853.853,0,0,1-.551.249l5.034,2.9,3.113,1.779a.463.463,0,0,1-.213-.5l1.583-7.115a.783.783,0,0,0-.516-.925Z",
    transform: "translate(-198.346 -10.798)",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M313.413,156.162a2.8,2.8,0,0,1-.32.551l-4.82,5.816a1.778,1.778,0,0,0-.285.587l-10.138-5.87a1.5,1.5,0,0,1,.285-.587l4.82-5.834a3.555,3.555,0,0,0,.3-.516Z",
    transform: "translate(-203.937 -16.672)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M311.188,156.671a1.477,1.477,0,0,1-.142.729l-10.156-5.852a1.424,1.424,0,0,0,.125-.356,2.449,2.449,0,0,0,0-.338h0c0-.694-.089-1.405-.089-2.134l4.749,2.739a.765.765,0,0,0,.462.16l4.3.267a.694.694,0,0,1,.729.676A21.719,21.719,0,0,0,311.188,156.671Z",
    transform: "translate(-201.57 -17.91)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M315.641,146.633a1.512,1.512,0,0,1-.64.3l-4.713,1.138a1.778,1.778,0,0,0-.872.569L299.26,142.88a1.458,1.458,0,0,1,.534-.445,1.209,1.209,0,0,1,.356-.125l4.713-1.138a1.779,1.779,0,0,0,.622-.3h0Z",
    transform: "translate(-202.839 -24.023)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M307.915,156.079a.552.552,0,0,0,.142.551l-4.749-2.739h0l-5.211-3.006h0a.5.5,0,0,1-.2-.569l2.383-8a1.247,1.247,0,0,1,.16-.3l10.174,5.852a1.1,1.1,0,0,0-.2.338Z",
    transform: "translate(-203.917 -23.135)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M303.855,134.09l10.138,5.816a.978.978,0,0,0,0,.587l1.53,5.194a1.28,1.28,0,0,1,0,.676l-10.138-5.87h0v-.16a1.3,1.3,0,0,0,0-.462l-1.547-5.194a.871.871,0,0,1,0-.516",
    transform: "translate(-199.305 -29.302)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M325.44,132.531a.907.907,0,0,0-.267.374l-2.7,7.292a1.6,1.6,0,0,1-.551.676l-10.138-5.852a1.779,1.779,0,0,0,.391-.587.338.338,0,0,0,.089-.178L315,126.964a.818.818,0,0,1,.249-.374Z",
    transform: "translate(-193.09 -35.142)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M307.915,156.079a.552.552,0,0,0,.142.551l-4.749-2.739h0l-5.211-3.006h0a.5.5,0,0,1-.2-.569l2.383-8a1.247,1.247,0,0,1,.16-.3l10.174,5.852a1.1,1.1,0,0,0-.2.338Z",
    transform: "translate(-203.917 -23.135)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M307.915,156.079a.552.552,0,0,0,.142.551l-4.749-2.739h0l-5.211-3.006h0a.5.5,0,0,1-.2-.569l2.383-8a1.247,1.247,0,0,1,.16-.3l10.174,5.852a1.1,1.1,0,0,0-.2.338Z",
    transform: "translate(-203.917 -23.135)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M299.26,142Z",
    transform: "translate(-202.839 -23.143)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M320.666,136.177h0c-.213-.142-.534,0-.783.231l-5.514,5.816a2.383,2.383,0,0,0-.391.64l-10.138-5.816a1.976,1.976,0,0,1,.142-.373,1.957,1.957,0,0,1,.249-.32l5.514-5.816a.855.855,0,0,1,.3-.213.427.427,0,0,1,.427,0h.089l5.336,3.042Z",
    transform: "translate(-199.273 -32.278)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M320.666,136.177h0c-.213-.142-.534,0-.783.231l-5.514,5.816a2.383,2.383,0,0,0-.391.64l-10.138-5.816a1.976,1.976,0,0,1,.142-.373,1.957,1.957,0,0,1,.249-.32l5.514-5.816a.855.855,0,0,1,.3-.213.427.427,0,0,1,.427,0h.089l5.336,3.042Z",
    transform: "translate(-199.273 -32.278)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M330.2,132.022a.8.8,0,0,0-.462-.089l-5.016.516a1.405,1.405,0,0,0-.836.391l-10.138-5.87.16-.142.231-.124h.213a.48.48,0,0,1,.231,0l5.016-.5a.694.694,0,0,1,.5.089Z",
    transform: "translate(-191.556 -35.452)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M330.2,132.022a.8.8,0,0,0-.462-.089l-5.016.516a1.405,1.405,0,0,0-.836.391l-10.138-5.87.16-.142.231-.124h.213a.48.48,0,0,1,.231,0l5.016-.5a.694.694,0,0,1,.5.089Z",
    transform: "translate(-191.556 -35.452)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M300.77,148.59l.285.16h0Z",
    transform: "translate(-201.663 -18.012)",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M348.843,152.895a.6.6,0,0,0-.32,0l-4.3-.249a.682.682,0,0,1-.729-.694,19.853,19.853,0,0,0,.018-2.01,16.87,16.87,0,0,0-.089-2.134,1.956,1.956,0,0,1,.462-1.263l4.82-5.834a1.263,1.263,0,0,0,.285-1.192l-2.277-5.051a.427.427,0,0,0-.142-.16h0c-.2-.089-.462,0-.729.231l-5.14,4.678a.889.889,0,0,1-1.121.2,7.948,7.948,0,0,0-2.188-1.263.818.818,0,0,1-.516-.907l1.565-7.115a.391.391,0,0,0-.214-.5.694.694,0,0,0-.48-.107l-5.016.516a1.387,1.387,0,0,0-1.1.765l-2.7,7.293a2.472,2.472,0,0,1-1.1,1.067,21.528,21.528,0,0,0-3.113,1.779c-.427.285-.907.3-1.085,0l-2.561-3.931c-.2-.267-.6-.231-.925.125l-5.514,5.816a1.441,1.441,0,0,0-.427,1.227l1.53,5.194a1.672,1.672,0,0,1-.285,1.245,43.4,43.4,0,0,0-2.526,4.411,2.01,2.01,0,0,1-1.209.872l-4.713,1.138a1.636,1.636,0,0,0-1.067.907l-2.383,7.986c-.107.374.16.694.6.711l4.3.267a.694.694,0,0,1,.729.676,21.718,21.718,0,0,0,0,4.162,2.028,2.028,0,0,1-.463,1.281l-4.82,5.816a1.37,1.37,0,0,0-.285,1.192l2.241,5.034a.3.3,0,0,0,.107.107h0a.409.409,0,0,0,.2,0,.783.783,0,0,0,.551-.249l5.14-4.7a.889.889,0,0,1,1.121-.2,9.034,9.034,0,0,0,2.188,1.281.783.783,0,0,1,.516.889l-1.583,7.115a.462.462,0,0,0,.213.5h0a.889.889,0,0,0,.5,0l5.016-.5a1.387,1.387,0,0,0,1.1-.765l2.721-7.293a2.259,2.259,0,0,1,1.085-1.067c.534-.249,1.085-.534,1.6-.836a17.8,17.8,0,0,0,1.512-.96c.409-.285.907-.3,1.067,0l2.6,3.931a.231.231,0,0,0,.107.125.676.676,0,0,0,.8-.249l5.532-5.816a1.441,1.441,0,0,0,.409-1.209l-1.53-5.194a1.779,1.779,0,0,1,.285-1.263,41.784,41.784,0,0,0,2.526-4.393,2.045,2.045,0,0,1,1.21-.907l4.713-1.138a1.512,1.512,0,0,0,1.067-.872l2.383-8a.534.534,0,0,0-.267-.623ZM330.22,168.209a14.229,14.229,0,0,1-6.545,4.233h-.267a.622.622,0,0,1-.2,0,2.1,2.1,0,0,1-.445,0h-1a5.069,5.069,0,0,1-4.731-3.184,8.184,8.184,0,0,1-.676-2.632,7.842,7.842,0,0,1-.089-1.459,22.66,22.66,0,0,1,6.225-14.229,16.719,16.719,0,0,1,3.806-3.077,12.062,12.062,0,0,1,1.263-.64,7.524,7.524,0,0,1,3.557-.747h.587a5.069,5.069,0,0,1,3.949,3.13c2.063,4.945-.374,13.162-5.514,18.6Z",
    transform: "translate(-199.524 -32.864)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M348.843,152.895a.6.6,0,0,0-.32,0l-4.3-.249a.682.682,0,0,1-.729-.694,19.853,19.853,0,0,0,.018-2.01,16.87,16.87,0,0,0-.089-2.134,1.956,1.956,0,0,1,.462-1.263l4.82-5.834a1.263,1.263,0,0,0,.285-1.192l-2.277-5.051a.427.427,0,0,0-.142-.16h0c-.2-.089-.462,0-.729.231l-5.14,4.678a.889.889,0,0,1-1.121.2,7.948,7.948,0,0,0-2.188-1.263.818.818,0,0,1-.516-.907l1.565-7.115a.391.391,0,0,0-.214-.5.694.694,0,0,0-.48-.107l-5.016.516a1.387,1.387,0,0,0-1.1.765l-2.7,7.293a2.472,2.472,0,0,1-1.1,1.067,21.528,21.528,0,0,0-3.113,1.779c-.427.285-.907.3-1.085,0l-2.561-3.931c-.2-.267-.6-.231-.925.125l-5.514,5.816a1.441,1.441,0,0,0-.427,1.227l1.53,5.194a1.672,1.672,0,0,1-.285,1.245,43.4,43.4,0,0,0-2.526,4.411,2.01,2.01,0,0,1-1.209.872l-4.713,1.138a1.636,1.636,0,0,0-1.067.907l-2.383,7.986c-.107.374.16.694.6.711l4.3.267a.694.694,0,0,1,.729.676,21.718,21.718,0,0,0,0,4.162,2.028,2.028,0,0,1-.463,1.281l-4.82,5.816a1.37,1.37,0,0,0-.285,1.192l2.241,5.034a.3.3,0,0,0,.107.107h0a.409.409,0,0,0,.2,0,.783.783,0,0,0,.551-.249l5.14-4.7a.889.889,0,0,1,1.121-.2,9.034,9.034,0,0,0,2.188,1.281.783.783,0,0,1,.516.889l-1.583,7.115a.462.462,0,0,0,.213.5h0a.889.889,0,0,0,.5,0l5.016-.5a1.387,1.387,0,0,0,1.1-.765l2.721-7.293a2.259,2.259,0,0,1,1.085-1.067c.534-.249,1.085-.534,1.6-.836a17.8,17.8,0,0,0,1.512-.96c.409-.285.907-.3,1.067,0l2.6,3.931a.231.231,0,0,0,.107.125.676.676,0,0,0,.8-.249l5.532-5.816a1.441,1.441,0,0,0,.409-1.209l-1.53-5.194a1.779,1.779,0,0,1,.285-1.263,41.784,41.784,0,0,0,2.526-4.393,2.045,2.045,0,0,1,1.21-.907l4.713-1.138a1.512,1.512,0,0,0,1.067-.872l2.383-8a.534.534,0,0,0-.267-.623ZM330.22,168.209a14.229,14.229,0,0,1-6.545,4.233h-.267a.622.622,0,0,1-.2,0,2.1,2.1,0,0,1-.445,0h-1a5.069,5.069,0,0,1-4.731-3.184,8.184,8.184,0,0,1-.676-2.632,7.842,7.842,0,0,1-.089-1.459,22.66,22.66,0,0,1,6.225-14.229,16.719,16.719,0,0,1,3.806-3.077,12.062,12.062,0,0,1,1.263-.64,7.524,7.524,0,0,1,3.557-.747h.587a5.069,5.069,0,0,1,3.949,3.13c2.063,4.945-.374,13.162-5.514,18.6Z",
    transform: "translate(-199.524 -32.864)",
    opacity: 0.45
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-2",
    transform: "translate(480.37 119.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Vehicle--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M416.527,137.243l-32.674,61.47-10.423-6.652L406,131.16Z",
    transform: "translate(-200.817 -45.393)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M366.818,189.981l30.4-17.929L386.792,165.4,356.27,183.916Z",
    transform: "translate(-214.179 -18.732)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M356.27,181.608l10.547,6.083v-5.816L356.27,175.81Z",
    transform: "translate(-214.179 -10.626)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M430.465,137.355l-5.194-2.775L392.6,196.05l-30.4,17.929V219.8l35.289-21.024Z",
    transform: "translate(-209.561 -42.73)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-2",
    transform: "translate(0 17.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M438.164,96.479a2.579,2.579,0,0,0-2.383.409L286.374,183.117a7.684,7.684,0,0,0-3.468,6.012V323.845a2.544,2.544,0,0,0,.943,2.223c-.587-.391-5.834-3.362-6.474-3.735a2.472,2.472,0,0,1-.978-2.223V185.287a7.63,7.63,0,0,1,3.468-6.012l149.3-86.247a2.472,2.472,0,0,1,2.49-.213C432.383,93.153,436.937,95.732,438.164,96.479Z",
    transform: "translate(-276.383 -92.575)",
    opacity: 0.7,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M283.678,181.347l149.247-86.14c1.921-1.1,3.468-.213,3.468,2.01V232.039a7.684,7.684,0,0,1-3.468,6.012L283.518,324.262c-1.921,1.1-3.468.213-3.468-1.992V187.448a7.63,7.63,0,0,1,3.628-6.1Z",
    transform: "translate(-273.528 -90.894)",
    opacity: 0.7,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M284.009,146.541l-6.51-3.771a7.114,7.114,0,0,0-1.014,3.433V281.025a2.473,2.473,0,0,0,.978,2.223c.64.374,5.887,3.344,6.474,3.735A2.543,2.543,0,0,1,283,284.76v-134.8A7.115,7.115,0,0,1,284.009,146.541Z",
    transform: "translate(-276.313 -53.49)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M437.645,96.479c-1.227-.747-5.781-3.326-6.35-3.664a2.472,2.472,0,0,0-2.49.213L279.5,179.276a7.008,7.008,0,0,0-2.455,2.579l6.51,3.771a7.115,7.115,0,0,1,2.455-2.6l149.247-86.14a2.579,2.579,0,0,1,2.383-.409Z",
    transform: "translate(-275.864 -92.575)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M377.885,186.432l11.81,16.595-53.36-48.539L280.13,249.7v32.852c0,2.206,1.547,3.095,3.468,1.992l149.407-86.211a7.684,7.684,0,0,0,3.468-6.012V174.266L396.7,145.63Z",
    transform: "translate(-273.466 -51.263)",
    fill: "#fafafa",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M344.231,124.442c6.955-4.02,12.593-.747,12.593,7.292a27.854,27.854,0,0,1-12.593,21.824c-6.972,4.02-12.611.765-12.611-7.275a27.854,27.854,0,0,1,12.611-21.842Z",
    transform: "translate(-233.373 -69.1)",
    fill: "#fafafa",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M434.544,96.291c.3,0,.32.783.32.872V231.984a6.119,6.119,0,0,1-2.668,4.625l-149.318,86.3a1.779,1.779,0,0,1-.747.267c-.3,0-.32-.783-.32-.872V187.482a6.065,6.065,0,0,1,2.668-4.624L433.8,96.629a1.547,1.547,0,0,1,.747-.249m0-1.6a3.13,3.13,0,0,0-1.619.462L283.518,181.471a7.63,7.63,0,0,0-3.468,6.012V322.3c0,1.565.783,2.472,1.921,2.472a3.166,3.166,0,0,0,1.547-.48l149.407-86.211a7.684,7.684,0,0,0,3.468-6.012V97.162c0-1.565-.783-2.472-1.921-2.472Z",
    transform: "translate(-273.528 -90.928)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M474.227,147.814c5.14-4.749,17.217,4.091,17.217,9.178L443.6,290.925,415.14,277.283Z",
    transform: "translate(-168.339 -33.482)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M474.227,147.814c5.14-4.749,17.217,4.091,17.217,9.178L443.6,290.925,415.14,277.283Z",
    transform: "translate(-168.339 -33.482)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M456.584,121.874c5.14-4.287,10.245-5.336,14.336-3.789h0l25.292,12.077-.587,1.6a18.819,18.819,0,0,1,3.557,8.538c2.241,12.931-4.109,30.237-14.229,38.632a18.73,18.73,0,0,1-8.093,4.215l-.6,1.672-25.239-12.059h0c-4.233-1.334-7.453-5.549-8.609-12.219C440.238,147.594,446.5,130.287,456.584,121.874Z",
    transform: "translate(-147.441 -56.1)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M456.584,121.874c5.14-4.287,10.245-5.336,14.336-3.789h0l25.292,12.077-.587,1.6a18.819,18.819,0,0,1,3.557,8.538c2.241,12.931-4.109,30.237-14.229,38.632a18.73,18.73,0,0,1-8.093,4.215l-.6,1.672-25.239-12.059h0c-4.233-1.334-7.453-5.549-8.609-12.219C440.238,147.594,446.5,130.287,456.584,121.874Z",
    transform: "translate(-147.441 -56.1)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M471.131,128.8c-10.085,8.413-16.435,25.7-14.229,38.632s12.219,16.595,22.3,8.2,16.435-25.719,14.229-38.65S481.2,120.387,471.131,128.8Z",
    transform: "translate(-136.162 -50.752)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M462.147,153.089a9.321,9.321,0,0,0,1.441,3.789c2.01,2.917,5.621,3.13,9.231.142a21.806,21.806,0,0,0,6.777-18.48c-.694-4.02-2.917-6.154-5.727-6.047a7.9,7.9,0,0,0-4.927,2.134,21.664,21.664,0,0,0-6.794,18.462Z",
    transform: "translate(-131.856 -44.359)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M462.147,153.089a9.321,9.321,0,0,0,1.441,3.789c2.01,2.917,5.621,3.13,9.231.142a21.806,21.806,0,0,0,6.777-18.48c-.694-4.02-2.917-6.154-5.727-6.047a7.9,7.9,0,0,0-4.927,2.134,21.664,21.664,0,0,0-6.794,18.462Z",
    transform: "translate(-131.856 -44.359)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M462.147,153.087a9.321,9.321,0,0,0,1.441,3.789,8.111,8.111,0,0,0,4.962-2.152,21.718,21.718,0,0,0,6.759-18.445,9.321,9.321,0,0,0-1.441-3.789,7.9,7.9,0,0,0-4.927,2.134,21.664,21.664,0,0,0-6.794,18.462Z",
    transform: "translate(-131.856 -44.358)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M407.657,136.117l83.046,18.2a8.538,8.538,0,0,0-2.721-16.844h-.3L405.345,123.24a6.479,6.479,0,0,0,2.294,12.753Z",
    transform: "translate(-180.119 -51.56)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M407.657,136.117l83.046,18.2a8.538,8.538,0,0,0-2.721-16.844h-.3L405.345,123.24a6.479,6.479,0,0,0,2.294,12.753Z",
    transform: "translate(-180.119 -51.56)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M397.186,115.61c3.664-3.041,7.293-3.842,10.192-2.7h0l17.876,9.178-.409,1.138a13.466,13.466,0,0,1,2.49,6.083c1.6,9.2-2.917,21.5-10.085,27.48a13.678,13.678,0,0,1-5.763,3.006l-.427,1.174-17.787-9.16h0c-3.024-.96-5.336-3.931-6.136-8.68C385.5,133.894,390.018,121.6,397.186,115.61Z",
    transform: "translate(-190.405 -59.991)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M397.186,115.61c3.664-3.041,7.293-3.842,10.192-2.7h0l17.876,9.178-.409,1.138a13.466,13.466,0,0,1,2.49,6.083c1.6,9.2-2.917,21.5-10.085,27.48a13.678,13.678,0,0,1-5.763,3.006l-.427,1.174-17.787-9.16h0c-3.024-.96-5.336-3.931-6.136-8.68C385.5,133.894,390.018,121.6,397.186,115.61Z",
    transform: "translate(-190.405 -59.991)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M407.455,120.855c-7.115,5.976-11.686,18.285-10.085,27.48s8.7,11.81,15.866,5.834,11.686-18.285,10.085-27.48S414.623,114.878,407.455,120.855Z",
    transform: "translate(-182.425 -55.916)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M401.053,138.169a6.831,6.831,0,0,0,1.032,2.7c1.423,2.063,4,2.223,6.563,0a15.4,15.4,0,0,0,4.82-13.126c-.5-2.864-2.081-4.393-4.073-4.3a5.585,5.585,0,0,0-3.557,1.512,15.457,15.457,0,0,0-4.784,13.215Z",
    transform: "translate(-179.402 -51.406)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M401.053,138.169a6.831,6.831,0,0,0,1.032,2.7c1.423,2.063,4,2.223,6.563,0a15.4,15.4,0,0,0,4.82-13.126c-.5-2.864-2.081-4.393-4.073-4.3a5.585,5.585,0,0,0-3.557,1.512,15.457,15.457,0,0,0-4.784,13.215Z",
    transform: "translate(-179.402 -51.406)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M401.046,138.128a6.832,6.832,0,0,0,1.032,2.7,5.763,5.763,0,0,0,3.557-1.53,15.492,15.492,0,0,0,4.838-13.126,6.635,6.635,0,0,0-1.032-2.686A5.585,5.585,0,0,0,405.884,125a15.457,15.457,0,0,0-4.838,13.127Z",
    transform: "translate(-179.395 -51.366)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M418.062,144.123l-10.547-6.136L372.76,93.253,381.3,91.51Z",
    transform: "translate(-201.339 -76.267)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M430.466,147.72l4.18-4.642L395.285,86.89,356.83,108v7.613l36.213-19.441Z",
    transform: "translate(-213.743 -79.864)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M362.156,109.448l-12.166-7.026V94.81l12.166,7.026Z",
    transform: "translate(-219.069 -73.697)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M349.99,104.053,388.427,82.94l12.184,7.026-38.455,21.113Z",
    transform: "translate(-219.069 -82.94)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M439.653,336.775v22.589l-48.362-27.907a67.591,67.591,0,0,0-2.6-17.2h0a81.982,81.982,0,0,0-2.935-8.538Z",
    transform: "translate(-191.216 90.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M507.715,260.005v114.67c-8.449,6.083-15.866,16.257-20.721,27.64h0l-7.435,4.287V374.586L373.8,317.829V206.574l21.7-12.451a6.988,6.988,0,0,1,1.316-.587,3.557,3.557,0,0,1,2.9.249L505.225,254.7h.125l.231.125.462.356.427.445a5.591,5.591,0,0,1,.658,1.156,4.025,4.025,0,0,1,.267.694l.16.676v.178a2.788,2.788,0,0,0,.089.747A3.059,3.059,0,0,1,507.715,260.005Z",
    transform: "translate(-200.529 3.022)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M373.79,206.575l105.777,61.043,21.7-12.451a4.18,4.18,0,0,1,4.144-.391h0l-105.634-60.99a4.162,4.162,0,0,0-4.233.338Z",
    transform: "translate(-200.537 3.04)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M425.3,339.745a4.25,4.25,0,0,0,1.37-2.739q.32-2.188.8-4.375a2.953,2.953,0,0,0-.16-2.134l-.427-.249c-.409-.249-.462-1.209-.089-2.277l2.757-7.986c.409-1.174,1.192-2.063,1.779-1.957s1.387-.747,1.939-1.779c.676-1.387,1.387-2.757,2.134-4.073a3.789,3.789,0,0,0,.569-2.917,3.06,3.06,0,0,1,.729-2.721l4.785-6.439c.587-.8,1.281-1.174,1.654-.943l.836.48a2.543,2.543,0,0,0,1.227-.889c.943-.96,1.9-1.868,2.9-2.721a4.2,4.2,0,0,0,1.458-2.7,3.148,3.148,0,0,1,1.494-2.383l5.514-3.184a1.138,1.138,0,0,1,1.121-.124l2.721,1.565a20.464,20.464,0,0,1,2.028-.409,2.7,2.7,0,0,0,1.956-1.779,1.9,1.9,0,0,1,1.868-1.387l4.785.925a.908.908,0,0,1,.3.125l19.281,11.045a1.334,1.334,0,0,1,.5,1.441l5.887,3.4a.979.979,0,0,1,.391.409l2.757,4.785a2.544,2.544,0,0,1-.213,2.579,3.557,3.557,0,0,0-.445,2.864,32.691,32.691,0,0,1,.783,3.451l1.957,1.138a1.53,1.53,0,0,1,.516,1.37v7.381a3.237,3.237,0,0,1-1.085,2.6,4.162,4.162,0,0,0-1.334,2.739c-.214,1.458-.48,2.935-.8,4.393a2.989,2.989,0,0,0,.16,2.152l.409.231c.391.231.427,1.192,0,2.277l-2.757,7.986c-.409,1.174-1.156,2.063-1.672,1.957s-1.334.765-1.885,1.9c-.676,1.405-1.405,2.81-2.17,4.162a3.807,3.807,0,0,0-.6,2.864c.3.5,0,1.69-.747,2.65l-4.785,6.439c-.6.818-1.3,1.21-1.654,1l-.729-.409a2.544,2.544,0,0,0-1.37.8,40.254,40.254,0,0,1-2.988,2.81,4.109,4.109,0,0,0-1.458,2.6,3.041,3.041,0,0,1-1.476,2.259l-5.532,3.184a1.21,1.21,0,0,1-1.138.16l-2.472-1.423a18.58,18.58,0,0,1-2.33.463,2.6,2.6,0,0,0-1.921,1.654,1.779,1.779,0,0,1-1.779,1.281l-4.767-.907a1.1,1.1,0,0,1-.338-.124l-19.227-11.046a1.3,1.3,0,0,1-.516-1.441l-5.816-3.4a1.281,1.281,0,0,1-.427-.445l-2.757-4.785a2.526,2.526,0,0,1,.2-2.543,3.646,3.646,0,0,0,.427-2.846,32.4,32.4,0,0,1-.783-3.557h0l-1.921-1.1a1.583,1.583,0,0,1-.516-1.387v-7.381a3.308,3.308,0,0,1,1.1-2.543Z",
    transform: "translate(-161.298 74.878)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M435,355.953v-7.381a3.308,3.308,0,0,1,1.1-2.615,4.252,4.252,0,0,0,1.369-2.739q.32-2.188.8-4.375c.249-1.174,0-2.241-.462-2.33s-.623-1.156-.213-2.33l2.757-7.986c.427-1.192,1.192-2.063,1.779-1.957s1.387-.747,1.939-1.885,1.387-2.739,2.134-4.055a3.557,3.557,0,0,0,.569-2.917,3.113,3.113,0,0,1,.729-2.721l4.785-6.439c.711-.96,1.547-1.3,1.779-.765s1.192.3,1.974-.48,1.9-1.868,2.9-2.721a4.252,4.252,0,0,0,1.459-2.7,3.148,3.148,0,0,1,1.494-2.383l5.532-3.184c.818-.48,1.476-.178,1.476.658a1.032,1.032,0,0,0,1.459,1.014,23.314,23.314,0,0,1,2.917-.64,2.7,2.7,0,0,0,1.957-1.779,1.779,1.779,0,0,1,1.779-1.387l4.785.925c.711.142,1.032.978.711,1.868a1.974,1.974,0,0,0,.569,2.259,14.372,14.372,0,0,1,2.152,1.6,1.3,1.3,0,0,0,1.939-.356,1,1,0,0,1,1.779,0l2.757,4.785a2.544,2.544,0,0,1-.214,2.579,3.557,3.557,0,0,0-.445,2.864,32.692,32.692,0,0,1,.783,3.451c.178.978.765,1.512,1.37,1.174s1.1.249,1.1,1.334v7.381a3.237,3.237,0,0,1-1.085,2.6,4.252,4.252,0,0,0-1.352,2.739c-.2,1.458-.462,2.935-.783,4.393-.249,1.192,0,2.241.445,2.348s.587,1.138.178,2.312l-2.757,7.986c-.409,1.174-1.156,2.063-1.672,1.957s-1.334.765-1.885,1.9c-.676,1.405-1.405,2.81-2.17,4.162a3.806,3.806,0,0,0-.6,2.864c.3.5,0,1.69-.747,2.65l-4.785,6.439c-.711.961-1.53,1.334-1.779.836s-1.156-.231-1.939.551a40.2,40.2,0,0,1-2.988,2.81,4.109,4.109,0,0,0-1.459,2.6,3.042,3.042,0,0,1-1.476,2.259l-5.532,3.184c-.818.48-1.494.231-1.494-.534s-.658-1.156-1.459-.907a18.734,18.734,0,0,1-2.988.64,2.6,2.6,0,0,0-1.921,1.654,1.779,1.779,0,0,1-1.779,1.281l-4.82-.943a1.263,1.263,0,0,1-.765-1.779,1.779,1.779,0,0,0-.6-2.17,15.9,15.9,0,0,1-2.17-1.654,1.245,1.245,0,0,0-1.8.267.925.925,0,0,1-1.672,0l-2.757-4.785a2.526,2.526,0,0,1,.2-2.543,3.557,3.557,0,0,0,.427-2.846,34.277,34.277,0,0,1-.783-3.557c-.213-1.3-.747-1.53-1.352-1.174S435,357.038,435,355.953Z",
    transform: "translate(-152.877 79.729)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M444.59,288.1l16.47,9.462h0a.854.854,0,0,1,.356.783,1.032,1.032,0,0,0,1.459,1.014l.925-.249c.676-.16,1.334-.3,1.992-.391a2.206,2.206,0,0,0,1.192-.64L447.721,287.02a2.188,2.188,0,0,1-1.209.64C445.924,287.82,445.319,287.945,444.59,288.1Z",
    transform: "translate(-145.408 75.968)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M438.15,292.2l19.3,11.063a3.557,3.557,0,0,0,.587-1.69,2.7,2.7,0,0,1,.409-1.3L439.164,289.23a2.544,2.544,0,0,0-.427,1.3,3.4,3.4,0,0,1-.587,1.672Z",
    transform: "translate(-150.423 77.689)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M435.28,295.441l18.338,10.547h.107a.516.516,0,0,1,.2.2.587.587,0,0,0,.658.267,2.508,2.508,0,0,0,1.316-.765c.943-.96,1.921-1.868,2.9-2.721a4.539,4.539,0,0,0,.889-1.032l-19.3-11.063a4.966,4.966,0,0,1-.872,1.032c-1,.836-1.956,1.779-2.917,2.721A2.3,2.3,0,0,1,435.28,295.441Z",
    transform: "translate(-152.657 78.966)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M427.81,308.3l19.281,11.045a.783.783,0,0,1,.64-.231c.534.107,1.387-.747,1.939-1.868s1.387-2.757,2.134-4.091a3.664,3.664,0,0,0,.569-2.9,1.138,1.138,0,0,1-.107-.711L432.986,298.48a1.121,1.121,0,0,0,.107.712,3.717,3.717,0,0,1-.569,2.917c-.765,1.316-1.459,2.668-2.134,4.055s-1.405,1.992-1.939,1.885a.854.854,0,0,0-.64.249Z",
    transform: "translate(-158.474 84.891)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M447.091,315.119l-19.281-11.01a.854.854,0,0,1,.64-.249.8.8,0,0,0,.285,0l19.281,10.921a.551.551,0,0,1-.285,0A.782.782,0,0,0,447.091,315.119Z",
    transform: "translate(-158.474 89.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M430.835,299.171a1.121,1.121,0,0,1-.107-.711l19.281,11.063a1.138,1.138,0,0,0,.107.711,1.778,1.778,0,0,1,.089,1.014l-19.281-11.063A1.778,1.778,0,0,0,430.835,299.171Z",
    transform: "translate(-156.216 84.876)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M424.4,320.967l19.316,11.045a1.921,1.921,0,0,1,.694-.889,4.18,4.18,0,0,0,1.37-2.739c.213-1.458.48-2.9.8-4.375a2.739,2.739,0,0,0-.2-2.17h0l-.249-.142-.213-.125L427.157,310.9a2.864,2.864,0,0,1,.16,2.134c-.32,1.459-.587,2.935-.8,4.375a4.215,4.215,0,0,1-1.37,2.739,2.152,2.152,0,0,0-.747.818Z",
    transform: "translate(-161.129 94.562)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M425.129,316.486a2.525,2.525,0,0,0,.818-1l19.281,11.045a2.437,2.437,0,0,1-.818,1.014,1.921,1.921,0,0,0-.694.889L424.4,317.393A2.152,2.152,0,0,1,425.129,316.486Z",
    transform: "translate(-161.129 98.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M425.53,330.431l19.281,11.063a2.207,2.207,0,0,1,.409-.978,3.147,3.147,0,0,0,.5-1.352,3.236,3.236,0,0,0,0-1.494,32.393,32.393,0,0,1-.783-3.557h0c-.178-.96-.747-1.494-1.352-1.156a.534.534,0,0,1-.64,0l-17.289-9.907h0c.213,1.227.48,2.4.783,3.557a3.557,3.557,0,0,1-.445,2.846,2.188,2.188,0,0,0-.462.978Z",
    transform: "translate(-160.249 104.023)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M445.22,338.219a2.206,2.206,0,0,0-.409.978L425.53,328.134a2.187,2.187,0,0,1,.391-.978,2.706,2.706,0,0,0,.445-1.156l19.281,11.046A3.076,3.076,0,0,1,445.22,338.219Z",
    transform: "translate(-160.249 106.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M462.414,295.788a15.326,15.326,0,0,1,2.134,1.619,1.3,1.3,0,0,0,1.939-.373,1,1,0,0,1,1.263-.445h0L462,293.28a1.866,1.866,0,0,0-.089.338,1.9,1.9,0,0,0,.5,2.17Z",
    transform: "translate(-132.034 80.843)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M431.233,334.341h0a2.712,2.712,0,0,1,.356.2l18.64,10.672.16.089a1.387,1.387,0,0,1-.391-1.619,1.779,1.779,0,0,0-.587-2.17,13.6,13.6,0,0,1-2.188-1.654,1.227,1.227,0,0,0-1.761.338,1,1,0,0,1-1.085.48l-.213-.125L430.77,332.9a1.263,1.263,0,0,0,.462,1.441Z",
    transform: "translate(-156.223 111.693)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M448.13,338.725l2.455,1.423a.729.729,0,0,1-.32-.694c0-.765-.676-1.156-1.476-.925Z",
    transform: "translate(-142.651 116.024)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M457.39,332.777l.569.32h0A.462.462,0,0,0,457.39,332.777Z",
    transform: "translate(-135.441 111.584)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M467,303.07c.16.978.765,1.512,1.352,1.156a.64.64,0,0,1,.5,0l-.16-.089-.267-.16Z",
    transform: "translate(-127.958 88.466)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M446.4,288.023l19.263,11.063a2.722,2.722,0,0,0,.783-1.138,2.258,2.258,0,0,1,.818-1.1l-19.3-11.045a2.118,2.118,0,0,0-.818,1.1A2.953,2.953,0,0,1,446.4,288.023Z",
    transform: "translate(-143.999 75.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M427.93,348.173c0,11.97,4,20.4,10.281,24.03l4.251,2.437c-6.19-3.682-10.1-12.077-10.1-23.941,0-21.86,13.287-47.277,29.686-56.739,7.115-4.091,13.589-4.536,18.694-1.974l-3.646-2.1c-5.229-3.041-12.024-2.757-19.458,1.547C441.234,300.9,427.93,326.313,427.93,348.173Z",
    transform: "translate(-158.38 76.624)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M430.42,349.607c0,11.864,3.913,20.241,10.1,23.923l1.3.676c-6.19-3.664-8.538-11.081-8.538-22.945,0-21.86,13.3-47.277,29.686-56.739,7.346-4.251,12.451-5.532,17.68-2.632l-1.779-1.014c-5.1-2.561-11.615-2.117-18.694,1.974C443.707,302.313,430.42,327.73,430.42,349.607Z",
    transform: "translate(-156.441 77.732)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M447.28,285.89l19.3,11.028a1.334,1.334,0,0,1,1.032-.285l1.974.373,2.81.551a.673.673,0,0,1,.178,0l-.3-.2-17.52-10.032-.409-.231-.409-.249-.16-.089-.213-.125h-.445l-4.8-.907A1.28,1.28,0,0,0,447.28,285.89Z",
    transform: "translate(-143.313 74.928)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M438.72,291.195,458,302.24a3.219,3.219,0,0,1,1.067-1.067l5.532-3.184a1.156,1.156,0,0,1,1.032-.178l-16.47-9.462-1.779-1-.622-.373-.338-.2a1.209,1.209,0,0,0-1.121.142l-5.514,3.2A3.059,3.059,0,0,0,438.72,291.195Z",
    transform: "translate(-149.979 75.724)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M430.72,302.6,450,313.665a4.393,4.393,0,0,1,.836-2.01l4.785-6.439c.534-.729,1.156-1.1,1.547-1l-18.338-10.547-.818-.462c-.409-.231-1.067.125-1.672.925l-4.8,6.474A4.179,4.179,0,0,0,430.72,302.6Z",
    transform: "translate(-156.208 80.734)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M425.8,315.9l.124.089.356.2,18.765,10.672a2.49,2.49,0,0,1,0-2.206l2.757-7.986a3.948,3.948,0,0,1,1.085-1.779L429.6,304a3.735,3.735,0,0,0-1.067,1.779l-2.775,7.968C425.406,314.672,425.424,315.615,425.8,315.9Z",
    transform: "translate(-160.268 89.19)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M424.2,318.309v7.364a1.583,1.583,0,0,0,.516,1.387l1.921,1.1,17.289,9.907a1.779,1.779,0,0,1-.427-1.334v-7.381a3.878,3.878,0,0,1,.391-1.779h0L424.569,316.53a4.163,4.163,0,0,0-.374,1.779Z",
    transform: "translate(-161.298 98.946)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M425.788,328.757l2.757,4.785a1.032,1.032,0,0,0,.427.445l1.3.747.48.267,4.055,2.348L448.2,345a1.315,1.315,0,0,1-.445-.373L445,339.839a2.437,2.437,0,0,1-.213-1.565L425.5,327.21a2.312,2.312,0,0,0,.285,1.547Z",
    transform: "translate(-160.294 107.262)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M442.42,336.239c0-12.166,7.4-26.306,16.524-31.571s16.524.32,16.524,12.451-7.4,26.306-16.524,31.571S442.42,348.405,442.42,336.239Z",
    transform: "translate(-147.098 88.166)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 20.561,
    cy: 11.632,
    rx: 20.561,
    ry: 11.632,
    transform: "matrix(0.392, -0.92, 0.92, 0.392, 293.082, 429.216)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M446.43,327.581c0-6.9,4.215-14.941,9.391-17.947s9.391.2,9.391,7.115-4.2,14.941-9.391,17.947S446.43,334.5,446.43,327.581Z",
    transform: "translate(-143.975 92.697)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M448.68,322.75a12.948,12.948,0,0,1,5.336-10.316c2.988-1.779,5.336.107,5.336,4.073a12.913,12.913,0,0,1-5.336,10.316C451.028,328.549,448.68,326.717,448.68,322.75Z",
    transform: "translate(-142.223 95.234)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M451.38,314.16a1.441,1.441,0,0,1,.587-1.121c.32-.178.587,0,.587.445a1.405,1.405,0,0,1-.587,1.121C451.647,314.8,451.38,314.605,451.38,314.16Z",
    transform: "translate(-140.121 96.176)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M450.076,316.265c-.231-.178-.231-.676,0-1.121s.6-.64.836-.48.231.676,0,1.121S450.361,316.425,450.076,316.265Z",
    transform: "translate(-141.271 97.45)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M449.917,318.528c-.32.178-.587,0-.587-.445a1.4,1.4,0,0,1,.587-1.121c.32-.2.587,0,.587.445a1.441,1.441,0,0,1-.587,1.121Z",
    transform: "translate(-141.717 99.225)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M450.942,319.639c-.231.445-.6.658-.836.48s-.231-.676,0-1.1.6-.658.836-.48S451.173,319.195,450.942,319.639Z",
    transform: "translate(-141.248 100.462)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M452.514,318.958a1.441,1.441,0,0,1-.587,1.121c-.32.178-.587,0-.587-.445a1.405,1.405,0,0,1,.587-1.121C452.318,318.318,452.514,318.513,452.514,318.958Z",
    transform: "translate(-140.152 100.431)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M453.842,316.854c.213.178.213.676,0,1.121s-.6.64-.836.48-.231-.676,0-1.121S453.611,316.694,453.842,316.854Z",
    transform: "translate(-138.99 99.156)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M454.017,314.59c.32-.178.587,0,.587.445a1.4,1.4,0,0,1-.587,1.121c-.32.2-.587,0-.587-.445A1.441,1.441,0,0,1,454.017,314.59Z",
    transform: "translate(-138.525 97.382)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M453.006,313.478c.231-.445.6-.658.836-.48s.213.676,0,1.1-.6.658-.836.48S452.775,313.922,453.006,313.478Z",
    transform: "translate(-138.99 96.147)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M450.49,318.829a5.194,5.194,0,0,1,2.17-4.162c1.209-.694,2.188,0,2.188,1.654a5.212,5.212,0,0,1-2.188,4.162C451.4,321.177,450.49,320.448,450.49,318.829Z",
    transform: "translate(-140.814 97.288)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M454.064,310.83h0a78.648,78.648,0,0,0-3.148,8.893,66.558,66.558,0,0,0-2.81,17.217L416.09,355.474V332.8l30.611-17.68Z",
    transform: "translate(-167.6 94.508)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    width: 10.281,
    height: 10.281,
    transform: "translate(171.777 438.19) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M454.1,310.83h0a78.642,78.642,0,0,0-3.148,8.893l-34.9,20.045V332.8l30.611-17.68Z",
    transform: "translate(-167.631 94.508)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M461.416,233.295v114.67c-8.449,6.083-15.866,16.257-20.721,27.64h0l-7.435,4.287V240.925l21.682-12.54a4.607,4.607,0,0,1,3.4-.658,2.849,2.849,0,0,1,.587.2h.124l.231.125.462.356.427.445a4.89,4.89,0,0,1,.658,1.156,4.016,4.016,0,0,1,.267.694l.16.676v.178a2.787,2.787,0,0,0,.089.747A3.555,3.555,0,0,1,461.416,233.295Z",
    transform: "translate(-154.23 29.733)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M461.416,233.295v114.67c-8.449,6.083-15.866,16.257-20.721,27.64h0l-7.435,4.287V240.925l21.682-12.54a4.607,4.607,0,0,1,3.4-.658,2.849,2.849,0,0,1,.587.2h.124l.231.125.462.356.427.445a4.89,4.89,0,0,1,.658,1.156,4.016,4.016,0,0,1,.267.694l.16.676v.178a2.787,2.787,0,0,0,.089.747A3.555,3.555,0,0,1,461.416,233.295Z",
    transform: "translate(-154.23 29.733)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M431.76,236.64l2.668-1.53V374.094l-2.668,1.53Z",
    transform: "translate(-155.398 35.548)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M436.32,327.208V245.069a6.172,6.172,0,0,1,2.579-4.927l12.451-7.115c1.423-.818,2.579,0,2.579,1.957v82.138a6.208,6.208,0,0,1-2.579,4.945L438.9,329.182C437.529,330,436.32,329.111,436.32,327.208Z",
    transform: "translate(-151.847 33.682)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M461.416,285.11,433.26,301.367v1.708l28.156-16.257Z",
    transform: "translate(-154.23 74.481)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M433.424,337.655,393.76,314.764l17.626-10.174,39.664,22.891Z",
    transform: "translate(-184.987 89.649)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M315.249,341.918a4.98,4.98,0,0,0,1.636-3.273c.249-1.779.569-3.468.943-5.194a3.414,3.414,0,0,0-.178-2.561l-.516-.3c-.48-.285-.551-1.423-.107-2.7l3.308-9.516c.48-1.405,1.387-2.455,2.028-2.33s1.654-.889,2.312-2.241c.8-1.636,1.654-3.255,2.543-4.838a4.446,4.446,0,0,0,.694-3.557,3.557,3.557,0,0,1,.854-3.219l5.709-7.684c.711-.96,1.512-1.405,1.974-1.138l1,.569a2.935,2.935,0,0,0,1.583-.925c1.121-1.138,2.277-2.223,3.451-3.237a4.963,4.963,0,0,0,1.779-3.219,3.718,3.718,0,0,1,1.779-2.828l6.581-3.806a1.387,1.387,0,0,1,1.334-.16l3.237,1.868c.818-.2,1.619-.356,2.4-.462a3.308,3.308,0,0,0,2.348-2.134,2.241,2.241,0,0,1,2.206-1.654l5.71,1.1a1.174,1.174,0,0,1,.374.142l22.962,13.18a1.565,1.565,0,0,1,.6,1.779l7.008,4.038a1.263,1.263,0,0,1,.462.5l3.291,5.709a3.024,3.024,0,0,1-.249,3.059,4.322,4.322,0,0,0-.551,3.415,35.885,35.885,0,0,1,.96,4.126l2.33,1.334a1.9,1.9,0,0,1,.6,1.654v8.769a3.842,3.842,0,0,1-1.3,3.113,4.98,4.98,0,0,0-1.6,3.255c-.249,1.779-.551,3.557-.925,5.247a3.557,3.557,0,0,0,.16,2.543l.5.285c.48.285.534,1.423,0,2.721l-3.29,9.5c-.48,1.423-1.37,2.472-1.992,2.348s-1.583.907-2.241,2.259c-.818,1.69-1.672,3.344-2.579,4.962a4.482,4.482,0,0,0-.729,3.4c.356.6,0,2.028-.889,3.166l-5.71,7.684c-.711.96-1.53,1.423-1.974,1.174l-.854-.5a3.1,3.1,0,0,0-1.619.978c-1.174,1.174-2.348,2.295-3.557,3.344a4.945,4.945,0,0,0-1.779,3.095,3.558,3.558,0,0,1-1.779,2.686l-6.581,3.789a1.441,1.441,0,0,1-1.37.2l-2.935-1.69a23.124,23.124,0,0,1-2.775.551,3.113,3.113,0,0,0-2.294,1.974,2.117,2.117,0,0,1-2.17,1.512l-5.692-1.1a.942.942,0,0,1-.391-.142l-22.962-13.162a1.547,1.547,0,0,1-.6-1.779l-6.972-4.02a1.547,1.547,0,0,1-.5-.516l-3.219-5.621a3.059,3.059,0,0,1,.231-3.042,4.269,4.269,0,0,0,.516-3.379,39.754,39.754,0,0,1-.925-4.162h0l-2.277-1.316a1.867,1.867,0,0,1-.6-1.654v-8.787a3.931,3.931,0,0,1,1.281-3.166Z",
    transform: "translate(-247.132 68.454)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M326.862,361.227V352.44a3.877,3.877,0,0,1,1.316-3.113,5.052,5.052,0,0,0,1.636-3.273c.249-1.779.569-3.557.943-5.194.32-1.423.089-2.668-.534-2.793s-.747-1.37-.267-2.775l3.29-9.516c.5-1.405,1.405-2.455,2.045-2.33s1.654-.889,2.312-2.241c.8-1.654,1.654-3.273,2.543-4.838a4.447,4.447,0,0,0,.676-3.557,3.664,3.664,0,0,1,.871-3.219l5.692-7.684c.854-1.156,1.779-1.547,2.223-.907s1.405.356,2.348-.587,2.277-2.223,3.451-3.237a4.963,4.963,0,0,0,1.779-3.219,3.717,3.717,0,0,1,1.779-2.828l6.581-3.806c.978-.569,1.779-.213,1.779.783a1.227,1.227,0,0,0,1.779,1.209,23.82,23.82,0,0,1,3.468-.747,3.326,3.326,0,0,0,2.348-2.134,2.241,2.241,0,0,1,2.206-1.654l5.709,1.1c.836.16,1.227,1.174.854,2.241a2.312,2.312,0,0,0,.676,2.686,18.734,18.734,0,0,1,2.561,1.9,1.512,1.512,0,0,0,2.294-.427c.64-.854,1.565-.871,2.045,0L394.558,298a3.023,3.023,0,0,1-.249,3.059,4.322,4.322,0,0,0-.551,3.415,35.9,35.9,0,0,1,.96,4.126c.2,1.156.907,1.779,1.636,1.37s1.3.3,1.3,1.619v8.769a3.841,3.841,0,0,1-1.3,3.113,4.98,4.98,0,0,0-1.6,3.255c-.249,1.779-.551,3.557-.925,5.247-.3,1.405-.107,2.65.516,2.775s.711,1.352.213,2.775l-3.415,9.551c-.48,1.423-1.37,2.472-1.992,2.348s-1.583.907-2.241,2.259c-.818,1.69-1.672,3.344-2.579,4.962a4.482,4.482,0,0,0-.729,3.4c.356.6,0,2.028-.889,3.166L377,370.885c-.854,1.138-1.779,1.583-2.152.978s-1.37-.267-2.294.676-2.348,2.294-3.557,3.344a4.945,4.945,0,0,0-1.779,3.095,3.558,3.558,0,0,1-1.779,2.686l-6.581,3.789c-.978.569-1.779.285-1.779-.64s-.783-1.352-1.779-1.085a22.476,22.476,0,0,1-3.557.783,3.113,3.113,0,0,0-2.294,1.974,2.117,2.117,0,0,1-2.17,1.512l-5.692-1.1c-.854-.16-1.263-1.1-.907-2.117a2.206,2.206,0,0,0-.711-2.579,18.194,18.194,0,0,1-2.6-1.974,1.476,1.476,0,0,0-2.241.338,1.1,1.1,0,0,1-1.992,0l-3.291-5.71a3.024,3.024,0,0,1,.231-3.042,4.34,4.34,0,0,0,.516-3.379,39.714,39.714,0,0,1-.943-4.162c-.2-1.156-.889-1.779-1.6-1.387S326.862,362.525,326.862,361.227Z",
    transform: "translate(-237.081 74.224)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M338.25,280.368l19.565,11.259h.107a1.1,1.1,0,0,1,.409.943,1.245,1.245,0,0,0,1.779,1.227c.374-.125.729-.213,1.1-.3a19.128,19.128,0,0,1,2.366-.462,2.738,2.738,0,0,0,1.423-.765l-22.945-13.2a2.74,2.74,0,0,1-1.441.765C339.851,280.013,339.068,280.173,338.25,280.368Z",
    transform: "translate(-228.21 69.778)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M330.58,285.24l22.98,13.18a4.073,4.073,0,0,0,.694-2.01,3.023,3.023,0,0,1,.516-1.547L331.79,281.7a2.97,2.97,0,0,0-.516,1.547,4.2,4.2,0,0,1-.694,1.992Z",
    transform: "translate(-234.183 71.826)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M327.16,289.111,349,301.668h.142a.48.48,0,0,1,.231.231.676.676,0,0,0,.783.3,2.793,2.793,0,0,0,1.565-.907c1.121-1.138,2.277-2.223,3.468-3.237a4.977,4.977,0,0,0,1.032-1.227l-22.98-13.18a5.889,5.889,0,0,1-1.049,1.227c-1.174,1.014-2.33,2.081-3.468,3.237A2.829,2.829,0,0,1,327.16,289.111Z",
    transform: "translate(-236.846 73.344)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M318.25,304.386l23,13.162a.96.96,0,0,1,.747-.267c.64.125,1.654-.889,2.312-2.241.8-1.654,1.654-3.273,2.543-4.856a4.3,4.3,0,0,0,.676-3.468,1.406,1.406,0,0,1-.124-.854L324.44,292.7a1.245,1.245,0,0,0,.124.836,4.5,4.5,0,0,1-.676,3.557c-.907,1.565-1.779,3.184-2.543,4.838-.676,1.352-1.672,2.366-2.33,2.241A1,1,0,0,0,318.25,304.386Z",
    transform: "translate(-243.783 80.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M341.248,312.558l-23-13.162a1,1,0,0,1,.765-.285.623.623,0,0,0,.356,0l22.98,13.162a.64.64,0,0,1-.356,0,.961.961,0,0,0-.747.285Z",
    transform: "translate(-243.783 85.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M321.865,293.536a1.246,1.246,0,0,1-.125-.836L344.7,305.862a1.405,1.405,0,0,0,.125.854,2.045,2.045,0,0,1,.107,1.227l-22.98-13.2a2.133,2.133,0,0,0-.089-1.209Z",
    transform: "translate(-241.084 80.391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M314.2,319.547l23,13.162a2.241,2.241,0,0,1,.836-1.049,4.962,4.962,0,0,0,1.619-3.273c.267-1.779.587-3.451.96-5.194a3.166,3.166,0,0,0-.231-2.6h0l-.3-.178-.267-.16L317.4,307.47a3.379,3.379,0,0,1,.2,2.526c-.391,1.779-.694,3.557-.96,5.211A5.052,5.052,0,0,1,315,318.48,2.544,2.544,0,0,0,314.2,319.547Z",
    transform: "translate(-246.937 91.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M315.054,314.19a2.792,2.792,0,0,0,.978-1.21l22.98,13.18a3.023,3.023,0,0,1-.978,1.209,2.241,2.241,0,0,0-.836,1.049l-23-13.162A2.544,2.544,0,0,1,315.054,314.19Z",
    transform: "translate(-246.937 96.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M315.54,330.787l22.962,13.18a3.007,3.007,0,0,1,.5-1.174,3.558,3.558,0,0,0,.587-1.6,3.9,3.9,0,0,0,0-1.779,40.766,40.766,0,0,1-.943-4.162h0c-.2-1.156-.889-1.779-1.6-1.387a.676.676,0,0,1-.765,0L315.593,322h0a42.313,42.313,0,0,0,.943,4.162,4.2,4.2,0,0,1-.516,3.379,2.65,2.65,0,0,0-.48,1.245Z",
    transform: "translate(-245.893 103.205)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M339,340.1a3.006,3.006,0,0,0-.5,1.174l-22.962-13.18a2.649,2.649,0,0,1,.48-1.174,3.557,3.557,0,0,0,.569-1.458l22.962,13.162A3.557,3.557,0,0,1,339,340.1Z",
    transform: "translate(-245.894 105.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M359.518,289.526a17.364,17.364,0,0,1,2.543,1.921,1.547,1.547,0,0,0,2.312-.445,1.192,1.192,0,0,1,1.494-.534h-.089l-6.848-3.949a2.521,2.521,0,0,0-.089.391A2.277,2.277,0,0,0,359.518,289.526Z",
    transform: "translate(-212.304 75.579)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M322.388,335.463h0l.427.249L345.1,348.447l.2.089a1.6,1.6,0,0,1-.462-1.921,2.205,2.205,0,0,0-.711-2.579,16.97,16.97,0,0,1-2.6-1.974,1.476,1.476,0,0,0-2.241.338,1.192,1.192,0,0,1-1.3.569l-.249-.142L321.73,333.72A1.512,1.512,0,0,0,322.388,335.463Z",
    transform: "translate(-241.127 112.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M342.47,340.678l2.935,1.69a.854.854,0,0,1-.409-.818c0-.925-.8-1.387-1.779-1.1Z",
    transform: "translate(-224.924 117.504)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M353.5,333.59l.676.374v-.089A.587.587,0,0,0,353.5,333.59Z",
    transform: "translate(-216.336 112.213)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M365,298.2c.2,1.156.907,1.779,1.619,1.37a.765.765,0,0,1,.6-.089l-.2-.107-.338-.2Z",
    transform: "translate(-207.381 84.674)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M340.41,280.26l22.945,13.2a3.343,3.343,0,0,0,.925-1.37,2.544,2.544,0,0,1,.978-1.3l-22.98-13.18a2.668,2.668,0,0,0-.978,1.316A3.558,3.558,0,0,1,340.41,280.26Z",
    transform: "translate(-226.528 68.641)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M318.4,351.882c0,14.229,4.767,24.314,12.255,28.636l5.069,2.9c-7.381-4.375-12.042-14.371-12.042-28.459,0-26.057,15.812-56.33,35.377-67.589,8.431-4.874,16.168-5.336,22.251-2.348l-4.34-2.508c-6.225-3.557-14.318-3.273-23.123,1.779C334.248,295.552,318.4,325.842,318.4,351.882Z",
    transform: "translate(-243.666 70.602)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M321.37,353.646c0,14.14,4.66,24.136,12.042,28.458l1.53.8c-7.364-4.376-10.174-13.215-10.174-27.338,0-26.057,15.848-56.33,35.4-67.589,8.733-5.051,14.87-6.581,21.059-3.13L379,283.638c-6.083-3.041-13.82-2.526-22.251,2.366C337.182,297.316,321.37,327.606,321.37,353.646Z",
    transform: "translate(-241.354 71.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M341.46,277.76,364.44,290.9a1.565,1.565,0,0,1,1.227-.356l2.366.462,3.344.64h.213l-.356-.231-20.881-11.97-.48-.267-.5-.285-.2-.107-.249-.16-.16-.089h-.178a.8.8,0,0,0-.2,0l-5.71-1.1a1.547,1.547,0,0,0-1.227.32Z",
    transform: "translate(-225.711 68.491)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M331.26,284.042,354.24,297.2a3.682,3.682,0,0,1,1.245-1.263l6.6-3.806a1.477,1.477,0,0,1,1.245-.213l-19.565-11.259-2.117-1.209-.747-.427-.409-.231a1.352,1.352,0,0,0-1.316.16l-6.6,3.842a3.789,3.789,0,0,0-1.316,1.245Z",
    transform: "translate(-233.653 69.484)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M321.73,297.636,344.693,310.8a5.337,5.337,0,0,1,1-2.383l5.692-7.666c.64-.854,1.387-1.316,1.779-1.192L331.317,287l-.978-.551c-.48-.285-1.281.142-1.992,1.1l-5.71,7.7A4.731,4.731,0,0,0,321.73,297.636Z",
    transform: "translate(-241.074 75.455)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M315.865,313.5l.16.107.409.249,22.358,12.771a3.024,3.024,0,0,1,0-2.633l3.291-9.5a4.75,4.75,0,0,1,1.3-2.063l-23-13.162a5.122,5.122,0,0,0-1.263,2.063l-3.308,9.5C315.385,312.059,315.42,313.161,315.865,313.5Z",
    transform: "translate(-245.916 85.507)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M314,316.3v8.787c0,.854.231,1.441.6,1.654l2.277,1.316,20.615,11.81a2.081,2.081,0,0,1-.516-1.6v-8.787a4.927,4.927,0,0,1,.462-2.045h0l-23-13.162A4.855,4.855,0,0,0,314,316.3Z",
    transform: "translate(-247.093 97.186)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M315.8,328.779l3.291,5.709a1.546,1.546,0,0,0,.5.516l1.547.889.587.338,4.838,2.793,16.008,9.107a1.246,1.246,0,0,1-.445-.462l-3.29-5.709a3.13,3.13,0,0,1-.267-1.779L315.6,327A2.756,2.756,0,0,0,315.8,328.779Z",
    transform: "translate(-245.9 107.099)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 30.219,
    cy: 17.093,
    rx: 30.219,
    ry: 17.093,
    transform: "matrix(0.392, -0.92, 0.92, 0.392, 97.569, 431.741)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 24.492,
    cy: 13.856,
    rx: 24.492,
    ry: 13.856,
    transform: "matrix(0.392, -0.92, 0.92, 0.392, 102.791, 427.739)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M340.45,327.38c0-8.235,5-17.787,11.188-21.344s11.188.213,11.188,8.449-5.016,17.787-11.188,21.344S340.45,335.615,340.45,327.38Z",
    transform: "translate(-226.497 89.732)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M343.12,321.637c0-4.749,2.881-10.245,6.439-12.308S356,309.471,356,314.2s-2.881,10.245-6.439,12.29S343.12,326.369,343.12,321.637Z",
    transform: "translate(-224.418 92.736)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M346.34,311.413a1.654,1.654,0,0,1,.711-1.334c.373-.231.694,0,.694.516a1.778,1.778,0,0,1-.694,1.352C346.66,312.16,346.34,311.929,346.34,311.413Z",
    transform: "translate(-221.911 93.854)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M344.818,313.859c-.267-.2-.267-.783,0-1.316s.729-.783,1-.569.267.8,0,1.316S345.1,314.143,344.818,313.859Z",
    transform: "translate(-223.252 95.339)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M344.611,316.6c-.391.231-.711,0-.711-.534a1.778,1.778,0,0,1,.711-1.334c.373-.213.694,0,.694.534A1.779,1.779,0,0,1,344.611,316.6Z",
    transform: "translate(-223.811 97.485)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M345.817,317.939c-.267.516-.711.765-1,.569s-.267-.8,0-1.316.729-.783,1-.569S346.083,317.352,345.817,317.939Z",
    transform: "translate(-223.255 98.961)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M347.745,317.122a1.779,1.779,0,0,1-.694,1.334c-.391.213-.711,0-.711-.534a1.654,1.654,0,0,1,.711-1.334C347.514,316.357,347.745,316.606,347.745,317.122Z",
    transform: "translate(-221.911 98.924)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M349.259,314.62c.285.213.285.8,0,1.316s-.711.783-.978.569-.285-.783,0-1.316S348.992,314.425,349.259,314.62Z",
    transform: "translate(-220.561 97.406)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M349.484,311.916c.391-.213.694,0,.694.534a1.636,1.636,0,0,1-.694,1.334c-.391.231-.694,0-.694-.516A1.779,1.779,0,0,1,349.484,311.916Z",
    transform: "translate(-220.003 95.29)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M348.29,310.593c.267-.534.711-.783.978-.569a1.125,1.125,0,0,1,0,1.316c-.285.516-.711.783-.978.569A1.046,1.046,0,0,1,348.29,310.593Z",
    transform: "translate(-220.57 93.821)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M345.28,316.974a6.226,6.226,0,0,1,2.6-4.962c1.423-.836,2.6,0,2.6,1.956a6.278,6.278,0,0,1-2.6,4.98C346.436,319.766,345.28,318.895,345.28,316.974Z",
    transform: "translate(-222.736 95.176)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M400.217,343.127c-1.3-.747-2.348-.124-2.348,1.37v30.362l-61.7-35.715V308.905a5.176,5.176,0,0,0-2.348-4.055Z",
    transform: "translate(-231.66 89.852)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M400.217,343.127c-1.3-.747-2.348-.124-2.348,1.37v30.362l-61.7-35.715V308.905a5.176,5.176,0,0,0-2.348-4.055Z",
    transform: "translate(-231.66 89.852)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M365.439,371.678a4.98,4.98,0,0,0,1.636-3.273c.249-1.779.569-3.468.96-5.194a3.557,3.557,0,0,0-.2-2.561l-.516-.3c-.48-.285-.551-1.423-.107-2.7l3.308-9.516c.48-1.405,1.405-2.455,2.045-2.33s1.636-.889,2.294-2.241c.8-1.636,1.654-3.255,2.561-4.838a4.429,4.429,0,0,0,.676-3.557,3.557,3.557,0,0,1,.854-3.219l5.709-7.684c.711-.96,1.512-1.405,1.992-1.138l.978.569a2.935,2.935,0,0,0,1.583-.925c1.121-1.138,2.277-2.223,3.451-3.237a4.962,4.962,0,0,0,1.779-3.219,3.718,3.718,0,0,1,1.779-2.828l6.581-3.806a1.387,1.387,0,0,1,1.334-.16l3.237,1.868a24.08,24.08,0,0,1,2.419-.462,3.308,3.308,0,0,0,2.33-2.134,2.241,2.241,0,0,1,2.206-1.654l5.71,1.1a1.175,1.175,0,0,1,.374.142l22.962,13.18a1.565,1.565,0,0,1,.6,1.779l7.008,4.038a1.262,1.262,0,0,1,.462.5l3.291,5.709a2.988,2.988,0,0,1-.249,3.059,4.251,4.251,0,0,0-.533,3.415,40.1,40.1,0,0,1,.943,4.127l2.33,1.334c.374.213.6.8.6,1.654v8.769a3.9,3.9,0,0,1-1.281,3.113,4.873,4.873,0,0,0-1.619,3.255c-.249,1.779-.551,3.557-.925,5.336a3.557,3.557,0,0,0,.16,2.543l.5.285c.48.285.534,1.423,0,2.721l-3.291,9.5c-.48,1.423-1.37,2.472-1.974,2.348s-1.6.907-2.259,2.259c-.818,1.779-1.672,3.344-2.579,4.962a4.482,4.482,0,0,0-.729,3.4c.356.6,0,2.028-.889,3.166l-5.674,7.684c-.711.96-1.53,1.423-1.957,1.174l-.872-.5a2.987,2.987,0,0,0-1.619.978c-1.174,1.174-2.348,2.294-3.557,3.344A4.945,4.945,0,0,0,427.5,414.6a3.558,3.558,0,0,1-1.779,2.686l-6.581,3.789a1.441,1.441,0,0,1-1.37.2l-2.935-1.69a23.125,23.125,0,0,1-2.775.551,3.113,3.113,0,0,0-2.294,1.974,2.117,2.117,0,0,1-2.17,1.512l-5.692-1.1a1.034,1.034,0,0,1-.391-.142l-22.962-13.162a1.548,1.548,0,0,1-.6-1.779l-6.937-4.037a1.547,1.547,0,0,1-.5-.516l-3.29-5.709a3.059,3.059,0,0,1,.231-3.113,4.269,4.269,0,0,0,.516-3.379,39.785,39.785,0,0,1-.925-4.162h0l-2.277-1.316a1.868,1.868,0,0,1-.6-1.654v-8.787A3.93,3.93,0,0,1,365.439,371.678Z",
    transform: "translate(-208.051 91.627)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M377.063,390.987V382.2a3.878,3.878,0,0,1,1.3-3.113A5.051,5.051,0,0,0,380,375.815c.249-1.779.569-3.468.943-5.194.32-1.423.089-2.668-.534-2.793s-.747-1.37-.267-2.775l3.291-9.516c.5-1.405,1.405-2.455,2.045-2.33s1.654-.889,2.312-2.241c.8-1.654,1.654-3.273,2.543-4.838a4.447,4.447,0,0,0,.676-3.557,3.664,3.664,0,0,1,.872-3.219l5.71-7.684c.836-1.156,1.779-1.547,2.205-.907s1.405.356,2.348-.587,2.277-2.223,3.451-3.237a4.962,4.962,0,0,0,1.779-3.219,3.717,3.717,0,0,1,1.779-2.828l6.581-3.806c.978-.569,1.779-.213,1.779.783a1.245,1.245,0,0,0,1.779,1.209,23.141,23.141,0,0,1,3.451-.747,3.308,3.308,0,0,0,2.348-2.134,2.241,2.241,0,0,1,2.206-1.654l5.709,1.1c.854.16,1.227,1.174.854,2.241a2.312,2.312,0,0,0,.676,2.686,17.793,17.793,0,0,1,2.561,1.9,1.53,1.53,0,0,0,2.312-.427c.623-.854,1.547-.871,2.028,0l3.308,5.71a3.059,3.059,0,0,1-.267,3.059,4.322,4.322,0,0,0-.551,3.415,35.88,35.88,0,0,1,.96,4.126c.2,1.156.907,1.779,1.636,1.37s1.3.3,1.3,1.619v8.769a3.9,3.9,0,0,1-1.281,3.113,4.873,4.873,0,0,0-1.619,3.255c-.249,1.779-.551,3.557-.925,5.336-.3,1.405-.107,2.65.516,2.775s.711,1.352.213,2.775l-3.29,9.5c-.48,1.423-1.37,2.472-1.974,2.348s-1.6.907-2.259,2.259c-.818,1.779-1.672,3.344-2.579,4.962a4.482,4.482,0,0,0-.729,3.4c.356.6,0,2.028-.889,3.166l-5.781,7.737c-.854,1.138-1.779,1.583-2.152.978s-1.37-.267-2.294.676-2.348,2.294-3.557,3.344a4.945,4.945,0,0,0-1.779,3.095,3.558,3.558,0,0,1-1.779,2.686l-6.581,3.789c-.978.569-1.779.285-1.779-.64s-.783-1.37-1.779-1.085a22.479,22.479,0,0,1-3.557.783,3.112,3.112,0,0,0-2.294,1.974,2.117,2.117,0,0,1-2.17,1.512l-5.692-1.1c-.854-.16-1.263-1.1-.907-2.117a2.205,2.205,0,0,0-.711-2.579,18.191,18.191,0,0,1-2.561-2.063,1.476,1.476,0,0,0-2.241.338,1.1,1.1,0,0,1-1.992,0l-3.29-5.71a3.024,3.024,0,0,1,.231-3.041,4.34,4.34,0,0,0,.516-3.379,39.714,39.714,0,0,1-.943-4.162c-.2-1.156-.889-1.779-1.6-1.387S377.063,392.285,377.063,390.987Z",
    transform: "translate(-197.993 97.396)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M388.44,310.128l19.565,11.259h.107a1.1,1.1,0,0,1,.409.943,1.245,1.245,0,0,0,1.779,1.227c.374-.125.729-.214,1.1-.3a19.151,19.151,0,0,1,2.366-.462,2.739,2.739,0,0,0,1.423-.765l-22.945-13.2a2.669,2.669,0,0,1-1.441.765C390.041,309.773,389.258,309.933,388.44,310.128Z",
    transform: "translate(-189.129 92.951)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M380.77,315l22.98,13.18a4.072,4.072,0,0,0,.694-2.01,3.023,3.023,0,0,1,.516-1.547L381.98,311.46a2.971,2.971,0,0,0-.516,1.547A4.019,4.019,0,0,1,380.77,315Z",
    transform: "translate(-195.102 94.998)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M377.35,318.871l21.842,12.557h.142a.48.48,0,0,1,.231.231.676.676,0,0,0,.783.3,2.793,2.793,0,0,0,1.565-.907c1.121-1.138,2.277-2.223,3.468-3.237a4.978,4.978,0,0,0,1.032-1.227l-22.98-13.18a5.889,5.889,0,0,1-1.049,1.227c-1.174,1.014-2.33,2.081-3.451,3.237a2.934,2.934,0,0,1-1.583,1Z",
    transform: "translate(-197.765 96.517)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M368.44,334.155l23,13.162a.961.961,0,0,1,.747-.267c.64.124,1.654-.889,2.312-2.241.8-1.654,1.654-3.273,2.543-4.856a4.3,4.3,0,0,0,.676-3.557,1.406,1.406,0,0,1-.125-.854L374.63,322.38a1.245,1.245,0,0,0,.124.836,4.517,4.517,0,0,1-.676,3.557c-.907,1.565-1.779,3.184-2.543,4.838-.658,1.352-1.672,2.366-2.312,2.241A1,1,0,0,0,368.44,334.155Z",
    transform: "translate(-204.703 103.501)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M391.438,342.341l-23-13.215a1,1,0,0,1,.783-.285.569.569,0,0,0,.338,0L392.541,342a.641.641,0,0,1-.356,0A.961.961,0,0,0,391.438,342.341Z",
    transform: "translate(-204.703 108.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M372.065,323.3a1.245,1.245,0,0,1-.125-.836L394.9,335.622a1.4,1.4,0,0,0,.125.854,2.01,2.01,0,0,1,.107,1.21l-23.069-13.18A2.133,2.133,0,0,0,372.065,323.3Z",
    transform: "translate(-201.996 103.564)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M364.39,349.287l23,13.162a2.241,2.241,0,0,1,.836-1.049,4.891,4.891,0,0,0,1.619-3.273c.267-1.779.587-3.451.96-5.194a3.255,3.255,0,0,0-.213-2.6h0l-.3-.178-.267-.16L367.663,337.21a3.432,3.432,0,0,1,.2,2.543c-.391,1.779-.694,3.557-.96,5.211a5.051,5.051,0,0,1-1.636,3.273,2.686,2.686,0,0,0-.871,1.05Z",
    transform: "translate(-207.856 115.049)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M365.244,343.95a2.793,2.793,0,0,0,.978-1.21l22.98,13.18a3.022,3.022,0,0,1-.978,1.209,2.241,2.241,0,0,0-.836,1.049l-23-13.2a2.685,2.685,0,0,1,.854-1.032Z",
    transform: "translate(-207.856 119.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M365.73,360.523l22.98,13.18a2.741,2.741,0,0,1,.48-1.174,3.557,3.557,0,0,0,.587-1.6,3.894,3.894,0,0,0,0-1.779,40.8,40.8,0,0,1-.943-4.162h0c-.2-1.156-.872-1.779-1.6-1.387a.676.676,0,0,1-.765,0l-20.615-11.81h0c.267,1.458.587,2.864.943,4.162a4.2,4.2,0,0,1-.587,3.326A2.65,2.65,0,0,0,365.73,360.523Z",
    transform: "translate(-206.813 126.402)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M389.19,369.889a2.741,2.741,0,0,0-.48,1.174l-22.98-13.18a2.649,2.649,0,0,1,.48-1.245,3.556,3.556,0,0,0,.569-1.459l22.98,13.162a3.823,3.823,0,0,1-.569,1.548Z",
    transform: "translate(-206.813 129.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M409.729,319.37a17.36,17.36,0,0,1,2.543,1.921,1.548,1.548,0,0,0,2.312-.445,1.192,1.192,0,0,1,1.494-.534h-.089l-6.866-4.073a.689.689,0,0,1-.089.391,2.294,2.294,0,0,0,.694,2.739Z",
    transform: "translate(-173.245 98.72)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M372.586,365.2h0l.427.249,22.233,12.789h.2a1.619,1.619,0,0,1-.462-1.921,2.205,2.205,0,0,0-.711-2.579,16.969,16.969,0,0,1-2.579-1.885,1.476,1.476,0,0,0-2.241.338,1.192,1.192,0,0,1-1.3.569l-.249-.142-16.008-9.107a1.512,1.512,0,0,0,.694,1.69Z",
    transform: "translate(-202.054 135.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M392.67,370.438l2.917,1.69a.854.854,0,0,1-.409-.818c0-.925-.8-1.387-1.779-1.1Z",
    transform: "translate(-185.836 140.677)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M403.69,363.351l.676.373v-.089a.569.569,0,0,0-.676-.285Z",
    transform: "translate(-177.255 135.384)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M415.15,328c.2,1.156.907,1.779,1.619,1.37a.764.764,0,0,1,.6-.089l-.2-.107-.338-.2Z",
    transform: "translate(-168.332 107.877)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M390.6,310.02l22.945,13.2a3.344,3.344,0,0,0,.925-1.37,2.544,2.544,0,0,1,.978-1.3l-22.98-13.18a2.667,2.667,0,0,0-.978,1.316,3.379,3.379,0,0,1-.889,1.334Z",
    transform: "translate(-187.448 91.814)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M368.59,381.642c0,14.229,4.767,24.314,12.255,28.636l5.069,2.9c-7.381-4.375-12.042-14.372-12.042-28.459,0-26.057,15.83-56.33,35.377-67.589,8.431-4.874,16.168-5.336,22.251-2.348l-4.34-2.508c-6.225-3.557-14.229-3.273-23.123,1.779C384.438,325.312,368.59,355.6,368.59,381.642Z",
    transform: "translate(-204.586 93.775)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M371.56,383.406c0,14.14,4.66,24.136,12.042,28.458l1.53.8c-7.364-4.376-10.174-13.215-10.174-27.338,0-26.057,15.848-56.33,35.4-67.589,8.733-5.051,14.87-6.581,21.059-3.13l-2.223-1.209c-6.083-3.041-13.82-2.526-22.251,2.366C387.39,327.076,371.56,357.348,371.56,383.406Z",
    transform: "translate(-202.273 95.035)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M391.65,307.521l22.98,13.18a1.583,1.583,0,0,1,1.227-.356l2.366.462,3.344.64h.213l-.356-.231-20.881-11.97-.48-.267-.5-.285-.178-.053-.249-.16-.16-.089-.178-.089h-.2l-5.71-1.1a1.547,1.547,0,0,0-1.245.32Z",
    transform: "translate(-186.63 91.663)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M381.45,313.8l22.98,13.162a3.682,3.682,0,0,1,1.245-1.263l6.6-3.806a1.477,1.477,0,0,1,1.245-.213l-19.565-11.259-2.117-1.209-.747-.427-.391-.231a1.387,1.387,0,0,0-1.334.16l-6.581,3.806a3.789,3.789,0,0,0-1.334,1.281Z",
    transform: "translate(-194.572 92.657)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M371.92,327.4l22.962,13.162a5.336,5.336,0,0,1,1-2.383l5.692-7.666c.64-.854,1.387-1.316,1.779-1.192l-21.842-12.557-.978-.551c-.48-.285-1.281.142-1.992,1.1l-5.71,7.7a4.91,4.91,0,0,0-.907,2.383Z",
    transform: "translate(-201.993 98.628)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M366.052,343.229l.16.107.409.231,22.358,12.789a3.024,3.024,0,0,1,0-2.632l3.291-9.5a4.75,4.75,0,0,1,1.3-2.063L370.57,329a5.122,5.122,0,0,0-1.263,2.063l-3.308,9.5C365.59,341.842,365.607,342.945,366.052,343.229Z",
    transform: "translate(-206.832 108.656)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M364.14,346.081v8.787c0,.854.231,1.441.6,1.654l2.277,1.316,20.615,11.81a2.081,2.081,0,0,1-.516-1.6v-8.786a4.928,4.928,0,0,1,.462-2.046h0l-23-13.215a5.141,5.141,0,0,0-.445,2.081Z",
    transform: "translate(-208.051 120.336)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M365.992,358.55l3.291,5.727a1.547,1.547,0,0,0,.5.516l1.565.889.569.338,4.838,2.793,16.008,9.107a1.388,1.388,0,0,1-.445-.462l-3.29-5.71a3.007,3.007,0,0,1-.249-1.868L365.8,356.7a2.685,2.685,0,0,0,.2,1.85Z",
    transform: "translate(-206.825 130.225)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 30.219,
    cy: 17.093,
    rx: 30.219,
    ry: 17.093,
    transform: "matrix(0.392, -0.92, 0.92, 0.392, 186.831, 484.673)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 24.492,
    cy: 13.856,
    rx: 24.492,
    ry: 13.856,
    transform: "matrix(0.392, -0.92, 0.92, 0.392, 192.07, 480.688)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M390.64,357.14c0-8.235,5-17.787,11.188-21.344s11.188.213,11.188,8.449S408,362.031,401.828,365.589,390.64,365.375,390.64,357.14Z",
    transform: "translate(-187.416 112.905)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M393.31,351.4c0-4.749,2.881-10.245,6.439-12.308s6.439.142,6.439,4.874-2.881,10.245-6.439,12.291S393.31,356.129,393.31,351.4Z",
    transform: "translate(-185.337 115.909)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M396.53,341.173a1.655,1.655,0,0,1,.711-1.334c.391-.231.694,0,.694.516a1.778,1.778,0,0,1-.694,1.352C396.85,341.974,396.53,341.689,396.53,341.173Z",
    transform: "translate(-182.83 117.026)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M395.008,343.659c-.267-.2-.267-.783,0-1.316s.729-.783,1-.569.267.8,0,1.316S395.292,343.872,395.008,343.659Z",
    transform: "translate(-184.171 118.543)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M394.8,346.363c-.391.231-.711,0-.711-.534a1.672,1.672,0,0,1,.711-1.334c.373-.214.694,0,.694.533A1.779,1.779,0,0,1,394.8,346.363Z",
    transform: "translate(-184.73 120.658)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M396.007,347.7c-.267.516-.711.765-1,.569s-.267-.8,0-1.316.729-.783,1-.569S396.273,347.165,396.007,347.7Z",
    transform: "translate(-184.174 122.134)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M397.935,346.882a1.654,1.654,0,0,1-.694,1.334c-.391.213-.711,0-.711-.534a1.655,1.655,0,0,1,.711-1.334C397.633,346.117,397.935,346.366,397.935,346.882Z",
    transform: "translate(-182.83 122.097)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M399.449,344.38c.285.213.285.8,0,1.316s-.711.783-.978.569-.285-.783,0-1.316S399.182,344.184,399.449,344.38Z",
    transform: "translate(-181.48 120.578)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M399.674,341.676c.391-.213.694,0,.694.534a1.636,1.636,0,0,1-.694,1.334c-.391.231-.694,0-.694-.534a1.654,1.654,0,0,1,.694-1.334Z",
    transform: "translate(-180.922 118.462)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M398.471,340.353c.267-.534.711-.783.978-.569s.285.783,0,1.316-.711.783-.978.569A1.125,1.125,0,0,1,398.471,340.353Z",
    transform: "translate(-181.48 116.993)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M395.47,346.734a6.226,6.226,0,0,1,2.6-4.963c1.441-.836,2.6,0,2.6,1.957a6.243,6.243,0,0,1-2.6,4.98C396.626,349.544,395.47,348.655,395.47,346.734Z",
    transform: "translate(-183.656 118.349)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M332.855,341.31l3.415-9.907,29.348-84.984,38.49,22.109,50.478,28.992-33.03,95.069Zm-10.245,2.9v29.455l19.939,11.508,66.4,38.33,19.423,11.206c6.6-12.913,15.866-23.941,26.111-29.846,16.008-9.213,29.472-3.308,34.346,12.949l27.925-16.132V262.747l-105.759-61.1L366.365,227.4h-.107l-2.454,1.423a3.684,3.684,0,0,0-.445.267,13.661,13.661,0,0,0-4.287,5.087,19.665,19.665,0,0,0-1.067,2.508L323.446,339.354a15.152,15.152,0,0,0-.836,4.856Zm117.943,43.915L469.3,300.383a8.894,8.894,0,0,1,3.557-4.8l34.7-20.045a2.81,2.81,0,0,1,2.081-.391,5.141,5.141,0,0,1,.285,1.779v72.551A6.991,6.991,0,0,1,507,355.041l-64.53,37.227a2.756,2.756,0,0,1-2.081.409,7.382,7.382,0,0,1,.16-4.553Z",
    transform: "translate(-240.388 9.494)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M410.991,201.64l-44.626,25.773a.161.161,0,0,1-.107,0l-2.454,1.441-.445.267a13.66,13.66,0,0,0-4.287,5.087,14.1,14.1,0,0,0-1.049,2.508L323.446,339.4a14.959,14.959,0,0,0-.836,4.767v29.455l19.939,11.508,66.4,38.33,19.423,11.206c6.6-12.913,15.866-23.941,26.093-29.846,16.008-9.213,29.49-3.308,34.364,12.949l27.925-16.132V262.755ZM421.557,392.6l-88.7-51.208,3.433-9.907,29.33-84.984,38.49,22.109,50.478,29.01Zm88.31-43.061a7.008,7.008,0,0,1-2.917,5.567l-64.476,37.174a2.845,2.845,0,0,1-2.081.427,7.434,7.434,0,0,1,.2-4.571l28.743-87.741a8.894,8.894,0,0,1,3.557-4.8l34.7-20.046a2.721,2.721,0,0,1,2.081-.374,4.856,4.856,0,0,1,.285,1.779Z",
    transform: "translate(-240.388 9.486)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M450.1,277.939l-33.03,94.98-88.7-51.208L331.8,311.8l29.33-84.984,38.49,22.109Z",
    transform: "translate(-235.903 29.093)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M344.52,230.731l105.795,61.008a10.671,10.671,0,0,1,2.223-1.779l47.152-27.213-105.759-61.1L349.3,227.4H349.2l-2.455,1.423a3.686,3.686,0,0,0-.445.267,11.47,11.47,0,0,0-1.779,1.636Z",
    transform: "translate(-223.328 9.494)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(82.222 236.668)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M366.81,216l-3.006,1.779a14.585,14.585,0,0,0-5.781,7.879L323.446,328.322a15.243,15.243,0,0,0-.836,4.785V335.9S353.434,243.747,357.1,233,361.972,218.775,366.81,216Z",
    transform: "translate(-322.61 -216)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M381.39,318.049l-35.217-20.063a4.731,4.731,0,0,0-7.684,4.429V321.98a14.781,14.781,0,0,0,6.777,11.721l35.217,20.063a6.652,6.652,0,0,0,3.273,1,4.072,4.072,0,0,0,2.1-.551,5.336,5.336,0,0,0,2.312-4.874V329.771a14.816,14.816,0,0,0-6.777-11.721Zm-40.7,6.492a9.747,9.747,0,0,1-.374-2.508v-.6l45.925,26.253h.089v1.672a6.309,6.309,0,0,1-.107,1.192Zm45.64,11.1L340.41,309.387h-.089V306.47l45.925,26.182h.089Zm-46.014-24.208,45.925,26.253h.089V340.6L340.41,314.35h-.089Zm0,5,45.925,26.253h.089V345.6L340.41,319.348h-.089Zm46.014,13.358v.854L340.41,304.389h-.089v-1.974a7.809,7.809,0,0,1,0-.943l45.64,26.111a9.532,9.532,0,0,1,.374,2.206Zm-44.626-30.664a2.241,2.241,0,0,1,1.192-.3,4.8,4.8,0,0,1,2.366.747l35.217,20.063a12.45,12.45,0,0,1,4.607,5.336l-44.04-25.221a1.993,1.993,0,0,1,.658-.623Zm39.682,53.093-35.217-20.063a12.06,12.06,0,0,1-4.411-4.838l43.7,24.9a1.779,1.779,0,0,1-.516.445A3.557,3.557,0,0,1,381.39,352.217Z",
    transform: "translate(-228.076 83.66)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M380.69,318.409l-35.217-20.063a4.731,4.731,0,0,0-7.684,4.429V322.34a14.745,14.745,0,0,0,6.777,11.721l35.217,20.063a6.6,6.6,0,0,0,3.273,1,4.073,4.073,0,0,0,2.1-.551,5.336,5.336,0,0,0,2.294-4.874V330.131A14.8,14.8,0,0,0,380.69,318.409Zm-40.7,6.474a10.262,10.262,0,0,1-.356-2.49v-.6l45.925,26.253h.089v1.69a5.991,5.991,0,0,1-.107,1.174Zm45.64,11.045L339.71,309.676h0v-2.917l45.925,26.253h.089Zm-46.014-24.208,45.925,26.253h.089v2.917L339.71,314.639h0Zm0,5,45.925,26.324h.089v2.917L339.71,319.69h0Zm46.014,13.34v.872L339.71,304.678h0v-1.939a7.821,7.821,0,0,1,0-.943l45.64,26.093a9.793,9.793,0,0,1,.285,2.241Zm-44.626-30.593a2.4,2.4,0,0,1,1.192-.285,4.945,4.945,0,0,1,2.366.729l35.217,20.01a12.628,12.628,0,0,1,4.607,5.336l-44.057-25.186A2.312,2.312,0,0,1,341.008,299.467ZM380.69,352.6l-35.217-20.063a12.343,12.343,0,0,1-4.429-4.927l43.719,24.99a2.009,2.009,0,0,1-.516.445A3.558,3.558,0,0,1,380.69,352.6Z",
    transform: "translate(-228.621 83.94)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M394.338,322.915v7.453a2.632,2.632,0,0,1-1.174,2.045l-2.063,1.174a2.6,2.6,0,0,1-2.348,0l-15.279-8.893a2.614,2.614,0,0,1-1.174-2.028V315.2c0-.747.534-1.049,1.174-.676l15.279,8.893a2.6,2.6,0,0,0,2.348,0l2.063-1.192C393.8,321.848,394.338,322.15,394.338,322.915Z",
    transform: "translate(-201.697 97.257)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M322.61,285.42l17.875,10.334v10.174L322.61,295.594Z",
    transform: "translate(-240.388 74.722)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M374.968,200.78l105.759,61.061-2.668,1.53L372.3,202.327Z",
    transform: "translate(-201.697 8.817)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M382.07,378.524V407.96c6.6-12.913,15.866-23.941,26.111-29.846,16.008-9.213,29.472-3.308,34.346,12.949l27.925-16.132V236l-47.188,27.249a14.638,14.638,0,0,0-5.8,7.879L382.906,373.793a15.241,15.241,0,0,0-.836,4.731Zm12.184-17.146L423,273.636a8.893,8.893,0,0,1,3.557-4.8l34.7-20.045a2.81,2.81,0,0,1,2.081-.391,5.14,5.14,0,0,1,.285,1.779v72.551a6.99,6.99,0,0,1-2.917,5.567l-64.53,37.227a2.756,2.756,0,0,1-2.081.409,7.382,7.382,0,0,1,.16-4.553Z",
    transform: "translate(-194.089 36.241)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M423.264,263.2a14.567,14.567,0,0,0-5.8,7.862L382.906,373.739a15.243,15.243,0,0,0-.836,4.785V407.96c6.6-12.913,15.866-23.941,26.093-29.846,16.008-9.213,29.49-3.308,34.364,12.949l27.925-16.132V236Zm40.3,59.514a7.008,7.008,0,0,1-2.917,5.567l-64.476,37.245a2.845,2.845,0,0,1-2.081.427,7.434,7.434,0,0,1,.2-4.571l28.743-87.741a8.894,8.894,0,0,1,3.557-4.8l34.7-20.045a2.721,2.721,0,0,1,2.081-.374,4.856,4.856,0,0,1,.285,1.779Z",
    transform: "translate(-194.089 36.241)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M426.27,250.32l-3.006,1.779a14.585,14.585,0,0,0-5.781,7.879L382.906,362.642a15.245,15.245,0,0,0-.836,4.785v2.793s30.824-92.081,34.524-102.824S421.432,253.095,426.27,250.32Z",
    transform: "translate(-194.089 47.391)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M458.422,244.823v72.569a7.008,7.008,0,0,1-2.917,5.567l-64.476,37.156a2.845,2.845,0,0,1-2.081.427,7.434,7.434,0,0,1,.2-4.571l28.743-87.741a8.893,8.893,0,0,1,3.557-4.8l34.7-20.046a2.721,2.721,0,0,1,2.081-.374,4.855,4.855,0,0,1,.2,1.814Z",
    transform: "translate(-188.944 41.647)",
    fill: "#37474f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Barrier--inject-2",
    transform: "translate(384.578 547.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--barrier--inject-2-2",
    "data-name": "freepik--barrier--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M283.4,426.218l-5.727,3.308a2.259,2.259,0,0,1-2.081,0l-1.779-1.049a1.779,1.779,0,0,1-.8-1.779l19.014-90.018A3.166,3.166,0,0,1,293.3,334.9l5.727-3.291a2.259,2.259,0,0,1,2.081,0l1.779,1.049a1.779,1.779,0,0,1,.783,1.779l-19.014,90A3.1,3.1,0,0,1,283.4,426.218Z",
    transform: "translate(-183.235 -317.54)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M281.709,425.181l-5.727,3.308c-.569.338-.925,0-.8-.569L294.195,337.9a3.059,3.059,0,0,1,1.3-1.779l5.727-3.308c.569-.32.925,0,.783.587l-19.014,90a3.1,3.1,0,0,1-1.281,1.779Z",
    transform: "translate(-181.546 -316.503)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M277.12,385.891l1.69-8.04,3.913-2.241,36.125,20.864,1.708,9.978-3.913,2.259Z",
    transform: "translate(-180.017 -283.083)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M316.642,407.73,277.12,384.91l1.69-8.04,36.142,20.864Z",
    transform: "translate(-180.017 -282.102)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M316.113,450.008l-5.727,3.308a2.259,2.259,0,0,1-2.081,0l-1.779-1.049a2.882,2.882,0,0,1-1.245-1.779l-19.1-112.535a1.779,1.779,0,0,1,.836-1.779l5.727-3.308a2.366,2.366,0,0,1,2.081,0l1.779,1.049a2.935,2.935,0,0,1,1.245,1.779l19.1,112.518a1.779,1.779,0,0,1-.836,1.8Z",
    transform: "translate(-172.979 -316.554)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M286.123,337.921l.711,4.269,18.391,108.249a2.988,2.988,0,0,0,1.227,1.779l1.779,1.049a2.259,2.259,0,0,0,2.081,0l5.727-3.308a1.779,1.779,0,0,0,.836-1.779L297.845,336.124v-.391a3.006,3.006,0,0,0-1.245-1.779l-1.779-1.049a2.419,2.419,0,0,0-2.1,0l-5.709,3.308A1.779,1.779,0,0,0,286.123,337.921Z",
    transform: "translate(-173.013 -316.522)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M296.127,334.707l19.1,112.518a1.779,1.779,0,0,1-.836,1.779l-5.727,3.308a.783.783,0,0,1-1.245-.587l-19.1-112.518a1.778,1.778,0,0,1,.836-1.779l5.727-3.362a.783.783,0,0,1,1.245.64Z",
    transform: "translate(-171.312 -315.549)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M283.15,341.043l3.006,1.779a4.571,4.571,0,0,0,2.988.409,3.7,3.7,0,0,0,1.156-.409l9.907-5.709v-.391a3.006,3.006,0,0,0-1.245-1.779l-1.779-1.049a2.419,2.419,0,0,0-2.1,0c.16-.64.587-.871,0-1.192l-1.779-1.049a2.259,2.259,0,0,0-2.081,0l-5.727,3.291a3.166,3.166,0,0,0-1.281,1.779Z",
    transform: "translate(-175.322 -317.509)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M281.2,336.512a1.459,1.459,0,0,1,.854-1.209l11.455-6.617a4.643,4.643,0,0,1,4.162,0l5.6,3.237a1.476,1.476,0,0,1,.854,1.192c0,.445,0,2.17,0,2.615a1.476,1.476,0,0,1-.854,1.192l-11.455,6.617a4.642,4.642,0,0,1-4.162,0l-5.6-3.237a1.476,1.476,0,0,1-.854-1.192C281.186,338.664,281.2,336.939,281.2,336.512Z",
    transform: "translate(-176.844 -320.004)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M281.2,335.346a1.459,1.459,0,0,1,.854-1.209l7.684-4.447v13.18a4.447,4.447,0,0,1-2.081-.5l-5.6-3.237a1.476,1.476,0,0,1-.854-1.192C281.186,337.5,281.2,335.773,281.2,335.346Z",
    transform: "translate(-176.844 -318.838)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M291.826,340.941l11.455-6.617a1.263,1.263,0,0,0,0-2.4l-5.6-3.237a4.643,4.643,0,0,0-4.162,0L282.061,335.3a1.263,1.263,0,0,0,0,2.4l5.6,3.237A4.642,4.642,0,0,0,291.826,340.941Z",
    transform: "translate(-176.848 -320.004)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-2",
    transform: "translate(108.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M297.161,326.1h0l-3.931-2.206h0a4.162,4.162,0,0,0-4.18.623,13.269,13.269,0,0,0-5.478,10.672,4.251,4.251,0,0,0,1.939,3.771h0l3.877,2.277h0a4.251,4.251,0,0,0,4.2-.64,13.162,13.162,0,0,0,5.46-10.672A4.233,4.233,0,0,0,297.161,326.1Z",
    transform: "translate(-283.567 -323.589)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M289.319,338.438l-3.789-2.241h0a4.251,4.251,0,0,1-1.939-3.771,12.166,12.166,0,0,1,1.156-5.336l3.877,2.277a11.687,11.687,0,0,0-1.156,5.336A4.269,4.269,0,0,0,289.319,338.438Z",
    transform: "translate(-283.552 -320.863)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M291.906,339.606a13.162,13.162,0,0,0,5.46-10.672c-.178-3.806-2.917-5.211-6.136-3.148a13.2,13.2,0,0,0-5.461,10.672C285.948,340.264,288.7,341.67,291.906,339.606Z",
    transform: "translate(-281.852 -322.618)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M288.691,338.8c-1.885.089-2.205-2.028-2.241-2.953a12.113,12.113,0,0,1,4.909-9.551,4.393,4.393,0,0,1,2.028-.747c1.9-.089,2.206,2.028,2.241,2.953a12.006,12.006,0,0,1-4.909,9.551A4.127,4.127,0,0,1,288.691,338.8Z",
    transform: "translate(-281.323 -322.063)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M291.359,326.311a4.517,4.517,0,0,1,1.779-.711,4.783,4.783,0,0,1,.534,2.01,12.077,12.077,0,0,1-4.927,9.551,4.466,4.466,0,0,1-1.779.729,4.606,4.606,0,0,1-.516-2.028A12.113,12.113,0,0,1,291.359,326.311Z",
    transform: "translate(-281.323 -322.023)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M232.92,455.36l-5.727,3.291a2.259,2.259,0,0,1-2.081,0l-1.779-1.049a1.779,1.779,0,0,1-.783-1.779l19.014-90a3.024,3.024,0,0,1,1.281-1.779l5.727-3.308a2.366,2.366,0,0,1,2.081,0l1.779,1.049a1.779,1.779,0,0,1,.8,1.779l-19.014,90.018A3.112,3.112,0,0,1,232.92,455.36Z",
    transform: "translate(-222.527 -294.852)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M231.234,454.332l-5.727,3.291c-.569.338-.925.089-.783-.569l19.014-90.018a3.059,3.059,0,0,1,1.281-1.779l5.727-3.308c.569-.338.925,0,.8.569l-19.014,90.035A3.113,3.113,0,0,1,231.234,454.332Z",
    transform: "translate(-220.84 -293.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M226.6,415.1l1.69-8.04,3.9-2.241,36.142,20.864,1.69,10-3.9,2.241Z",
    transform: "translate(-219.355 -260.338)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M266.122,436.94,226.6,414.12l1.69-8.04,36.142,20.864Z",
    transform: "translate(-219.355 -259.357)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M265.605,479.154l-5.727,3.308a2.33,2.33,0,0,1-2.063,0l-1.779-1.067a2.917,2.917,0,0,1-1.245-1.779L235.688,367.1a1.778,1.778,0,0,1,.836-1.779l5.727-3.308a2.259,2.259,0,0,1,2.081,0l1.779,1.049a2.881,2.881,0,0,1,1.245,1.779l19.138,112.518A1.779,1.779,0,0,1,265.605,479.154Z",
    transform: "translate(-212.293 -293.869)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M235.655,367.114l.729,4.251L254.758,479.6A2.917,2.917,0,0,0,256,481.374l1.779,1.067a2.42,2.42,0,0,0,2.1,0l5.709-3.308a1.921,1.921,0,0,0,.854-1.779L247.394,365.211v-.391a2.881,2.881,0,0,0-1.227-1.779l-1.779-1.049a2.259,2.259,0,0,0-2.081,0l-5.727,3.291A1.885,1.885,0,0,0,235.655,367.114Z",
    transform: "translate(-212.313 -293.885)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M245.649,363.821,264.8,476.339a1.779,1.779,0,0,1-.836,1.779l-5.727,3.308a.765.765,0,0,1-1.227-.587L237.858,368.286a1.779,1.779,0,0,1,.836-1.779l5.71-3.291a.783.783,0,0,1,1.245.6Z",
    transform: "translate(-210.603 -292.851)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M232.69,370.23l2.988,1.779a4.5,4.5,0,0,0,3.006.409,3.556,3.556,0,0,0,1.156-.409l9.889-5.709v-.391a2.881,2.881,0,0,0-1.227-1.779l-1.779-1.049a2.259,2.259,0,0,0-2.081,0c.142-.658.569-.871,0-1.209l-1.779-1.049a2.259,2.259,0,0,0-2.081,0l-5.727,3.308a3.006,3.006,0,0,0-1.3,1.779Z",
    transform: "translate(-214.613 -294.796)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M230.73,365.648a1.476,1.476,0,0,1,.872-1.227l11.437-6.6a4.517,4.517,0,0,1,4.162,0l5.6,3.237a1.476,1.476,0,0,1,.872,1.174v2.615a1.458,1.458,0,0,1-.872,1.209l-11.437,6.706a4.518,4.518,0,0,1-4.162,0l-5.6-3.237a1.476,1.476,0,0,1-.872-1.174C230.73,367.818,230.748,366.093,230.73,365.648Z",
    transform: "translate(-216.139 -297.328)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M230.73,364.476a1.476,1.476,0,0,1,.872-1.227l7.684-4.429v13.162a4.2,4.2,0,0,1-2.081-.5l-5.6-3.237a1.476,1.476,0,0,1-.872-1.174C230.73,366.646,230.748,364.921,230.73,364.476Z",
    transform: "translate(-216.139 -296.156)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M241.357,370.069l11.437-6.6c1.156-.676,1.156-1.779,0-2.4l-5.585-3.237a4.518,4.518,0,0,0-4.162,0l-11.437,6.6c-1.156.676-1.156,1.779,0,2.4l5.6,3.237A4.517,4.517,0,0,0,241.357,370.069Z",
    transform: "translate(-216.129 -297.321)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-2-2",
    "data-name": "freepik--clock--inject-2",
    transform: "translate(18.87 51.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M246.671,355.3h0l-3.86-2.259h0a4.251,4.251,0,0,0-4.2.64,13.162,13.162,0,0,0-5.46,10.672,4.233,4.233,0,0,0,1.921,3.789h0l3.86,2.277h0a4.162,4.162,0,0,0,4.18-.623,13.215,13.215,0,0,0,5.478-10.672,4.18,4.18,0,0,0-1.921-3.824Z",
    transform: "translate(-233.128 -352.747)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M238.853,367.56l-3.789-2.223h0a4.18,4.18,0,0,1-1.921-3.771,11.775,11.775,0,0,1,1.156-5.336l3.931,2.259a12.024,12.024,0,0,0-1.156,5.336,4.233,4.233,0,0,0,1.779,3.735Z",
    transform: "translate(-233.136 -350.035)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M241.436,368.752a13.215,13.215,0,0,0,5.478-10.672c-.178-3.806-2.935-5.229-6.136-3.166a13.286,13.286,0,0,0-5.478,10.672C235.5,369.393,238.324,370.816,241.436,368.752Z",
    transform: "translate(-231.451 -351.796)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M238.221,367.94c-1.885.089-2.188-2.028-2.241-2.953a12.077,12.077,0,0,1,4.927-9.551,4.356,4.356,0,0,1,2.028-.765c1.885-.089,2.188,2.045,2.241,2.953a12.113,12.113,0,0,1-4.909,9.551,4.233,4.233,0,0,1-2.045.765Z",
    transform: "translate(-230.921 -351.251)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M240.907,355.419a4.464,4.464,0,0,1,1.779-.729,4.482,4.482,0,0,1,.516,2.01,12.059,12.059,0,0,1-4.909,9.551,4.32,4.32,0,0,1-1.779.729,4.785,4.785,0,0,1-.534-2.01A12.077,12.077,0,0,1,240.907,355.419Z",
    transform: "translate(-230.921 -351.234)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M234.2,404.028,355.163,334.2l-1.974-1.138L232.24,402.89Z",
    transform: "translate(-214.963 -316.214)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M234.2,404.028,355.163,334.2l-1.974-1.138L232.24,402.89Z",
    transform: "translate(-214.963 -316.214)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M233.34,403.53l5.887,34.933,120.949-69.848-5.87-34.915Z",
    transform: "translate(-214.107 -315.716)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M232.24,372.32l5.87,34.933,1.974,1.138L234.2,373.458Z",
    transform: "translate(-214.963 -285.644)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M232.93,376.41l3.237,19.316,1.974,1.138-3.255-19.316Z",
    transform: "translate(-214.426 -282.46)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M232.93,376.41l3.237,19.316,1.974,1.138-3.255-19.316",
    transform: "translate(-214.426 -282.46)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M244.439,369.36,239.227,410.7l-5.887-34.933Z",
    transform: "translate(-214.107 -287.949)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M298.41,375.036l5.229-41.336,5.87,34.915Z",
    transform: "translate(-163.44 -315.716)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M253.316,404.1l5.229-41.336L246.539,369.7l-5.229,41.336Z",
    transform: "translate(-207.901 -293.088)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M264.736,397.506l5.229-41.336-12.006,6.937-5.229,41.336Z",
    transform: "translate(-199.009 -298.22)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M276.156,390.916l5.229-41.336-12.006,6.937-5.229,41.318Z",
    transform: "translate(-190.116 -303.351)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M287.576,384.326l5.229-41.336L280.8,349.909l-5.229,41.336Z",
    transform: "translate(-181.224 -308.482)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M299,377.726l5.229-41.336-12.006,6.937-5.229,41.336Z",
    transform: "translate(-172.332 -313.621)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M245.114,370.187l-1.974-1.138,12.024-6.919,1.957,1.121Z",
    transform: "translate(-206.476 -293.579)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M256.534,363.605l-1.974-1.138,12.024-6.937,1.957,1.138Z",
    transform: "translate(-197.584 -298.718)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M267.954,357.015l-1.974-1.138L278,348.94l1.957,1.138Z",
    transform: "translate(-188.691 -303.849)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M279.374,350.407l-1.974-1.138,12.024-6.919,1.957,1.138Z",
    transform: "translate(-179.799 -308.981)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M290.794,343.817l-1.974-1.138,12.024-6.919,1.957,1.121Z",
    transform: "translate(-170.907 -314.112)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M234.2,376.262l-1.956-1.138,11.1-6.4,1.957,1.138Z",
    transform: "translate(-214.963 -288.447)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M234.03,407.62l3.255,19.316,120.949-69.83L355,337.79Z",
    transform: "translate(-213.569 -312.531)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M239.823,390.042a3.024,3.024,0,0,1-1.263-2.366l-1.334-8.4q-.107-.587.64-1.014l.516-.285c.5-.285.783-.249.836.142l1.316,8.217a1.529,1.529,0,0,0,.48,1.032.711.711,0,0,0,.872,0,1.672,1.672,0,0,0,.711-.925,2.934,2.934,0,0,0,.107-1.37l-1.316-8.217a1.1,1.1,0,0,1,.658-1l.5-.285c.5-.285.783-.249.836.142l1.334,8.4a5.851,5.851,0,0,1-.356,3.308,4.909,4.909,0,0,1-2.1,2.312,2.419,2.419,0,0,1-2.437.3Z",
    transform: "translate(-211.091 -283.25)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M243.239,388.4l-1.779-11.561a1.079,1.079,0,0,1,.658-1l.338-.2a.64.64,0,0,1,.427-.142c.107,0,.213.089.32.249l3.237,4.571a10.067,10.067,0,0,1,.658,1.156h0a11.38,11.38,0,0,1-.338-1.37l-.907-5.763a1.076,1.076,0,0,1,.64-1l.3-.178c.5-.285.783-.249.836.142l1.779,11.561a1.079,1.079,0,0,1-.658,1l-.249.142a.8.8,0,0,1-.427.16c-.125,0-.231-.089-.338-.267l-3.415-4.713a7.776,7.776,0,0,1-.534-.96v.089a10.533,10.533,0,0,1,.285,1.174l.96,5.941a1.079,1.079,0,0,1-.658,1l-.3.178C243.577,388.824,243.292,388.788,243.239,388.4Z",
    transform: "translate(-207.784 -285.126)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M247.72,385.716a.765.765,0,0,1-.2-.48l-1.779-11.206a1.387,1.387,0,0,1,0-.622.693.693,0,0,1,.338-.374l2.437-1.405a2.01,2.01,0,0,1,2.7.142,8.769,8.769,0,0,1,1.53,4.3,12.985,12.985,0,0,1,0,5.211,4.749,4.749,0,0,1-2.206,2.988l-2.437,1.405A.354.354,0,0,1,247.72,385.716Zm2.383-3.771a1.921,1.921,0,0,0,.836-1.458,12.451,12.451,0,0,0-.2-3.237,9.355,9.355,0,0,0-.783-2.881.729.729,0,0,0-1.121-.338l-.836.391,1.263,7.915Z",
    transform: "translate(-204.475 -286.537)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M251.89,383.537a.676.676,0,0,1-.213-.48L249.9,371.851a1.174,1.174,0,0,1,0-.622.658.658,0,0,1,.32-.374l3.789-2.188a.213.213,0,0,1,.3,0,1.458,1.458,0,0,1,.213.64l.089.551a2.7,2.7,0,0,1,0,.747.534.534,0,0,1-.249.374l-2.259,1.3.409,2.632,2.01-1.156a.231.231,0,0,1,.32,0,1.779,1.779,0,0,1,.2.64v.551a2.044,2.044,0,0,1,0,.729.533.533,0,0,1-.249.391l-1.992,1.156.462,2.917,2.259-1.3a.231.231,0,0,1,.32,0,1.778,1.778,0,0,1,.2.64l.089.551a2.7,2.7,0,0,1,0,.747.516.516,0,0,1-.231.374l-3.806,2.188C252.1,383.537,251.979,383.537,251.89,383.537Z",
    transform: "translate(-201.246 -288.537)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M254.967,381.04l-1.779-11.383a1.173,1.173,0,0,1,0-.623.836.836,0,0,1,.356-.391L255.7,367.4a2.134,2.134,0,0,1,2.01-.267c.569.267.96,1.049,1.156,2.33a5.141,5.141,0,0,1-.729,3.753h0a1.049,1.049,0,0,1,.622.427,2.828,2.828,0,0,1,.516.872l1.316,3.042v.2c0,.32-.178.64-.711.943l-.462.267c-.445.249-.729.249-.836,0l-1.227-3.042a.925.925,0,0,0-.356-.409,1.691,1.691,0,0,0-.48.107l-.32.178.658,4.091a1.092,1.092,0,0,1-.676,1.014l-.445.249C255.323,381.467,255.02,381.431,254.967,381.04Zm1.619-8.271a1.014,1.014,0,0,0,.409-.676,2.774,2.774,0,0,0,0-1.281,1.583,1.583,0,0,0-.374-.978.427.427,0,0,0-.569,0l-.676.391.48,3.024Z",
    transform: "translate(-198.684 -289.793)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M259.937,377.348a8.663,8.663,0,0,1-1.6-4.464,12.451,12.451,0,0,1,0-5.336,5.051,5.051,0,0,1,2.383-3.113,3.841,3.841,0,0,1,1.138-.445c.285,0,.462.142.534.551a4.679,4.679,0,0,1,0,1.316c0,.445-.178.658-.356.676a2.117,2.117,0,0,0-.854.285,2.241,2.241,0,0,0-1,1.654,10.245,10.245,0,0,0,.107,3.237,7.381,7.381,0,0,0,.854,2.81.943.943,0,0,0,1.387.3,1.777,1.777,0,0,0,.391-.285,4.369,4.369,0,0,0,.409-.409h.107c.178-.107.338,0,.462.231a3.272,3.272,0,0,1,.32,1.1,1.262,1.262,0,0,1,0,.516,1,1,0,0,1-.249.462,4,4,0,0,1-.551.534,5.327,5.327,0,0,1-.729.5C261.52,378.095,260.631,378.077,259.937,377.348Z",
    transform: "translate(-194.868 -292.131)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M261.462,371.064c-.694-4.3,0-7.115,2.33-8.4a2.081,2.081,0,0,1,2.739.124,8.307,8.307,0,0,1,1.636,4.411,12.771,12.771,0,0,1,0,5.336,4.927,4.927,0,0,1-2.241,3.006Q262.494,377.557,261.462,371.064Zm4.714,1.441a4.164,4.164,0,0,0,.213-1.494,18.39,18.39,0,0,0-.249-2.579,15.126,15.126,0,0,0-.534-2.366,1.778,1.778,0,0,0-.623-1.014.729.729,0,0,0-.8,0,1.78,1.78,0,0,0-.694.8,3.789,3.789,0,0,0-.231,1.512,15.481,15.481,0,0,0,.249,2.543,13.857,13.857,0,0,0,.534,2.4,1.973,1.973,0,0,0,.64,1.014.783.783,0,0,0,.8,0,1.619,1.619,0,0,0,.694-.818Z",
    transform: "translate(-192.409 -293.513)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M267.059,374.635l-1.779-11.561a1.1,1.1,0,0,1,.658-1l.32-.2a.854.854,0,0,1,.427-.142.427.427,0,0,1,.32.267l3.237,4.553c.178.249.391.64.676,1.156h0a13.558,13.558,0,0,1-.32-1.352l-.925-5.763a1.1,1.1,0,0,1,.658-1.014l.3-.178c.5-.285.765-.231.836.142l1.779,11.561a1.1,1.1,0,0,1-.658,1.014l-.249.142a1,1,0,0,1-.427.142.409.409,0,0,1-.338-.249l-3.433-4.731a7.766,7.766,0,0,1-.534-.96v.089a8.155,8.155,0,0,1,.3,1.174l.943,5.941q.107.587-.64,1.014l-.32.178C267.4,375.079,267.13,375.026,267.059,374.635Z",
    transform: "translate(-189.236 -295.838)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M272.109,371.623a1.209,1.209,0,0,1-1.014-.2.96.96,0,0,1-.267-.534,3.56,3.56,0,0,1,0-1.138.842.842,0,0,1,.338-.765.551.551,0,0,1,.356,0h.373a1.423,1.423,0,0,0,.925-.142,1.625,1.625,0,0,0,.8-1.779,1.458,1.458,0,0,0-.285-.729.926.926,0,0,0-.463-.338,3.56,3.56,0,0,0-.729-.178,2.97,2.97,0,0,1-1.672-.818,4.055,4.055,0,0,1-.818-2.081,5.336,5.336,0,0,1,.338-2.97,4.286,4.286,0,0,1,1.779-2.063,2.848,2.848,0,0,1,.943-.338,1.6,1.6,0,0,1,.836,0,.533.533,0,0,1,.32.48,4.34,4.34,0,0,1,0,1.085c0,.409-.142.658-.285.729a.693.693,0,0,1-.391,0,1.957,1.957,0,0,0-.872.214,1.387,1.387,0,0,0-.658.712,1.867,1.867,0,0,0,0,.818,1.245,1.245,0,0,0,.409.871,2.42,2.42,0,0,0,.925.32h.32a2.562,2.562,0,0,1,1.53.818,3.967,3.967,0,0,1,.747,1.957,6.582,6.582,0,0,1,0,2.045,5.212,5.212,0,0,1-.711,1.921,4.2,4.2,0,0,1-1.476,1.423,3.451,3.451,0,0,1-1.3.676Z",
    transform: "translate(-185.891 -297.185)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M275.949,369.41l-1.547-9.747-1.423.818a.231.231,0,0,1-.32,0,1.779,1.779,0,0,1-.2-.622l-.089-.569a2.151,2.151,0,0,1,0-.747.569.569,0,0,1,.249-.374l4.873-2.81a.231.231,0,0,1,.32,0,1.263,1.263,0,0,1,.2.622l.089.569a1.778,1.778,0,0,1,0,.729.533.533,0,0,1-.249.391l-1.441.836,1.547,9.729q.107.587-.64,1.014l-.534.3C276.287,369.836,276.021,369.783,275.949,369.41Z",
    transform: "translate(-183.738 -298.902)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M277.8,367.88,276.018,356.5a1.192,1.192,0,0,1,0-.622.872.872,0,0,1,.374-.391l2.134-1.245a2.17,2.17,0,0,1,2.028-.267c.569.267.943,1.049,1.156,2.33a5.14,5.14,0,0,1-.729,3.753h0a1.156,1.156,0,0,1,.622.427,3.754,3.754,0,0,1,.516.871l1.3,3.042.089.2c0,.32-.2.64-.729.943l-.445.267q-.667.374-.854,0l-1.209-3.041a1.05,1.05,0,0,0-.356-.409.569.569,0,0,0-.5.107l-.3.178.64,4.091a1.109,1.109,0,0,1-.676,1.014l-.427.249C278.081,368.36,277.8,368.254,277.8,367.88Zm1.636-8.271a1.086,1.086,0,0,0,.409-.676,3.379,3.379,0,0,0,0-1.281,1.993,1.993,0,0,0-.374-1,.462.462,0,0,0-.587,0l-.676.391.48,3.024Z",
    transform: "translate(-180.907 -300.04)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M282.215,365.577a3.059,3.059,0,0,1-1.281-2.366l-1.334-8.4a1.1,1.1,0,0,1,.658-1.014l.516-.285c.5-.3.765-.249.836.142l1.3,8.217a1.618,1.618,0,0,0,.5,1.032.693.693,0,0,0,.854,0,1.778,1.778,0,0,0,.729-.925,2.935,2.935,0,0,0,.107-1.37L283.78,352.4a1.079,1.079,0,0,1,.658-1l.5-.3c.5-.285.765-.231.836.16l1.334,8.4a5.869,5.869,0,0,1-.356,3.308,4.98,4.98,0,0,1-2.1,2.312,2.455,2.455,0,0,1-2.437.3Z",
    transform: "translate(-178.086 -302.308)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M285.933,362.328a8.733,8.733,0,0,1-1.619-4.464,12.788,12.788,0,0,1,.089-5.336,5.1,5.1,0,0,1,2.383-3.113,3.662,3.662,0,0,1,1.138-.445c.285,0,.462.142.534.551a4.8,4.8,0,0,1,0,1.334c0,.427-.178.64-.373.658a2.134,2.134,0,0,0-1.779,1.957,10.263,10.263,0,0,0,.107,3.237,7.381,7.381,0,0,0,.854,2.793.907.907,0,0,0,1.37.3,2.717,2.717,0,0,0,.409-.267l.409-.409.107-.089c.107-.089.32,0,.462.231a3.716,3.716,0,0,1,.32,1.121,1.549,1.549,0,0,1,0,.5,1.245,1.245,0,0,1-.249.48c-.142.142-.32.32-.551.516a6.789,6.789,0,0,1-.729.516C287.587,363.093,286.627,363.057,285.933,362.328Z",
    transform: "translate(-174.601 -303.826)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M290.4,361.03,288.9,351.3l-1.423.818a.231.231,0,0,1-.32,0,1.778,1.778,0,0,1-.2-.64l-.089-.551a2.154,2.154,0,0,1,0-.747.534.534,0,0,1,.249-.374l4.8-2.775a.213.213,0,0,1,.32,0,1.779,1.779,0,0,1,.2.64l.089.569a2.046,2.046,0,0,1,0,.729.605.605,0,0,1-.249.391l-1.441.818,1.547,9.747a1.107,1.107,0,0,1-.64,1l-.534.3C290.681,361.456,290.467,361.421,290.4,361.03Z",
    transform: "translate(-172.447 -305.392)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M292.2,359.1,290.42,347.54a1.1,1.1,0,0,1,.658-1.014l.534-.32c.48-.285.765-.213.836.178l1.779,11.561q.107.587-.64,1.014l-.534.32C292.537,359.564,292.27,359.51,292.2,359.1Z",
    transform: "translate(-169.661 -306.113)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M292.8,352.976q-1.032-6.457,2.33-8.413a2.1,2.1,0,0,1,2.739.142A8.235,8.235,0,0,1,299.5,349.1a12.7,12.7,0,0,1,0,5.336,4.838,4.838,0,0,1-2.241,3.024C294.948,358.792,293.472,357.28,292.8,352.976Zm4.713,1.37a4.2,4.2,0,0,0,.213-1.512,18.4,18.4,0,0,0-.249-2.561,17.888,17.888,0,0,0-.534-2.383,2.1,2.1,0,0,0-.623-1.014.783.783,0,0,0-.8,0,1.618,1.618,0,0,0-.694.8,3.754,3.754,0,0,0-.231,1.494,15.326,15.326,0,0,0,.231,2.561,14.605,14.605,0,0,0,.551,2.383,1.779,1.779,0,0,0,.64,1.014.747.747,0,0,0,.8,0A1.672,1.672,0,0,0,297.509,354.346Z",
    transform: "translate(-168 -307.601)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M298.4,356.547l-1.779-11.561a1.075,1.075,0,0,1,.64-1l.338-.2a.854.854,0,0,1,.427-.142q.16,0,.32.267l3.237,4.553a9.053,9.053,0,0,1,.658,1.156h0a10.682,10.682,0,0,1-.32-1.369L301,342.5a1.107,1.107,0,0,1,.64-1l.32-.178c.5-.285.765-.249.836.142l1.779,11.561a1.113,1.113,0,0,1-.64,1.014l-.249.124a.908.908,0,0,1-.445.16c-.124,0-.231-.089-.338-.249l-3.415-4.731a7.774,7.774,0,0,1-.534-.96v.089a11.546,11.546,0,0,1,.3,1.174l.943,5.941a1.119,1.119,0,0,1-.658,1.014l-.3.16C298.737,356.992,298.47,356.9,298.4,356.547Z",
    transform: "translate(-164.833 -309.927)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "translate(263.035 300.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2-2",
    "data-name": "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M229.952,254.055l-49.2,134.164h0a1.779,1.779,0,0,1-.854.925,5.015,5.015,0,0,1-4.5,0,1.779,1.779,0,0,1-.925-1.1,1.315,1.315,0,0,1,0-.373,3.559,3.559,0,0,1,.178-.925l49.429-134.911a3.184,3.184,0,0,1,4.091-1.885,3.148,3.148,0,0,1,1.779,4.109Z",
    transform: "translate(-138.409 -134.183)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M229.952,254.055l-49.2,134.164h0a1.779,1.779,0,0,1-.854.925,5.015,5.015,0,0,1-4.5,0,1.779,1.779,0,0,1-.925-1.1,1.315,1.315,0,0,1,0-.373,3.559,3.559,0,0,1,.178-.925l49.429-134.911a3.184,3.184,0,0,1,4.091-1.885,3.148,3.148,0,0,1,1.779,4.109Z",
    transform: "translate(-138.409 -134.183)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 7.115,
    height: 57.077,
    transform: "translate(23.87 212.893) rotate(-60)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    width: 7.115,
    height: 57.077,
    transform: "translate(23.87 212.893) rotate(-60)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    width: 7.115,
    height: 57.077,
    transform: "translate(59.829 192.149) rotate(-60)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1050",
    "data-name": "Rectangle 1050",
    width: 7.115,
    height: 57.077,
    transform: "translate(59.829 192.149) rotate(-60)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M183.05,254.136l26.36-15.225a6.945,6.945,0,0,1,10.654,4.82l43.773,204.741a4,4,0,0,1,0,.427,1.412,1.412,0,0,1-.907,1.547,5.016,5.016,0,0,1-4.5,0,1.992,1.992,0,0,1-.872-.96v-.2L213.839,244.958c-.089-.445-.267-.711-.409-.765a1.138,1.138,0,0,0-.836.213l-26.377,15.225",
    transform: "translate(-131.722 -143.458)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M183.05,254.136l26.36-15.225a6.945,6.945,0,0,1,10.654,4.82l43.773,204.741a4,4,0,0,1,0,.427,1.412,1.412,0,0,1-.907,1.547,5.016,5.016,0,0,1-4.5,0,1.992,1.992,0,0,1-.872-.96v-.2L213.839,244.958c-.089-.445-.267-.711-.409-.765a1.138,1.138,0,0,0-.836.213l-26.377,15.225",
    transform: "translate(-131.722 -143.458)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M202.911,317.614,186.9,308.33a2.134,2.134,0,0,1-.943-1.654v-.391a2.134,2.134,0,0,1,.943-1.654l38.543-22.251a2.117,2.117,0,0,1,1.9,0l16.008,9.285a2.1,2.1,0,0,1,.96,1.654v.391a2.1,2.1,0,0,1-.96,1.654l-38.526,22.251a2.152,2.152,0,0,1-1.921,0Z",
    transform: "translate(-129.456 -108.951)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M196,311.094v2.259a2.061,2.061,0,0,0,.96-.213L216.223,302l19.263-11.117a2.1,2.1,0,0,0,.96-1.654v-.391a1.921,1.921,0,0,0-.285-.943Z",
    transform: "translate(-121.639 -104.476)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M186.2,295.19a2.1,2.1,0,0,0-.267.943v.391a2.134,2.134,0,0,0,.943,1.654l16.008,9.285a2.115,2.115,0,0,0,.96.213v-2.259Z",
    transform: "translate(-129.48 -98.799)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M203.673,301.959l-26.68-15.4a2.134,2.134,0,0,1-.943-1.672v-.32a2.134,2.134,0,0,1,.943-1.654l38.543-22.251a2.116,2.116,0,0,1,1.9,0l26.68,15.4a2.152,2.152,0,0,1,.96,1.654v.391a2.152,2.152,0,0,1-.96,1.654l-38.526,22.251a2.152,2.152,0,0,1-1.921-.053Z",
    transform: "translate(-137.173 -125.863)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M192.12,292.784v2.277a2.134,2.134,0,0,0,.96-.231l19.263-11.117,19.263-11.134a2.152,2.152,0,0,0,.96-1.654v-.391a1.921,1.921,0,0,0-.285-.943Z",
    transform: "translate(-124.66 -118.733)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M176.307,273.44a2.1,2.1,0,0,0-.267.943v.374a2.134,2.134,0,0,0,.943,1.672l26.68,15.4a2.064,2.064,0,0,0,.96.231v-2.277Z",
    transform: "translate(-137.181 -115.735)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M214.668,372.516,198.66,363.25a2.1,2.1,0,0,1-.96-1.654V361.2a2.1,2.1,0,0,1,.96-1.654L237.186,337.3a2.152,2.152,0,0,1,1.921,0l16.008,9.285a2.152,2.152,0,0,1,.96,1.654v.374a2.152,2.152,0,0,1-.96,1.672l-38.543,22.233a2.01,2.01,0,0,1-1.9,0Z",
    transform: "translate(-120.315 -66.187)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M197.955,350.11a1.921,1.921,0,0,0-.285.943v.391a2.1,2.1,0,0,0,.96,1.654l16.008,9.267a1.867,1.867,0,0,0,.961.231v-2.259Z",
    transform: "translate(-120.338 -56.036)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M207.78,366.014v2.259a1.778,1.778,0,0,0,.943-.231L228,356.925l19.3-11.117a2.152,2.152,0,0,0,.96-1.672v-.374a2.135,2.135,0,0,0-.285-.943Z",
    transform: "translate(-112.466 -61.712)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M210.741,354.216l-16.008-9.285a2.134,2.134,0,0,1-.943-1.654V342.9a2.17,2.17,0,0,1,.943-1.672L233.294,319a2.117,2.117,0,0,1,1.9,0l16.008,9.267a2.1,2.1,0,0,1,.96,1.654v.391a2.1,2.1,0,0,1-.96,1.654l-38.543,22.251a2.152,2.152,0,0,1-1.921,0Z",
    transform: "translate(-123.36 -80.436)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M194.027,331.81a1.991,1.991,0,0,0-.267.943v.373a2.134,2.134,0,0,0,.943,1.654l16.008,9.285a2.134,2.134,0,0,0,.96.231v-2.277Z",
    transform: "translate(-123.383 -70.285)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M203.86,347.735v2.277a2.064,2.064,0,0,0,.96-.231l19.263-11.134,19.263-11.117a2.1,2.1,0,0,0,.96-1.654v-.462a1.921,1.921,0,0,0-.285-.943Z",
    transform: "translate(-115.519 -76)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M206.838,335.906l-16.008-9.267a2.1,2.1,0,0,1-.96-1.654v-.445a2.1,2.1,0,0,1,.96-1.654l38.4-22.2a2.152,2.152,0,0,1,1.921,0l16.008,9.267a2.188,2.188,0,0,1,.96,1.672v.462a2.117,2.117,0,0,1-.96,1.654L208.635,336A2.152,2.152,0,0,1,206.838,335.906Z",
    transform: "translate(-126.412 -94.694)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M190.125,313.5a1.921,1.921,0,0,0-.285.943v.391a2.1,2.1,0,0,0,.96,1.654l8.022,4.625,8.04,4.642a1.868,1.868,0,0,0,.96.231v-2.277Z",
    transform: "translate(-126.435 -84.542)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M200,329.386v2.277a1.921,1.921,0,0,0,.96-.231l19.263-11.117,19.263-11.134a2.117,2.117,0,0,0,.96-1.654v-.373a1.867,1.867,0,0,0-.285-.943Z",
    transform: "translate(-118.524 -90.219)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M228.266,316.969l-1.334-14.229-12.042.711s4.073,15.545,4.749,16.986C221.738,320.758,228.266,316.969,228.266,316.969Z",
    transform: "translate(-106.93 -92.921)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M230.439,316.4a6.885,6.885,0,0,1,0,1.6c-.107,1.779-.231,3.682-.338,5.514a14.791,14.791,0,0,1-.285,2.17,14.228,14.228,0,0,0,0,2.615v2.739a5.159,5.159,0,0,0,0,1.174c.107.391-5.745,3.824-8.111,5.158l-.427.213a3.753,3.753,0,0,1-3.86-.854,6.563,6.563,0,0,1,1.512-7.239s.3,0,.213-2.312a35.913,35.913,0,0,0-.231-4.98c-.16-1.209-.409-2.419-.623-3.557s-.356-2.366-.711-4.038a2.117,2.117,0,0,1,0-1.281,1.779,1.779,0,0,1,.587-.64,12.842,12.842,0,0,1,7.63-2.917,1.387,1.387,0,0,1,.925.231,1.352,1.352,0,0,1,.356.711,7.327,7.327,0,0,0,.587,1.957,5.872,5.872,0,0,0,1.067,1.138,5.869,5.869,0,0,1,1.779,2.312Q230.48,316.257,230.439,316.4Z",
    transform: "translate(-105.35 -87.458)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M229.344,313.938c1.1.409.854,3.415.2,6.314a13.82,13.82,0,0,0-.64,6.3c.391,2.4.6,3.557-.374,4.375a95.918,95.918,0,0,1-8.715,4.625,28.636,28.636,0,0,0,1.636-9.053c.125-5.336.445-8.751,2.881-11.206a4.678,4.678,0,0,1,5.016-1.352Z",
    transform: "translate(-103.099 -84.393)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M214.373,331.375a14.585,14.585,0,0,0,6.528,2.757c3.557.356,3.557-.978,3.966-5.1s.391-9.836,1.974-12.451a6.759,6.759,0,0,1,5.336-3.433c.231-.107,1.3.676,1.654,1.156a5.906,5.906,0,0,0-4.536,1.868c-2.152,2.152-2.49,6.652-2.544,10.672s-.16,8.8-3.415,9.338a11.846,11.846,0,0,1-8.893-2.579,1.654,1.654,0,0,1-.071-2.223Z",
    transform: "translate(-107.64 -84.827)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M220.936,320.894a7.219,7.219,0,0,0-.747,1.121h0a7.88,7.88,0,0,0-.623,5.976c-4.162-.338-5.336-2.579-5.336-2.579a3.984,3.984,0,0,1,2.117-3.557,5.444,5.444,0,0,1,.889-.48h0a6.083,6.083,0,0,1,3.7-.48Z",
    transform: "translate(-107.444 -78.863)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M218.361,320a1.174,1.174,0,0,0-.48.747,2.348,2.348,0,0,0,1.209,2.134c.445.249.818.142.107-.711a2.65,2.65,0,0,1-.658-.978,4.5,4.5,0,0,1-.178-1.192Z",
    transform: "translate(-104.602 -79.481)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M218.25,318.35a1.245,1.245,0,0,0-.32.676,3.557,3.557,0,0,0,1.459,2.241c.765.32.338-.445,0-.836a6.6,6.6,0,0,1-.8-1.245,4.306,4.306,0,0,1-.338-.836Z",
    transform: "translate(-104.563 -80.766)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M218.087,316.57a.836.836,0,0,0-.178.729,3.949,3.949,0,0,0,1.779,1.3c.338,0,.6-.214,0-.6a10.893,10.893,0,0,1-1.121-.783A2.436,2.436,0,0,1,218.087,316.57Z",
    transform: "translate(-104.596 -82.152)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M233.635,353.532a16.968,16.968,0,0,0-11.17,2.953s-1.1-2.988-6.6-22.464c-2.028-7.115-3.362-13.3-4.571-17.911a52.825,52.825,0,0,1-2.117-10.832c-.978-12.344-1.281-48.362-1.779-53,0,0,25.613-7.826,25.63-7.773a47.561,47.561,0,0,1,0,22.18c-2.134,15.047-4.02,31.518-4.713,39.628a46.8,46.8,0,0,1,3.433,12.451C232.408,323.65,233.635,353.532,233.635,353.532Z",
    transform: "translate(-112.762 -138.27)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M191.241,312.751c-.48-.089-.213,1.6-.107,2.241s1.085,2.223,4.518,3.255,6.617.391,8.893.907,5.905,2.917,7.951,3.451a11.419,11.419,0,0,0,7.346-.658c.569-.32,1.779-1.156,1.779-1.779a6.6,6.6,0,0,0,0-1.405Z",
    transform: "translate(-125.56 -85.128)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M220.919,322.49a6.83,6.83,0,0,1-3.4,2.223,10.672,10.672,0,0,1-5.959,0,17.5,17.5,0,0,1-3.557-1.583,20.016,20.016,0,0,0-3.9-1.423,51.689,51.689,0,0,0-6.848-.747,7.311,7.311,0,0,1-4.233-1.6,5.123,5.123,0,0,1-1.3-3.949,2.542,2.542,0,0,1,.124-1.032c.142-.3.374-.356.676-.551.711-.427,1.334-1,2.081-1.37,1.014-.516,5.016-1.779,6.67-1.174l.872.2c.676.142,3.308.427,4,.445a3.131,3.131,0,0,0,1.957-.534c.48-.373.8-.925,1.334-1.192a2.739,2.739,0,0,1,1.885,0,4.98,4.98,0,0,0,3.255,0c1.245-.462,2.348-1.6,3.557-2.1a1.049,1.049,0,0,1,1.192.231,1.9,1.9,0,0,1,.285,1.405,29.628,29.628,0,0,0,.427,4.838C220.332,316.887,221.648,319.306,220.919,322.49Z",
    transform: "translate(-124.983 -88.819)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M199.613,309.91a2.437,2.437,0,0,0-2.028,1.067,4.41,4.41,0,0,0-.569,1.067,2.917,2.917,0,0,0-.178,1.6.285.285,0,0,0,.32.213.338.338,0,0,0,.267-.267,5.994,5.994,0,0,1,.676-2.063,2.668,2.668,0,0,1,.587-.747,2.454,2.454,0,0,1,.854-.445,1.906,1.906,0,0,1,.409,0h.213a.32.32,0,0,0-.178-.285.711.711,0,0,0-.373-.142Z",
    transform: "translate(-121.019 -87.338)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M200.666,310.1a1.654,1.654,0,0,0-1.121.2,2.277,2.277,0,0,0-.747,1.032,4.517,4.517,0,0,0-.462,1.512c0,.267-.125,1.334.391,1.192a.374.374,0,0,0,.267-.249,1.422,1.422,0,0,0,.089-.374,6.227,6.227,0,0,1,.409-1.6c.231-.569.658-1.334,1.352-1.423h.213c0-.124-.107-.2-.213-.231Z",
    transform: "translate(-119.83 -87.209)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M201.456,309.831a1.477,1.477,0,0,0-.747.409,2.829,2.829,0,0,0-.48.8,5.016,5.016,0,0,0-.391,1.672,2.365,2.365,0,0,0,.2,1.263.332.332,0,0,0,.391.249c.16-.053.178-.338.213-.48a7.122,7.122,0,0,0,0-.872,5.175,5.175,0,0,1,1.263-2.881l.089-.124c0-.089-.16-.107-.231-.107Z",
    transform: "translate(-118.664 -87.454)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M201.773,310.154c-.836-.16-2.757.694-4.02,3.113a18.374,18.374,0,0,0-1.423,6.368,6.652,6.652,0,0,1-4.18-2.419,4.536,4.536,0,0,1-1.049-2.152,4.749,4.749,0,0,1,1.476-3.557c1.441-1.245,2.9-2.028,6.6-1.974,3.344,0,3.557.872,3.557.872Z",
    transform: "translate(-125.455 -87.634)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M210.943,303.16s.427,7.577.711,9.623c.178,1.138-.658,2.312-4.038,3.344-2.4.711-4.927,0-4.962-.694L201,308.211Z",
    transform: "translate(-117.746 -92.593)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M244.122,245.45l-41.194,4.269s-8.893,53.929-9.178,59.692c-.142,4.18,12.451,44.733,12.451,44.733s7.826,1.049,11.117-2.81c-.356-5.443-.943-19.245-1.334-24.207a76.482,76.482,0,0,0-3.557-18.96s9.676-27.943,13.429-40.393C244.389,260.658,244.122,245.45,244.122,245.45Z",
    transform: "translate(-123.391 -137.53)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M205.16,210.2l1.708,14.71,15.759-2.294-1.672-15.883Z",
    transform: "translate(-114.506 -167.679)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M217.52,211.4c4.411-.462,8.4.391,10.672,4.642s5.336,19.672,6.457,26.68c1.085,6.581,1.583,7.791-1.974,10.121-2.348,1.53-12.13,6.6-12.13,6.6Z",
    transform: "translate(-104.882 -164.131)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M216.47,211.311c4.8-.551,8.538-.356,10.352,1.3s3.735,3.362,5.034,9.765,3.006,15.528,3.006,15.528-3.557,7.506-16.524,6.457Z",
    transform: "translate(-105.7 -164.328)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M216.47,211.311c4.8-.551,8.538-.356,10.352,1.3s3.735,3.362,5.034,9.765,3.006,15.528,3.006,15.528-3.557,7.506-16.524,6.457Z",
    transform: "translate(-105.7 -164.328)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M241.251,218.606a10.281,10.281,0,0,0-10.832-7.346s-1.156.107-2.223.285c-.551,2.4-11.01,5.069-15.777,2.9-1.885.5-6.759,1.441-8.324,1.974-4.482,1.476-6.332,5.905-7.115,20.543,0,0,2.793,33.457,2.793,42.83a55.921,55.921,0,0,0,26.573.462c13.375-2.988,15.19-8.146,15.19-8.146l-1.281-15.368S242.887,227.588,241.251,218.606Z",
    transform: "translate(-120.876 -164.188)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M241.251,218.606a10.281,10.281,0,0,0-10.832-7.346s-1.156.107-2.223.285c-.551,2.4-11.01,5.069-15.777,2.9-1.885.5-6.759,1.441-8.324,1.974-4.482,1.476-6.332,5.905-7.115,20.543,0,0,2.793,33.457,2.793,42.83a55.921,55.921,0,0,0,26.573.462c13.375-2.988,15.19-8.146,15.19-8.146l-1.281-15.368S242.887,227.588,241.251,218.606Z",
    transform: "translate(-120.876 -164.188)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M169.78,208.6a3.842,3.842,0,0,1,3.451,3.006c0,1.245-2.615,2.134-2.615,2.134Z",
    transform: "translate(-142.055 -166.223)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Brush--inject-2",
    transform: "translate(12.197 6.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M166.13,204.374l3.219,18.783a1.209,1.209,0,0,0,.889.889,3.913,3.913,0,0,0,3.557-.587,1.3,1.3,0,0,0,.569-1.138l-3.219-18.8Z",
    transform: "translate(-157.094 -176.556)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M171.911,208.358l-4.464,3.7-1.316-7.684,4.945-.854Z",
    transform: "translate(-157.094 -176.556)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M174.124,194.81l.658,3.824,2.988-2.472,1.352,7.862a8.288,8.288,0,0,1-2.6,7.115l-5.336,4.358a2.81,2.81,0,0,1-2.455.747s-3.219-1.156-3.877-1.441a2.7,2.7,0,0,1-1.405-2.17L162.1,204.77Z",
    transform: "translate(-160.232 -183.338)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M169.6,214.874l5.336-4.358a8.289,8.289,0,0,0,2.6-7.115l-1.352-7.862-11.935,9.907,1.352,7.862a2.312,2.312,0,0,0,4,1.565Z",
    transform: "translate(-158.558 -182.769)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M165.064,210.5,177,200.592l-1.957-11.472-11.953,9.907Z",
    transform: "translate(-159.462 -187.768)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M166.653,206.754l-1.974-11.472-3.628-1.352,1.956,11.472Z",
    transform: "translate(-161.05 -184.023)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M164.53,207.4l11.935-9.907.267,1.547-11.917,10Z",
    transform: "translate(-158.34 -181.251)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M166.126,203.652,162.48,202.3l.285,1.636,3.646,1.352Z",
    transform: "translate(-159.937 -177.506)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M161.624,197.434s1.583,2.543,3.789,2.312l-.765-4.464-3.557-1.352Z",
    transform: "translate(-161.019 -184.023)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M161.624,197.434s1.583,2.543,3.789,2.312l-.765-4.464-3.557-1.352Z",
    transform: "translate(-161.019 -184.023)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M163.855,203.492a4.82,4.82,0,0,0,4.429-1.3c1.37-1.441,1.209-5.656,4.233-6.261a4.963,4.963,0,0,1,3.966,1.583l-1.441-8.4-11.953,9.907Z",
    transform: "translate(-159.462 -187.768)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M176.631,189.712l-3.646-1.352-11.935,9.907,3.628,1.352Z",
    transform: "translate(-161.05 -188.36)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M176.631,189.712l-3.646-1.352-11.935,9.907,3.628,1.352Z",
    transform: "translate(-161.05 -188.36)",
    fill: "#fff",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M230.1,218.366c-3.006.64-3.379-.231-11.49,4.7-7.542,4.571-20.65,12.113-25.577,14.923a80.235,80.235,0,0,1-12.9-15.83,6.723,6.723,0,0,1-.676-3.557c.285-3.077-.374-3.344-.48-6.119-.089-2.17.534-3.344,0-3.557a2.437,2.437,0,0,0-2.988,1.458,12.345,12.345,0,0,0-.943,3.362s-4.571,4.073-5.051,0l-.872-5.176a4.358,4.358,0,0,0-4.624,3.557c-.587,2.7-.96,8.609,1.049,12.451.96,1.779,5.034,3.344,7.275,4.82,2.508,1.654,10.121,18,14.8,21.148,2.881,1.9,4.749,1.547,8.466.285,8.342-2.828,28.725-13.02,28.725-13.02S233.338,232.7,230.1,218.366Z",
    transform: "translate(-146.526 -166.26)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M213.941,214c-6.617-.142-10.316,3.344-17.538,7.524l-10.387,5.994s-2.028,10.032,5.656,14.6l17.4-8.111C213.941,230.828,217.374,222.059,213.941,214Z",
    transform: "translate(-129.601 -162.02)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M213.941,214c-6.617-.142-10.316,3.344-17.538,7.524l-10.387,5.994s-2.028,10.032,5.656,14.6l17.4-8.111C213.941,230.828,217.374,222.059,213.941,214Z",
    transform: "translate(-129.601 -162.02)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M200.919,198s-3.557,6.972-3.219,7.506a11.792,11.792,0,0,0,3.042,1.334Z",
    transform: "translate(-120.333 -174.477)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M202.182,204.062a4.126,4.126,0,1,1,4.251-4.126A4.215,4.215,0,0,1,202.182,204.062Zm0-7.346a3.219,3.219,0,1,0,3.308,3.219,3.255,3.255,0,0,0-3.308-3.219Z",
    transform: "translate(-119.941 -176.181)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M209.562,190.682c-7.239,1.476-9.32,4.571-10.014,15.706-.711,11.65.178,14.229,1.779,15.723,1.049,1.049,5.692,1.565,8.484,1.423,10.121-.48,14-3.717,17.947-9.569,4.642-6.9,5.87-16.239.889-20.081C221.622,188.495,212.5,190.024,209.562,190.682Z",
    transform: "translate(-119.069 -180.73)",
    fill: "#ffa8a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M200.43,208.093c1.049,1.049,5.692,1.565,8.484,1.423l-.2-1.636a49.8,49.8,0,0,1-8.289.213Z",
    transform: "translate(-118.189 -166.784)",
    fill: "#f28f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M198.26,197.65l12.86,1.6-.534.889-12.326-1.565Z",
    transform: "translate(-119.879 -174.749)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M200.263,198.284a3.965,3.965,0,0,0,1.085.48,4.215,4.215,0,0,0,5.016,5.034,2.917,2.917,0,0,0,.231,2.455,2.864,2.864,0,0,0,2.045,1.37c-.249,0,0,1.957,0,2.134a1.885,1.885,0,0,0,1.281,1.476s1.138-4.3,4.874-3.771,4.269,5.211,1.9,8.04-4.553,1.779-4.589,1.779c.231.107.3,1.476.374,1.779a20.559,20.559,0,0,0,.96,3.077,6.332,6.332,0,0,0,3.806,3.9c1.334.587,7.559-.124,8.893-1.636,2.206-5.549,5.336-7.613,7.773-12.451a19.565,19.565,0,0,0,2.526-7.381,6.794,6.794,0,0,0-2.792-6.937,3.166,3.166,0,0,0-3.095-5.14,5.1,5.1,0,0,0-2.383-5.176,5.051,5.051,0,0,0-3.7-.5c-.356,0-3.095,1.192-3.024,1.654a4.589,4.589,0,0,0-8.893-.3,7.559,7.559,0,0,0-4.553-3.2,5.087,5.087,0,0,0-4.607.978,4.731,4.731,0,0,0-.5,5.211,3.557,3.557,0,0,0-3.308,1.281,4.091,4.091,0,0,0-.961,3.237,3.344,3.344,0,0,0,1.636,2.615Z",
    transform: "translate(-119.623 -184.775)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M205.946,203.134l.142-4.874a2.438,2.438,0,0,0-.142,4.874Z",
    transform: "translate(-115.737 -174.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M209.789,265.732l-49.251,134h0l-.125.3a2.153,2.153,0,0,1-.783.765,5.016,5.016,0,0,1-4.5,0,1.779,1.779,0,0,1-.925-1.1,1.192,1.192,0,0,1,0-.356,3.4,3.4,0,0,1,.178-.943L203.83,263.491a3.174,3.174,0,1,1,5.959,2.188Z",
    transform: "translate(-154.192 -125.102)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M209.789,265.732l-49.251,134h0l-.125.3a2.153,2.153,0,0,1-.783.765,5.016,5.016,0,0,1-4.5,0,1.779,1.779,0,0,1-.925-1.1,1.192,1.192,0,0,1,0-.356,3.4,3.4,0,0,1,.178-.943L203.83,263.491a3.174,3.174,0,1,1,5.959,2.188Z",
    transform: "translate(-154.192 -125.102)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M188.551,252.5a4.963,4.963,0,0,0-2.117,4.749l43.791,204.759a2.259,2.259,0,0,1,0,.5,1.192,1.192,0,0,1,0,.356,1.778,1.778,0,0,1-.907,1.1,4.909,4.909,0,0,1-4.5,0,2.1,2.1,0,0,1-.872-.907h0v-.267L180.227,258.6a11.348,11.348,0,0,1,5.158-11.615",
    transform: "translate(-134.058 -136.331)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M230.225,462.012,186.435,257.253a4.963,4.963,0,0,1,2.117-4.749l-3.166-5.514a11.348,11.348,0,0,0-5.158,11.615l43.7,204.154v.267h0a2.1,2.1,0,0,0,.872.907,4.909,4.909,0,0,0,4.5,0,1.779,1.779,0,0,0,.907-1.1,1.192,1.192,0,0,0,0-.356,2.257,2.257,0,0,0,.018-.462Z",
    transform: "translate(-134.058 -136.331)",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-2",
    transform: "translate(109.39 408.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signal--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M83.33,293.453a1.423,1.423,0,0,1,.854-1.192,4.642,4.642,0,0,1,4.215,0,1.476,1.476,0,0,1,.872,1.192h0V477.811c0,.943-1.334,1.69-2.97,1.69s-2.97-.747-2.97-1.69h0V293.453Z",
    transform: "translate(-55.725 -210.124)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M132.773,275.794,104.759,248.83a4.39,4.39,0,0,0-.48-.374l-4.126-2.348a1.779,1.779,0,0,0-2.579.925L68.137,309.678a3.949,3.949,0,0,0,.783,4.269l28.014,26.947a2.938,2.938,0,0,0,.48.374l4.073,2.348a1.779,1.779,0,0,0,2.579-.925l29.579-62.626A3.931,3.931,0,0,0,132.773,275.794Z",
    transform: "translate(-67.799 -245.86)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M131.814,279.046l-29.579,62.627a1.779,1.779,0,0,1-3.059.569L71.144,315.278a4.02,4.02,0,0,1-.783-4.269l29.6-62.627a1.779,1.779,0,0,1,3.059-.569l28.014,26.964A3.931,3.931,0,0,1,131.814,279.046Z",
    transform: "translate(-66.057 -244.843)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M72.06,310.583v-.249l28.583-60.474,26.449,25.381v.267L98.509,335.982Z",
    transform: "translate(-64.501 -242.746)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M101.213,314.713l-3.877-2.241a2.777,2.777,0,0,1-.48-.356L68.842,285.152a3.753,3.753,0,0,1-1.032-2.312l4.02,2.33a3.913,3.913,0,0,0,1.085,2.33l28.014,26.964Z",
    transform: "translate(-67.81 -217.066)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M88.826,254.391a.818.818,0,0,1,1.316.765,2.881,2.881,0,0,1-1.316,2.277c-.729.427-1.316.089-1.316-.747A2.917,2.917,0,0,1,88.826,254.391Z",
    transform: "translate(-52.47 -239.344)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M87.246,292.891c.729-.427,1.316-.089,1.316.747a2.917,2.917,0,0,1-1.316,2.294.818.818,0,0,1-1.316-.765,2.881,2.881,0,0,1,1.316-2.277Z",
    transform: "translate(-53.701 -209.384)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M94.994,268.606l1.423-2.721,3.9-.854a3.1,3.1,0,0,0-1.619-2.579c-1.459-.622-3.557.569-4.98,2.881a10.316,10.316,0,0,0-1.672,5.8,2.846,2.846,0,0,1-.356,1.458l-1.992,3.789-1.174,2.205,2.632,2.206,1-1.779,1.779-3.557a2.027,2.027,0,0,1,1.209-1.1,6.937,6.937,0,0,0,4.02-3.682l.267-.587-3.913.872Z",
    transform: "translate(-51.684 -233.069)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M90.943,275.18l-1.779,3.344-1.779,3.557a1.939,1.939,0,0,1-1.209,1.1,6.865,6.865,0,0,0-4.02,3.753c-.107.2-.2.391-.285.587l3.913-.872.516,2.259-1.423,2.721L81,292.486a3.042,3.042,0,0,0,1.6,2.579c1.459.622,3.557-.569,4.98-2.881a10.316,10.316,0,0,0,1.672-5.8,2.81,2.81,0,0,1,.356-1.458l2.277-4.34,1.53-2.953Z",
    transform: "translate(-57.54 -223.03)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M100.513,281.037,89.841,272.66a1.067,1.067,0,0,0-1.6.267l-1.245,2.117a1.049,1.049,0,0,0,.178,1.3l10.121,9.836c.391.409.8.142,1.1-.32l1.921-3.557C100.708,281.8,100.744,281.25,100.513,281.037Z",
    transform: "translate(-52.987 -225.188)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M84.7,272.275l6.51,5.425.818-1.387L85.5,270.887l-.391-1.53-3.557-1.868-.711,1.494,2.366,2.935Z",
    transform: "translate(-57.664 -229.018)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paint--inject-2",
    transform: "translate(202.51 576.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--paint--inject-2-2",
    "data-name": "freepik--paint--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M168.245,347.86H122l2.081,32.87h0c0,3.059,1.939,6.136,5.941,8.5,8.022,4.749,21.095,4.891,29.206.32,4.091-2.312,6.136-5.336,6.136-8.449Z",
    transform: "translate(-118.734 -333.882)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M128.834,343.734c-9.089,5.123-9.2,13.589-.213,18.907s23.638,5.46,32.727.356,9.178-13.589.2-18.907S137.923,338.629,128.834,343.734Z",
    transform: "translate(-118.773 -340.001)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M165.326,352.755a5.906,5.906,0,0,1-.32,1.779,11.17,11.17,0,0,1-5.549,5.834,34.275,34.275,0,0,1-30.7-.32,11.294,11.294,0,0,1-5.336-5.852,5.55,5.55,0,0,1-.32-1.939c0-2.81,2.117-5.532,5.87-7.613a30.771,30.771,0,0,1,15.368-3.557,31.09,31.09,0,0,1,15.332,3.806C163.333,347.188,165.361,349.927,165.326,352.755Z",
    transform: "translate(-117.878 -339.168)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M141.829,349.706a30.966,30.966,0,0,0-15.368,3.557l-.231.125h0a34.275,34.275,0,0,0,30.7.32l.231-.125h0a31.482,31.482,0,0,0-15.332-3.878Z",
    transform: "translate(-115.44 -332.455)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M143.343,356.979a14.511,14.511,0,0,1-4.2-1.583,5.958,5.958,0,0,1-2.864-3.113,3.024,3.024,0,0,1-.178-1.049,3.255,3.255,0,0,1,.32-1.334,27.567,27.567,0,0,0-9.943,3.148l-.231.125h0a31.392,31.392,0,0,0,15.3,3.789A15.255,15.255,0,0,0,143.343,356.979Z",
    transform: "translate(-115.425 -332.294)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M140.624,354.886a1.008,1.008,0,0,1,1.619.96,3.557,3.557,0,0,1-1.654,2.81c-.907.516-1.636.089-1.619-.961a3.557,3.557,0,0,1,1.654-2.81Z",
    transform: "translate(-105.521 -328.564)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M123.91,354.783c-1.992,5.1-3.557,12.059.925,15.368l.711.5V372.8c-.587-.356-1.192-.765-1.779-1.192-6.634-4.927-2.561-15.67,0-20.9Z",
    transform: "translate(-120.164 -331.663)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M153.661,356.66c-.249.516-6.617,12.717-17.111,15.172a15.651,15.651,0,0,1-3.557.427,18.231,18.231,0,0,1-9.783-3.059v-2.152a16.008,16.008,0,0,0,12.966,3.041c9.694-2.259,15.883-14.14,16.008-14.229a.889.889,0,0,1,1.209-.374A.872.872,0,0,1,153.661,356.66Z",
    transform: "translate(-117.792 -328.026)",
    fill: "#e0e0e0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMantenimientoSvg);
export default __webpack_public_path__ + "static/media/mantenimientoSVG.32c355b72a2fe0c9295ee77b887e7979.svg";
export { ForwardRef as ReactComponent };